'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

var EasyTips = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_easytips',
		offset: { x: 0, y: 0 },
		position: 'above', // above/top/up, below/bottom/down/under, leftside/left, rightside/right
		content: function content(_el) {
			return _el.getElement('.tooltip') || 'Use option \'content\' to set content to the tooltip';
		},
		parent: null
	},

	initialize: function initialize(elements, options) {
		this.setOptions(options);
		this._elements = elements;

		if (this._elements) {
			this.build();
		}
	},

	build: function build() {
		if (typeOf(this._elements) == 'element') {
			this._elements = [this._elements];
		}

		var opts = this.options;
		var self = this;

		this._container = new Element('.' + opts.cls);
		this._container.inject(document.body, 'bottom');
		this._tt_content = new Element('.w_easytips_content').inject(this._container);
		this._tt_tail = new Element('.w_easytips_tail').inject(this._container);

		this.intip = this.inelement = this.inparent = false;

		if (opts.parent) {
			opts.parent.addEvents({
				'mouseenter': function mouseenter() {
					self.inparent = true;
					if (self._current_el) self._current_el.addClass('_tipped');
				},

				'mouseleave': function mouseleave() {
					(function () {
						if (!self.intip && !self.inelement && !self.inparent) {
							self._container.hide();
							self._current_el = null;
						}
					}).delay(50);

					self.inparent = false;
					if (!self.inelement && !self.intip) {
						self.fireEvent('hide', [self._current_el]);
						if (self._current_el) self._current_el.removeClass('_tipped');
					}
				}
			});
		}

		this._container.addEvents({
			'mouseenter': function mouseenter() {
				self.intip = true;
				if (self._current_el) self._current_el.addClass('_tipped');
			},

			'mouseleave': function mouseleave() {
				(function () {
					if (!self.intip && !self.inelement && !self.inparent) {
						self._container.hide();
						self._current_el = null;
					}
				}).delay(50);

				self.intip = false;
				if (!self.inelement && !self.inparent) {
					self.fireEvent('hide', [self._current_el]);
					if (self._current_el) self._current_el.removeClass('_tipped');
				}
			}
		});

		this._elements.each(function (_el) {
			_el.addEvents({
				'mouseenter': function mouseenter() {
					self._container.show();

					if (self._current_el !== _el) {
						self.set_content(_el);
						self.set_position(_el);
						self.fireEvent('show', [_el]);
					}

					self.inelement = true;

					if (self._current_el) self._current_el.removeClass('_tipped');
					_el.addClass('_tipped');
					self._current_el = _el;
				},

				'mouseleave': function mouseleave() {
					(function () {
						if (!self.intip && !self.inelement && !self.inparent) {
							self._container.hide();
							self._current_el = null;
						}
					}).delay(50);

					self.inelement = false;

					if (!self.intip && !self.inparent) {
						self.fireEvent('hide', [_el]);
						if (self._current_el) self._current_el.removeClass('_tipped');
					}
				}
			});
		});

		document.addEvent('touchend', function (e) {
			if (e.target && self._current_el && e.target !== self._current_el) {
				self._current_el.fireEvent('mouseleave');
			}
		});
	},

	set_position: function set_position(_el) {
		var opts = this.options;
		var self = this;
		var left = _el.getCoordinates().left;
		var top = _el.getCoordinates().top;

		self._container.fade('hide');

		var el_width = _el.getAttribute('data-width') || _el.getSize().x;
		var el_height = _el.getAttribute('data-height') || _el.getSize().y;
		var cont_width = this._container.getSize().x;
		var cont_height = this._container.getSize().y;

		var shift_x;
		var shift_y;

		if (opts.position == 'above' || opts.position == 'top' || opts.position == 'up') {
			this._container.removeClass('_bottom').removeClass('_left').removeClass('_right').addClass('_top');

			shift_x = (el_width - cont_width) / 2;
			shift_y = -cont_height - this._tt_tail.getSize().y;
		} else if (opts.position == 'below' || opts.position == 'bottom' || opts.position == 'down' || opts.position == 'under') {
			this._container.removeClass('_top').removeClass('_left').removeClass('_right').addClass('_bottom');

			shift_x = (el_width - cont_width) / 2;
			shift_y = el_height + this._tt_tail.getSize().y;
		} else if (opts.position == 'rightside' || opts.position == 'right') {
			this._container.removeClass('_top').removeClass('_bottom').removeClass('_left').addClass('_right');

			shift_x = el_width + this._tt_tail.getSize().x;
			shift_y = (el_height - cont_height) / 2;
		} else {
			this._container.removeClass('_top').removeClass('_bottom').removeClass('_right').addClass('_left');

			shift_x = -cont_width - this._tt_tail.getSize().x;
			shift_y = (el_height - cont_height) / 2;
		}

		self._container.setStyles({
			'left': left + shift_x + opts.offset.x,
			'top': top + shift_y + opts.offset.y
		});

		self._container.fade('in');
	},

	set_content: function set_content(_el) {
		var type_of = typeOf(this.options.content);
		var content;

		if (type_of == 'function') {
			content = this.options.content(_el);
		} else {
			content = this.options.content;
		}

		if (typeOf(content) == 'element') {
			this._tt_content.empty();
			var _clone = content.clone();
			_clone.inject(this._tt_content);
			_clone.show();
			//_clone.cloneEvents(content);
			this.cloneEventsDeep(content, _clone);
		} else {
			this._tt_content.set('html', content);
		}
	},
	cloneEventsDeep: function cloneEventsDeep(from, to) {
		var self = this;
		to.cloneEvents(from);
		var fromChildren = from.getChildren();
		if (fromChildren.length > 0) {
			var toChildren = to.getChildren();
			fromChildren.each(function (item, index) {
				self.cloneEventsDeep(item, toChildren[index]);
			});
		}
	}
});
// Native.implement([Element, Window, Document], {

// });
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var HighstockExt = new Class({
	Extends: Highstock,

	options: {
		series_name: '',
		clickable: true,
		colors: ['#78cff6', '#aca000', '#008c99', '#c03e62', '#494a66', '#ff6a00'],
		chart: {
			chart: {
				renderTo: 'chart_container',
				backgroundColor: '#ebebeb',
				marginRight: 20
			},

			rangeSelector: {
				selected: 5,
				inputEnabled: false,
				labelStyle: {
					color: '#666'
				},
				buttons: [{
					type: 'month',
					count: 6,
					text: '6m'
				}, {
					type: 'year',
					count: 1,
					text: '1yr'
				}, {
					type: 'year',
					count: 2,
					text: '2yr'
				}, {
					type: 'year',
					count: 4,
					text: '4yr'
				}, {
					type: 'year',
					count: 6,
					text: '6yr'
				}, {
					type: 'all',
					text: 'All'
				}],
				buttonTheme: {
					fill: 'none',
					stroke: 'none',
					style: {
						color: '#aaa'
					},
					states: {
						hover: {
							fill: 'white'
						},

						select: {
							fill: '#bbb',
							stroke: 'none',
							style: {
								color: '#fff'
							}
						}
					}
				}
			},

			credits: {
				enabled: false
			},

			xAxis: {
				ordinal: false,
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14, //two weeks
				labels: {
					style: {
						color: '#666'
					}
				}
			},

			yAxis: {
				plotLines: [{
					value: 0,
					width: 2,
					color: '666'
				}],

				title: {
					text: null,
					style: {
						color: '#666'
					}
				},

				labels: {
					style: {
						color: '#666'
					},
					y: -5,
					formatter: function formatter() {
						return '$' + this.value;
					}
				},

				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				endOnTick: false,
				showLastLabel: true,
				maxPadding: 0.06,
				opposite: false
			},

			navigator: {
				maskFill: 'rgba(150, 150, 150, 0.5)',
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 150,
					ordinal: false,
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					}
				},

				series: {
					color: '#bbb',
					lineWidth: 0
				}
			},

			plotOptions: {
				series: {
					// lineWidth: 4,
					animation: true,
					cursor: 'pointer'
				},

				line: {
					dataGrouping: {
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					}
				}
			},

			scrollbar: {
				enabled: true,
				barBackgroundColor: '#bbb',
				barBorderColor: '#fff',
				rifleColor: '#fff',
				buttonBackgroundColor: '#bbb',
				buttonArrowColor: '#666',
				buttonBorderColor: '#fff',
				trackBackgroundColor: '#bbb'
			}
		}
	},

	build: function build() {
		var x_label = this._element.getAttribute('data-x-label');
		var y_label = this._element.getAttribute('data-y-label');

		if (x_label && x_label.trim() != '') {
			this.options.chart.xAxis.title.text = this._element.getAttribute('data-x-label');
		}

		if (y_label && y_label.trim() != '') {
			this.options.chart.yAxis.title.text = this._element.getAttribute('data-y-label');
		}

		this._veil = this._element.getNext('.veil');

		var rpc = this.options.rpc || this._element.getAttribute('data-rpc');

		if (rpc && rpc != '') {
			this.rpc_request(rpc, this.post_rpc.bind(this));
		}

		this.series_options = [];

		this.series_options.push({
			name: this.options.series_name,
			color: this.options.colors[0]
		});
	},

	post_rpc: function post_rpc(options) {
		var self = this;
		var data = this.data || this.remote.get_data();

		if (options) {
			this.series_options[0].name = options.name;
			this.series_options[0].data = (options.data || data).data;
			if (this.options.clickable) {
				this.series_options[0].events = {
					click: function () {
						self.fireEvent('seriesClick');

						window.location = data.url;
					}.bind(this)
				};
			}
		} else {
			this.series_options[0].data = data.data;
			if (this.options.clickable) {
				this.series_options[0].events = {
					click: function () {
						self.fireEvent('seriesClick');

						window.location = data.url;
					}.bind(this)
				};
			}
		}

		datepickers.each(function (dp) {
			dp.hide();
		});

		if (this.series_options[0].data.length > 1) {
			if (this.chart) {
				this.chart.destroy();
				datepickers = [];
			}

			this.create_chart();
		} else {
			this._element.getParent().hide();
			this.show_warning(true);
		}

		if (this._veil) {
			this._veil.hide();
		}

		this.fireEvent('postRpc', [data]);
	},

	create_chart: function create_chart() {
		var self = this;
		var series_options = this.series_options.clean();
		var __date_difference = this.date_difference;

		this.move_rangeselector();

		var chart_options = this.options.chart;

		chart_options = Object.merge(chart_options, {
			series: series_options,

			tooltip: {
				useHTML: true,
				formatter: function formatter() {
					var details = '';

					this.points.each(function (e, i) {
						var point = e.point;
						var current = point.series.yData[point.series.yData.length - 1];
						var result = ((current - e.y.round()) / e.y.round() * 100).round(1);
						var sign = current >= Math.floor(e.y) ? '+' : '';
						result = sign + result.toString();

						var current_date = new Date();
						var from_date = new Date(Highcharts.dateFormat('%b %e, %Y', e.x));
						var xy = __date_difference(from_date, current_date);

						details += '<div class="series_name" style="border-bottom-color:' + point.series.color + '">' + point.series.name + '</div><br/>' + '<span>Current Price: <b>$' + Core.add_commas(current) + ' / ft<sup>2</sup></b></span><br/><br/>' + '<span style="color:#000">Price on ' + Highcharts.dateFormat('%b %e, %Y', e.x) + ': <b>$' + Core.add_commas(e.y) + ' / ft<sup>2</sup></b></span><br/>' + '<span>&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<label style="color:' + (sign == '+' ? 'green' : 'red') + '"/>' + result.toString() + '%</label></span>';

						if (self.options.clickable) {
							details += '<br/><br/><span style="color:#000">Click for index details</span><br/><br/>';
						}
					});

					return details;
				}
			},
			yAxis: {
				labels: {
					formatter: function formatter() {
						return '$' + Core.add_commas(this.value);
					}
				}
			}
		});

		this.chart = new Highcharts.StockChart(chart_options, function (chart) {
			setTimeout(function () {
				var _input_group = this._element.getElement('.highcharts-input-group');
				var _inputs = this._element.getElements('input.highcharts-range-selector', '#' + chart.options.chart.renderTo);

				if (_input_group) {
					//this is a workaround. close event from Date Picker widget is triggerred when clicking the input Date
					//need to cancel it.
					_input_group.addEvent('click', function (e) {
						e.stop();
					});
				}

				if (_inputs && _inputs.length > 1) {
					var min_date = new Date().parse(_inputs[0].get('value'));
					var max_date = new Date().parse(_inputs[1].get('value'));
				}

				_inputs.each(function (_el, i) {
					var min = min_date.clone();
					var max = max_date.clone();

					var dp = new Picker.Date(_el, {
						timePicker: true,
						draggable: false,
						minDate: i === 0 ? min : min.increment('day', 15),
						maxDate: i === 1 ? max : max.decrement('day', 15),
						pickOnly: 'days',
						pickerClass: 'datepicker_vista',
						format: "%m/%d/%Y",
						useFadeInOut: true,
						onSelect: function onSelect(dateText, input) {
							input.onchange();
							input.onblur();

							if (i == 0) {
								datepickers[1].options.minDate = dateText.increment('day', 15);
							} else if (i == 1) {
								datepickers[0].options.maxDate = dateText.decrement('day', 15);
							}
						}
					});

					datepickers.push(dp);

					_el.addEvent('focus', function () {
						datepickers.each(function (dp, j) {
							if (i != j) {
								dp.hide();
							}
						});
					});
				});
			}.bind(this), 0);
		}.bind(this));
	},

	move_rangeselector: function move_rangeselector() {
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft,
				    topPosition = this.chart.plotTop - 18,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 410,
					y: topPosition
				});

				leftPosition += this.zoomText.getBBox().width + 410;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition,
						y: topPosition - 14
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	},

	date_difference: function date_difference(d1, d2) {
		var monthDay = [31, -1, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		var fromDate;
		var toDate;
		var year;
		var month;
		var day;

		fromDate = d1;
		toDate = d2;

		var increment = 0;

		if (fromDate.format('%e') > toDate.format('%e')) {
			increment = monthDay[fromDate.format('%m') - 1];
		}

		if (increment == -1) {
			if (fromDate.isLeapYear()) {
				increment = 29;
			} else {
				increment = 28;
			}
		}

		if (increment != 0) {
			increment = 1;
		}

		if (fromDate.get('Month') + increment > toDate.get('Month')) {
			month = toDate.get('Month') + 12 - (fromDate.get('Month') + increment);
			increment = 1;
		} else {
			month = toDate.get('Month') - (fromDate.get('Month') + increment);
			increment = 0;
		}

		year = toDate.get('year') - (fromDate.get('year') + increment);

		return year + '.' + month;
	},

	cancel_request: function cancel_request() {
		if (this.remote) {
			this.remote.cancel();
		}
	},

	rebuild_chart: function rebuild_chart(_el) {
		this.data = _el.data;

		if (_el.data) {
			this.post_rpc({
				name: _el.get('text'),
				data: this.data
			});
		} else if (_el.rpc) {
			this.series_options[0].name = _el.get('text');

			this.rpc_request(_el.rpc, function () {
				this.post_rpc({
					name: _el.get('text'),
					data: _el.data
				});
			}.bind(this));
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var HoodsAreaMap = new Class({
	Extends: SimpleMap,
	Implements: [Options, Events],

	defer_build: function defer_build() {
		this.parent();
		this.get_data();
	},

	get_data: function get_data() {
		var self = this;
		var opts = this.options;

		if (opts.data && opts.data != '') {
			self.data = opts.data;
			self.process_rpc();
		} else if (self._element.getAttribute('data-rpc')) {
			var url = self._element.getAttribute('data-rpc');

			new Remote({
				rpc: url,
				onSuccess: function onSuccess() {
					self.data = this.get_data();
					self.draw_map();
				}
			});
		} else {
			return;
		}
	},

	process_rpc: function process_rpc() {
		var opts = this.options,
		    data = this.data,
		    self = this;

		if (data.data.hood.length > 0 || data.data.building.length > 0) {
			if (data.data.building.length > 0) {
				this.add_marker({
					lat: data.data.building[0].lat,
					lng: data.data.building[0].lng,
					icon: Res_i + '/w/hoods/bld-markers/' + (data.data.building.length > 100 ? '100+' : data.data.building.length) + '.png',
					bubble: {
						content: data.data.building[0].name + '<span class="legend">Click on marker for more info</span>'
					},
					callbacks: {
						onClick: function onClick() {
							opts.open_blimp(data.data.building[0].url_popup);
						}
					}
				});
			}

			if (data.data.hood.length > 0) {
				data.data.hood.each(function (place) {
					self.add_marker({
						lat: place[0].lat,
						lng: place[0].lng,
						icon: Res_i + '/w/hoods/hood-markers/' + (place.length > 100 ? '100+' : place.length) + '.png',
						bubble: {
							content: place[0].name + '<span class="legend">Click on marker for more info</span>'
						},
						callbacks: {
							onClick: function onClick() {
								opts.open_blimp(place[0].url_popup);
							}
						}
					});
				});
			}

			this.fit_markers();

			(function () {
				this.fireEvent('ready');
			}).bind(this).delay(2000);
		} else {
			this.fireEvent('noData');
		}
	}
});
'use strict';

/*
--- 
description: FED Process
authors: 
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var HoodsHeatMap = new Class({
	Extends: HoodsMap,
	Implements: [Options, Events],

	draw_map: function draw_map() {
		this.parent();

		this.add_heatmap_layer();
	},

	add_heatmap_layer: function add_heatmap_layer() {
		var data = this.data;
		var heatmapData = [];

		data.data.each(function (el) {
			var obj = { location: new google.maps.LatLng(el.lat, el.lng), weight: el.weight };
			heatmapData.push(obj);
		});

		var heatmap = this.heatmap = new google.maps.visualization.HeatmapLayer({
			data: heatmapData,
			radius: data.radius ? data.radius : 20
		});

		// this.change_gradient();
		// this.change_opacity();
		heatmap.setMap(this.map);
	},

	change_gradient: function change_gradient() {
		var gradient = ['rgba(228, 139, 225, 0)', //bkg color
		'rgba(228, 139, 225, 1)', //least intensive color
		'rgba(255, 255, 0, 1)', 'rgba(255, 255, 255, 1)' // most intensive color
		];

		this.heatmap.setOptions({
			gradient: this.heatmap.get('gradient') ? null : gradient
		});
	},

	change_opacity: function change_opacity() {
		this.heatmap.setOptions({ opacity: this.heatmap.get('opacity') ? null : 1.0 });
	}
});
'use strict';

var MICP = new Class({
	Implements: [Options, Events],

	options: {
		colors: ['#a4b700', '#9ccdf3']
	},

	initialize: function initialize(_element, options) {
		if (_element) {
			this.setOptions(options);
			this._element = _element;
			this.build();
		}
	},

	build: function build() {
		var self = this;

		this.data = {};
		this.colors = [];

		this._graph_cont = this._element.getElement('.w_graph_stat');

		this._veil = this._element.getElement('.veil');

		this._beds_select = this._element.getElement('.w_styled_select._beds select');
		this._pricetype_select = this._element.getElement('.w_styled_select._price_types select');
		this._region_select = this._element.getElement('.w_styled_select._regions select');
		this._currency_select = this._element.getElement('.w_styled_select._currencies select');

		this.rpc = this._element.getAttribute('data-rpc');
		this.running_rpcs = 0;
		this.types = [2, 3];
		this.pricetype_id = this._pricetype_select.getElement(':selected').get('value');
		this.region_id = this._region_select.getElement(':selected').get('value');
		this.beds_id = this._beds_select.getElement(':selected').get('value');
		this.currency_id = this._currency_select.getElement(':selected').get('value');

		this._yaxis_title1 = new Element('div', { 'class': 'yaxis_title _first', 'html': '<span>Condos (' + (this.pricetype_id == 'avg' ? 'avg' : 'median') + ' price / ft<sup>2</sup>)</span>' }).inject(this._graph_cont, 'after');
		this._yaxis_title2 = new Element('div', { 'class': 'yaxis_title _second', 'html': '<span>Co-ops (' + (this.pricetype_id == 'avg' ? 'avg' : 'median') + ' price / ft<sup>2</sup>)</span>' }).inject(this._yaxis_title1, 'after');

		this._yaxis_title1.setStyle('background-color', this.options.colors[0]);
		this._yaxis_title2.setStyle('background-color', this.options.colors[1]);

		if (Core.is_ie8()) {
			this._yaxis_title1.addClass('ie');
			this._yaxis_title2.addClass('ie');
		}

		this.get_active_currency_symbol();

		this._beds_select.addEvent('change', function () {
			self.beds_id = self._beds_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this._pricetype_select.addEvent('change', function () {
			self.pricetype_id = self._pricetype_select.getElement(':selected').get('value');
			self._yaxis_title1.set('html', '<span>CONDOS (' + (self.pricetype_id == 'avg' ? 'avg' : 'median') + ' price / ft<sup>2</sup>)</span>');
			self._yaxis_title2.set('html', '<span>CO-OPS (' + (self.pricetype_id == 'avg' ? 'avg' : 'median') + ' price / ft<sup>2</sup>)</span>');

			self.fireEvent('filter');
		}.bind(this));

		this._region_select.addEvent('change', function () {
			self.region_id = self._region_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this._currency_select.addEvent('change', function () {
			self.currency_id = self._currency_select.getElement(':selected').get('value');
			self.get_active_currency_symbol();
			self.fireEvent('filter');
		});

		this.addEvent('filter', this.get_data.bind(this));

		this.fireEvent('filter');
	},

	get_active_currency_symbol: function get_active_currency_symbol() {
		var currency = this._currency_select.getElement(':selected').get('text');

		this.currency = currency.substring(0, currency.lastIndexOf(' '));
		this.currency_symbol = currency.substring(currency.lastIndexOf(' '), currency.length);
		this.currency_symbol = this.currency_symbol.trim();
	},

	get_data: function get_data() {
		var self = this;
		var type = '';

		this._veil.show();

		if (!this.data || !this.data[this.currency_id] || !this.data[this.currency_id][this.pricetype_id] || !this.data[this.currency_id][this.pricetype_id][this.region_id] || !this.data[this.currency_id][this.pricetype_id][this.region_id][this.beds_id]) {

			this.types.each(function (item) {

				self.store_data(self.currency_id, self.pricetype_id, self.region_id, self.beds_id);
				type += '&type[]=' + item;
			});
		}

		if (type == '') {
			this.display_chart();
		} else {
			this.running_rpcs++;

			var rpc = this.rpc + '?currency=' + this.currency_id + '&show=' + this.pricetype_id + '&region=' + this.region_id + '&bedrooms=' + this.beds_id + type;

			var currency = this.currency_id,
			    pricetype = this.pricetype_id,
			    region = this.region_id,
			    beds = this.beds_id;

			new Remote({
				rpc: rpc,
				onSuccess: function onSuccess() {
					self.running_rpcs--;
					self.store_data(this.get_data(), currency, pricetype, region, beds);

					self.display_chart();
				}
			});
		}
	},

	store_data: function store_data(data, currency, pricetype, region, beds) {
		var self = this;

		if (!this.data[currency]) this.data[currency] = {};
		if (!this.data[currency][pricetype]) this.data[currency][pricetype] = {};
		if (!this.data[currency][pricetype][region]) this.data[currency][pricetype][region] = {};
		if (!this.data[currency][pricetype][region][beds]) this.data[currency][pricetype][region][beds] = {};

		Object.each(data, function (el, i) {
			self.data[currency][pricetype][region][beds][i] = el;
		});
	},

	display_chart: function display_chart() {
		if (this.running_rpcs > 0) return;

		var self = this;
		var series = [];

		if (this.chart) {
			this.chart.destroy();
		}

		this.types.each(function (item) {
			if (item == 2) {
				series[0] = {
					name: 'CONDOS',
					data: self.data[self.currency_id][self.pricetype_id][self.region_id][self.beds_id][item],
					color: self.options.colors[0],
					yAxis: 0
				};
			} else {
				series[1] = {
					name: 'CO-OPS',
					data: self.data[self.currency_id][self.pricetype_id][self.region_id][self.beds_id][item],
					color: self.options.colors[1],
					yAxis: 1
				};
			}
		});

		this.move_rangeselector();

		var min = null,
		    max = null;
		var second_grid_width = 0;

		series[0].data.each(function (el) {
			if (!min || min > el[1]) {
				min = el[1];
			}

			if (!max || max < el[1]) {
				max = el[1];
			}
		});

		series[1].data.each(function (el) {
			if (!min || min > el[1]) {
				min = el[1];
			}

			if (!max || max < el[1]) {
				max = el[1];
			}
		});

		this.chart = new Highcharts.StockChart({
			chart: {
				renderTo: self._graph_cont,
				type: 'spline',
				backgroundColor: '#ebebeb',
				marginTop: 25
			},

			series: series,

			title: {
				text: null
			},

			subtitle: {
				text: null
			},

			rangeSelector: {
				selected: 5,
				inputEnabled: false,

				labelStyle: {
					color: '#666'
				},

				buttonTheme: {
					fill: 'none',
					stroke: 'none',
					style: {
						color: '#aaa'
					},
					states: {
						hover: {
							fill: 'white'
						},

						select: {
							fill: '#bbb',
							stroke: 'none',
							style: {
								color: '#fff'
							}
						}
					}
				},

				buttons: [{
					type: 'month',
					count: 6,
					text: '6m'
				}, {
					type: 'year',
					count: 1,
					text: '1yr'
				}, {
					type: 'year',
					count: 2,
					text: '2yr'
				}, {
					type: 'year',
					count: 4,
					text: '4yr'
				}, {
					type: 'year',
					count: 6,
					text: '6yr'
				}, {
					type: 'all',
					text: 'All'
				}]
			},

			credits: {
				enabled: false
			},

			xAxis: {
				type: 'datetime',
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14, //two weeks
				labels: {
					style: {
						color: '#666'
					}
				}
			},

			yAxis: [{
				min: min,
				max: max,
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					align: 'left',
					style: {
						color: '#666'
					},
					y: -5,
					x: 0,
					formatter: function formatter() {
						var currency_code = self._currency_select.getElement(':selected').get('value');

						if (currency_code == 'RUB') {
							return Core.add_commas(this.value) + ' ' + self.currency_symbol;
						} else if (currency_code == 'XAU') {
							return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol;
						}

						return self.currency_symbol + Core.add_commas(this.value);
					}
				},

				// endOnTick: false,
				showLastLabel: true,
				gridLineWidth: 1,
				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				opposite: false
			}, {
				min: min,
				max: max,
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					enabled: false

					// style: {
					//	 color: '#eee'
					// },
					// y: -5,
					// formatter: function() {
					//	 var currency_code = self._currency_select.getElement(':selected').get('value');

					//	 if(currency_code == 'RUB'){
					//		 return Core.add_commas(this.value) + ' ' + self.currency_symbol;
					//	 }else if(currency_code == 'XAU'){
					//		 return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol;
					//	 }

					//	 return self.currency_symbol + Core.add_commas(this.value);
					// }
				},

				gridLineWidth: second_grid_width,
				opposite: true

				// endOnTick: false,
				// gridLineDashStyle: 'dash',
				// showLastLabel: true,
				// gridLineColor: '#484848'
			}],

			navigator: {
				maskFill: 'rgba(150, 150, 150, 0.5)',
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 100,
					type: 'datetime',
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					},
					gridLineColor: '#888',
					gridZIndex: 4
				},

				series: {
					color: '#bbb',
					lineWidth: 0
				}
			},

			plotOptions: {
				series: {
					animation: true,
					events: {
						click: function click(e) {
							var type_id = this.name == 'CONDOS' ? 2 : 3;
							var _apartment_prices_option = self._element.getElement('.w_graph_categories .apartment_prices');

							if (!_apartment_prices_option) return;

							_apartment_prices_option.fireEvent('click');

							self.fireEvent('show_in_apartment_prices', [self.region_id, type_id, self.beds_id, self.pricetype_id, self.currency_id]);
						}
					}
				},

				// line: {
				//	 lineWidth: 3,

				//	 states: {
				//		 hover: {
				//			 lineWidth: 3
				//		 }
				//	 },

				//	 marker: {
				//		 enabled: false,
				//		 states: {
				//			 hover: {
				//				 enabled: false
				//			 }
				//		 }
				//	 },

				//	 dataGrouping: {
				//		 // groupPixelWidth: 5,
				//		 approximation: 'open',
				//		 // forced: true,
				//		 dateTimeLabelFormats: {
				//			 day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
				//			 week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
				//		 }
				//	 }
				// },

				spline: {
					lineWidth: 3,

					states: {
						hover: {
							lineWidth: 4
						}
					},

					marker: {
						enabled: false
					},

					dataGrouping: {
						groupPixelWidth: 10,
						approximation: 'open',
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					}
				}
			},

			tooltip: {
				useHTML: true,
				valueDecimals: 0,
				shared: true,
				crosshairs: false,
				borderWidth: 2,
				borderColor: '#999',

				formatter: function formatter() {
					return self.get_tooltip(this);
				}
			},

			scrollbar: {
				enabled: true,
				barBackgroundColor: '#bbb',
				barBorderColor: '#fff',
				rifleColor: '#fff',
				buttonBackgroundColor: '#bbb',
				buttonArrowColor: '#666',
				buttonBorderColor: '#fff',
				trackBackgroundColor: '#bbb'
			}
		});

		this._veil.hide();
	},

	get_tooltip: function get_tooltip(obj) {
		var self = this;

		var details, c_price1, h_price1, c_price2, h_price2;
		var current1 = obj.points[0].series.yData[obj.points[0].series.yData.length - 1];
		var current2 = obj.points[1] ? obj.points[1].series.yData[obj.points[1].series.yData.length - 1] : '';

		var result1 = ((current1 - obj.points[0].y.round()) / obj.points[0].y.round() * 100).round(1);

		if (current2 != '') {
			var result2 = ((current2 - obj.points[1].y.round()) / obj.points[1].y.round() * 100).round(1);
		}

		var current_date = new Date();
		var fromDate = new Date(Highcharts.dateFormat('%b %e, %Y', obj.points[0].x));
		var xy = self.date_difference(fromDate, current_date);

		if (this._currency_select.getElement(':selected').get('value') == 'XAU') {
			result1 = ((current1.round(1) - obj.points[0].y.round(1)) / obj.points[0].y.round(1) * 100).round(1);
			c_price1 = Core.add_commas(current1.toFixed(1)) + ' ' + self.currency_symbol;
			h_price1 = Core.add_commas(obj.points[0].y.toFixed(1)) + ' ' + self.currency_symbol;
		} else if (this._currency_select.getElement(':selected').get('value') == 'RUB') {
			c_price1 = Core.add_commas(current1) + ' ' + self.currency_symbol;
			h_price1 = Core.add_commas(obj.points[0].y) + ' ' + self.currency_symbol;
		} else {
			c_price1 = self.currency_symbol + Core.add_commas(current1);
			h_price1 = self.currency_symbol + Core.add_commas(obj.points[0].y.round());
		}

		if (current2 != '') {
			if (this._currency_select.getElement(':selected').get('value') == 'XAU') {
				result2 = ((current2.round(1) - obj.points[1].y.round(1)) / obj.points[1].y.round(1) * 100).round(1);
				c_price2 = Core.add_commas(current2.toFixed(1)) + ' ' + self.currency_symbol;
				h_price2 = Core.add_commas(obj.points[1].y.toFixed(1)) + ' ' + self.currency_symbol;
			} else if (this._currency_select.getElement(':selected').get('value') == 'RUB') {
				c_price2 = Core.add_commas(current2) + ' ' + self.currency_symbol;
				h_price2 = Core.add_commas(obj.points[1].y) + ' ' + self.currency_symbol;
			} else {
				c_price2 = self.currency_symbol + Core.add_commas(current2);
				h_price2 = self.currency_symbol + Core.add_commas(obj.points[1].y.round());
			}
		}

		var sign1 = current1.round(1) >= obj.points[0].y.round(1) ? '+' : '';
		result1 = sign1 + result1.toString();

		if (current2 != '') {
			var sign2 = current2.round(1) >= obj.points[1].y.round(1) ? '+' : '';
			result2 = sign2 + result2.toString();
		}

		details = '<div class="tooltip">' + '<div class="series_name" style="background-color:' + obj.points[0].series.color + '">' + obj.points[0].series.name + '</div>' + '<div style="">Current Price: ' + '<b style="">' + c_price1 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">Price on ' + Highcharts.dateFormat('%b %e, %Y', obj.points[0].x) + ': ' + '<b style="">' + h_price1 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<span style="color:' + (sign1 == '+' ? 'green' : 'red') + '"/>' + result1.toString() + '%</span>' + '</div><br/>';

		if (current2 != '') {

			details += '<div class="series_name" style="background-color:' + obj.points[1].series.color + '">' + obj.points[1].series.name + '</div>' + '<div style="">Current Price: ' + '<b style="">' + c_price2 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">Price on ' + Highcharts.dateFormat('%b %e, %Y', obj.points[1].x) + ': ' + '<b style="">' + h_price2 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<span style="color:' + (sign2 == '+' ? 'green' : 'red') + '"/>' + result2.toString() + '%</span>' + '</div>';
		}

		details += '<br/><span>Click on the line for more detail.</span></div>';

		return details;
	},

	date_difference: function date_difference(d1, d2) {
		var monthDay = [31, -1, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		var fromDate, toDate;
		var year, month, day;

		fromDate = d1;
		toDate = d2;

		var increment = 0;

		if (fromDate.format('%e') > toDate.format('%e')) {
			increment = monthDay[fromDate.format('%m') - 1];
		}

		if (increment == -1) {
			if (fromDate.isLeapYear()) {
				increment = 29;
			} else {
				increment = 28;
			}
		}

		if (increment != 0) {
			increment = 1;
		}

		if (fromDate.get('Month') + increment > toDate.get('Month')) {
			month = toDate.get('Month') + 12 - (fromDate.get('Month') + increment);
			increment = 1;
		} else {
			month = toDate.get('Month') - (fromDate.get('Month') + increment);
			increment = 0;
		}

		year = toDate.get('year') - (fromDate.get('year') + increment);

		return year + '.' + month;
	},

	move_rangeselector: function move_rangeselector() {
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft - 15,
				    topPosition = this.chart.plotTop,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 415,
					y: topPosition - 56
				});

				leftPosition += this.zoomText.getBBox().width + 420;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition,
						y: topPosition - 70
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var MIBC = new Class({
	Implements: [Options, Events],

	options: {
		colors: ['#ff6a00', '#c03e62', '#a7b568', '#00aeef', '#494a66', '#aca000', '#b19f00', '#018f9b', '#b4224a', '#484a67', '#ff5a00', '#a4b700', '#008ad9', '#b901fd', '#484a67', '#fa9a02', '#e20101', '#00c09e', '#139d05', '#010fca', '#672466', '#fe7a7a', '#a87b01'],
		unselected_item_color: '#d0d0d0',
		move_on_mousewheel: true
	},

	initialize: function initialize(_element, options) {
		if (_element) {
			this.setOptions(options);
			this._element = _element;
			this.build();
		}
	},

	build: function build() {
		var self = this;

		this.data = {};
		this.colors = [];

		this._graph_cont = this._element.getElement('.w_graph_stat');
		this._warning = this._element.getElement('.warning');
		this._veil = this._element.getElement('.veil');

		this._beds_select = this._element.getElement('.w_styled_select._beds select');
		this._type_select = this._element.getElement('.w_styled_select._type select');
		this._pricetype_select = this._element.getElement('.w_styled_select._price_types select');
		this._currency_select = this._element.getElement('.w_styled_select._currencies select');

		this._beds_options = this._element.getElements('.w_styled_select._beds .option');
		this._pricetype_options = this._element.getElements('.w_styled_select._price_types .option');
		this._currency_options = this._element.getElements('.w_styled_select._currencies .option');
		this._regions = this._element.getElements('.regions li');

		if (Cookie.read('from_mbc') == 'true') {
			this.fireEvent('apply_previous_filter');
			Cookie.write('from_mbc', false);
		}

		this.rpc = this._element.getAttribute('data-rpc');
		this.running_rpcs = 0;
		this.type_id = this._type_select.getElement(':selected').get('value');
		this.pricetype_id = this._pricetype_select.getElement(':selected').get('value');
		this.curr_id = this._currency_select.getElement(':selected').get('value');
		this.beds_id = this._beds_select.getElement(':selected').get('value');

		self.y_axis_title = self._pricetype_select.getElement(':selected').get('data-text');
		self.x_axis_title = this._element.getElement('.x_axis_title').get('text');

		this.data_changed = true;

		this._beds_select.addEvent('change', function () {
			self.beds_id = self._beds_select.getElement(':selected').get('value');
			self.data_changed = true;
			self.fireEvent('filter');
		});

		this._type_select.addEvent('change', function () {
			self.type_id = self._type_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this._pricetype_select.addEvent('change', function () {
			self.pricetype_id = self._pricetype_select.getElement(':selected').get('value');
			self.y_axis_title = self._pricetype_select.getElement(':selected').get('data-text');
			self.data_changed = true;
			self.fireEvent('filter');
		});

		var currency = this._currency_select.getElement(':selected').get('text');
		this.currency = currency.substring(0, currency.lastIndexOf(' '));
		this.currency_symbol = currency.substring(currency.lastIndexOf(' '), currency.length);

		this._currency_select.addEvent('change', function () {
			self.curr_id = self._currency_select.getElement(':selected').get('value');

			self.data_changed = true;

			var currency = self._currency_select.getElement(':selected').get('text');
			self.currency = currency.substring(0, currency.lastIndexOf(' '));
			self.currency_symbol = currency.substring(currency.lastIndexOf(' '), currency.length);

			self.fireEvent('filter');
		});

		this.addEvent('filter', this.get_data.bind(this));

		var back_button = this._element.getElement('.back_to_regions');

		if (back_button) {
			back_button.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				var url = self._element.getAttribute('data-url') + '?area=region' + '&type=' + self.type_id + '&show=' + self.pricetype_id + '&currency=' + self.curr_id + '&bedrooms=' + self.beds_id;

				window.location = url;
			});
		}

		this._regions = this._element.getElements('.regions li');

		this.regions = {};

		this._regions.each(function (_el, i) {
			_el.index = _el.get('data-id');
			self.regions[_el.index] = _el.get('text').trim();

			var color = self.options.colors[i];
			self.colors.push(color);
			_el.color = color;

			if (_el.hasClass('_selected')) {
				_el.setStyle('background-color', color);
			} else {
				_el.setStyle('background-color', self.options.unselected_item_color);
			}

			_el.setStyle('border-color', color);

			var config;

			try {
				config = JSONMOO.decode(_el.getElement('.hoods').get('html'), false);
			} catch (e) {}

			if (typeOf(config) == 'object') {
				_el.hoods = config;
			}

			_el.addEvents({
				'click': function click() {
					_el.toggleClass('_selected');

					if (_el.getStyle('background-color').toLowerCase() == self.colors[i].toLowerCase()) {
						_el.setStyles({
							'background-color': self.options.unselected_item_color
						});
					} else {
						_el.setStyles({
							'background-color': _el.color
						});
					}

					self.fireEvent('filter');
				}
			});
		});

		this.fireEvent('filter');
	},

	get_data: function get_data() {
		var self = this;
		var region = '';

		this._veil.show();

		this.area = 'region'; //this._element.getElement('.w_graph_legends').getAttribute('data-area');

		if (!this.data || !this.data[this.type_id] || !this.data[this.type_id][this.pricetype_id] || !this.data[this.type_id][this.pricetype_id][this.curr_id] || !this.data[this.type_id][this.pricetype_id][this.curr_id][this.beds_id]) {

			this._regions.each(function (_el) {
				if (_el.hasClass('_selected')) {
					var obj;
					try {
						obj = JSONMOO.decode('{"' + _el.index + '": "waiting"}', false);
					} catch (e) {}

					self.store_data(obj, self.type_id, self.pricetype_id, self.curr_id, self.beds_id);
					region += '&' + self.area + '[]=' + _el.index;
				}
			});
		} else {
			this._regions.each(function (_el) {
				if (_el.hasClass('_selected') && !self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id][_el.index]) {
					self.store_data(JSON.parse('{"' + _el.index + '": "waiting"}'), self.type_id, self.pricetype_id, self.curr_id, self.beds_id);
					region += '&' + self.area + '[]=' + _el.index;
				}
			});
		}

		if (region == '') {
			this.display_chart();
			this.fireEvent('set_cookie');
		} else {
			this.running_rpcs++;

			var rpc = this.rpc + '?area=' + this.area + '&type=' + this.type_id + '&show=' + this.pricetype_id + '&currency=' + this.curr_id + '&bedrooms=' + this.beds_id + region;

			var aptype = this.type_id,
			    pricetype = this.pricetype_id,
			    region = this.curr_id,
			    beds = this.beds_id;

			this.remote = new Remote({
				rpc: rpc,
				onSuccess: function onSuccess() {
					self.running_rpcs--;
					self.store_data(this.get_data(), aptype, pricetype, region, beds);

					self.display_chart();

					self.fireEvent('set_active_regions');
					self.fireEvent('set_cookie');
				}
			});
		}
	},

	store_data: function store_data(data, aptype, pricetype, currency, beds) {
		var self = this;

		if (!this.data[aptype]) this.data[aptype] = {};
		if (!this.data[aptype][pricetype]) this.data[aptype][pricetype] = {};
		if (!this.data[aptype][pricetype][currency]) this.data[aptype][pricetype][currency] = {};
		if (!this.data[aptype][pricetype][currency][beds]) this.data[aptype][pricetype][currency][beds] = {};

		Object.each(data, function (el, i) {
			self.data[aptype][pricetype][currency][beds][i] = el;
		});
	},

	sort_series: function sort_series(array, order) {
		this.array_to_sort = array;
		this.quick_sort(0, this.array_to_sort.length - 1, 'desc');
		return this.array_to_sort;
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.array_to_sort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.array_to_sort[left].price + '' >= center.price + '') {
						left++;
					}

					while (left <= right && this.array_to_sort[right].price + '' < center.price + '') {
						right--;
					}
				} else {
					while (left <= right && this.array_to_sort[left].price >= center.price) {
						left++;
					}

					while (left <= right && this.array_to_sort[right].price < center.price) {
						right--;
					}
				}

				if (left < right) {
					temp = this.array_to_sort[right];
					this.array_to_sort[right] = this.array_to_sort[left];
					this.array_to_sort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.array_to_sort[right];
			this.array_to_sort[right] = this.array_to_sort[first];
			this.array_to_sort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	display_chart: function display_chart() {
		if (this.running_rpcs > 0) return;

		var self = this;
		var series = [];

		var min, max;

		this._regions.each(function (_el, i) {
			if (!self.data[self.type_id]) self.data[self.type_id] = {};
			if (!self.data[self.type_id][self.pricetype_id]) self.data[self.type_id][self.pricetype_id] = {};
			if (!self.data[self.type_id][self.pricetype_id][self.curr_id]) self.data[self.type_id][self.pricetype_id][self.curr_id] = {};
			if (!self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id]) self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id] = {};

			var data = self.data[self.type_id][self.pricetype_id][self.curr_id][self.beds_id][_el.index];

			if (_el.hasClass('_selected') && data && data != 'waiting' && data != []) {
				data.each(function (el) {
					el.color = self.colors[i];
					series.push(el);

					if (!min || min > el.price) {
						min = el.price;
					}

					if (!max || max < el.price) {
						max = el.price;
					}
				});
			}
		});

		this.display_warning(series.length == 0);

		if (series.length == 0) {
			this._veil.hide();
			return;
		}

		self._graph_cont.set('html', '<div class="columns' + (Core.is_ie8() ? ' _old_ie' : '') + '"></div>');

		if (Core.is_ie8()) {
			self._element.addClass('_old_ie');
		}

		series = this.series = this.sort_series(series, 'desc');

		var _columns = self._graph_cont.getElement('.columns');

		var log_min = self.log2(min);
		var log_max = self.log2(max);

		log_min = this.is_integer(log_min) ? log_min - 0.1 : log_min;
		log_max = this.is_integer(log_max) ? log_max + 0.1 : log_max;

		var log_width = Math.ceil(log_max * 10) - Math.floor(log_min * 10) + 10;
		// var log_width = Math.ceil(log_max*10) - Math.floor(log_min*10);
		var max_height = _columns.getSize().x;
		var coef = max_height / log_width;

		while (max_height - coef * (self.log2(series[0].price) - Math.floor(log_min)) * 10 > max_height / 8) {
			log_width--;
			coef = max_height / log_width;
		}

		var real_width;

		(function () {
			series.each(function (el, i) {
				_columns.adopt(new Element('div', { 'class': 'column_name', 'text': el.name }));
				var _column = new Element('div', { 'class': 'column_body', 'data-class': 'w_blimp_bld', 'style': 'background-color: ' + el.color, 'data-rpc': el.url });
				if (i == series.length - 1) {
					_column.setStyle('margin-bottom', 0);
				}

				_column.addEvent('click', function () {
					self._veil.show();
				});

				var blimp = new BlimpExt(_column, {
					draggable: true,
					show_veil: true,
					onPostRpc: function onPostRpc() {
						new BldBlimp(this);

						self.fireEvent('columnClick');
					}
				});

				blimp.addEvent('show', function () {
					self._veil.hide();
					Cookie.write('from_mbc', true);
				});

				blimp.addEvent('hide', function () {
					Cookie.write('from_mbc', false);
				});

				self.set_tooltip(el, _column);
				_columns.adopt(_column);

				var width = 0;

				if (el.price > 0) {
					width = coef * (self.log2(el.price) - Math.floor(log_min)) * 10;
				}

				_column.setStyle('width', width);
			});

			var easytips = this.easytips = new EasyTips(this._graph_cont.getElements('.column_body'), { 'parent': this._graph_cont });

			easytips.addEvent('show', function () {
				var _img = this._container.getElement('img');
				_img.set('src', _img.getAttribute('data-src'));
			});

			this.create_grid(coef, max, log_min);

			this._veil.hide();
			this.data_changed = false;
			this.add_hscroll(_columns, this._graph_cont);
		}).bind(this).delay(50); //delay is needed for big data charts
	},
	set_tooltip: function set_tooltip(el, _column) {
		var self = this;
		var price;
		if (self.curr_id == 'XAU' || self.curr_id == 'RUB') {
			price = Core.add_commas(el.price) + ' ' + self.currency_symbol;
		} else {
			price = self.currency_symbol + Core.add_commas(el.price);
		}

		var _tooltip_content = new Element('.tooltip').inject(_column);
		var _bulb = new Element('div', {
			'class': 'w_columnchart_bulb _buildings clearfix',
			'html': '<img data-src="' + el.image + '" onerror="this.src=\'' + el.missing_img + '\';">' + '<div class="info"></div>'
		}).inject(_tooltip_content);

		var content = _bulb.getElement('.info');

		var _bulb_name = new Element('a.name').inject(content);
		_bulb_name.set('text', el.name || el.address);
		_bulb_name.addEvent('click', function (e) {
			e.stopPropagation();
			window.location = el.building_url;
		});

		var _bulb_address = new Element('a.address').inject(content);
		_bulb_address.set('text', el.address);
		_bulb_address.addEvent('click', function (e) {
			e.stopPropagation();
			window.location = el.building_url;
		});

		var _bulb_price = new Element('span.price').inject(content);
		_bulb_price.set('html', price + ' / ft<sup>2</sup>');

		var _bulb_sales = new Element('span.sales').inject(content);
		_bulb_sales.set('text', ' Based on ' + el.transactions_ppsqft + (el.transactions_ppsqft.toInt() > 1 ? ' sales' : ' sale') + ' in past 12 months');

		if (el.sale && el.sale.available > 0) {
			var _bulb_available_for_sale = new Element('a.apts_for_sale').inject(content);
			var apts = el.sale.available > 1 ? 'Apts' : 'Apt';
			_bulb_available_for_sale.set('html', apts + ' for Sale: ' + el.sale.available);
			_bulb_available_for_sale.addEvent('click', function (e) {
				e.stopPropagation();
				Cookie.write('crBovJumpTo', 'sale');
				window.location = el.building_url;
			});
		}

		if (el.rent && el.rent.available > 0) {
			var _bulb_available_for_rent = new Element('a.apts_for_rent').inject(content);
			var apts = el.rent.available > 1 ? 'Apts' : 'Apt';
			_bulb_available_for_rent.set('html', apts + ' for Rent: ' + el.rent.available);
			_bulb_available_for_rent.addEvent('click', function (e) {
				e.stopPropagation();
				Cookie.write('crBovJumpTo', 'rent');
				window.location = el.building_url;
			});
		}
		_bulb.set('data-class', 'w_blimp_bld');
		_bulb.set('href', el.url);

		new BlimpExt(_bulb, {
			draggable: true,
			show_veil: true,
			onPostRpc: function onPostRpc() {
				new BldBlimp(this);
			}
		});
	},
	create_grid: function create_grid(coef, max, log_min) {
		var self = this;

		var _scale = this._element.getElement('.w_graph_scale').set('html', '<div class="y_axis_title' + (Core.is_ie8() ? ' _old_ie' : '') + '">' + self.y_axis_title + ' in ' + self.currency + (self.curr_id == 'XAU' ? '' : 's') + '</div>');

		if (Core.is_ie8()) {
			this._element.getElement('.x_axis_title').set('html', self.y_axis_title);
			this._element.getElement('.y_axis_title').set('html', self.x_axis_title);
			return;
		}

		var grid_lines_amount = (max / Math.pow(10, String.from(max.round()).length - 1)).round();
		var grid_lines_step = grid_lines_amount * Math.pow(10, String.from(max.round()).length - 1) / grid_lines_amount;

		if (grid_lines_amount == 1) {
			grid_lines_amount = 2;
			grid_lines_step /= 2;
		}

		if (self.curr_id == 'XAU') {
			grid_lines_step = grid_lines_step.round(2);
		} else {
			grid_lines_step = grid_lines_step.round();
		}

		var scale_height = _scale.getSize().y - 10;

		for (var i = grid_lines_amount; i >= 0; i--) {
			var label_text;
			var label_value = i > 0 ? grid_lines_step * i : grid_lines_step / 2;

			if (self.curr_id == 'XAU') {
				label_text = label_value + (self.is_integer(label_value) ? '.0 ' : ' ') + self.currency_symbol.toLowerCase();
			} else if (self.curr_id == 'RUB') {
				label_text = Core.add_commas(label_value) + ' ' + self.currency_symbol.toLowerCase();
			} else {
				label_text = self.currency_symbol + Core.add_commas(label_value);
			}

			var _grid_line = new Element('div', { 'class': 'grid_element', 'html': '<span class="label">' + label_text + '</span>', 'data-value': label_value });
			_grid_line.inject(_scale);

			var bottom = coef * (self.log2(label_value) - Math.floor(log_min)) * 10 - 1;

			if (bottom > 10 && bottom < scale_height) {
				_grid_line.setStyle('bottom', bottom);
			} else {
				_grid_line.dispose();
			}
		}

		if (_scale.getElements('.grid_element').length == 1) {
			var _another_grid_line = _scale.getElement('.grid_element').clone();

			var label_value = _another_grid_line.get('data-value') / 4 * 3;

			if (self.curr_id == 'XAU') {
				label_text = label_value + (self.is_integer(label_value) ? '.0 ' : ' ') + self.currency_symbol.toLowerCase();
			} else if (self.curr_id == 'RUB') {
				label_text = Core.add_commas(label_value) + ' ' + self.currency_symbol.toLowerCase();
			} else {
				label_text = self.currency_symbol + Core.add_commas(label_value);
			}

			_another_grid_line.getElement('.label').set('text', label_text);

			var bottom = coef * (self.log2(label_value) - Math.floor(log_min)) * 10 - 1;

			if (bottom > 10 && bottom < scale_height) {
				_another_grid_line.inject(_scale);
				_another_grid_line.setStyle('bottom', bottom);
			}
		}
	},

	log2: function log2(val) {
		return Math.log(val) / Math.log(2);
	},

	is_integer: function is_integer(num) {
		return num.round() == num || num.round(1) - num.round() == 0;
	},

	add_hscroll: function add_hscroll(_child, _parent) {
		if (Core.is_ie8()) return;

		var _name = _child.getElement('.column_name');
		var _body = _child.getElement('.column_body');

		var element_width = _name.getSize().x + _name.getStyle('margin-top').toInt() + _name.getStyle('margin-bottom').toInt() + _body.getSize().x + _body.getStyle('margin-top').toInt() + _body.getStyle('margin-bottom').toInt();

		var child_width = element_width * this.series.length - _body.getStyle('margin-bottom').toInt();

		if (child_width <= _parent.getSize().x && !_hscroll) {

			if (this._hscroll) {
				this._hscroll.dispose();
			}

			var _hscroll = this._hscroll = new Element('div', { 'class': 'hscroller' });
			_hscroll.inject(this._graph_cont, 'after');

			return;
		}

		var self = this;
		var opts = this.options;

		var animate = new Fx.Scroll(_parent, {
			link: 'cancel',
			duration: 700,
			transition: Fx.Transitions.Quad.easeOut,
			wheelStops: false
		});

		if (this._hscroll) {
			this._hscroll.removeEvents();
			this._hscroll.dispose();
		}

		var _hscroll = this._hscroll = new Element('div', { 'class': 'hscroller', 'html': '<div class="ar_l">&nbsp;</div><div class="dragger">|||</div><div class="ar_r">&nbsp;</div>' });
		_hscroll.inject(this._graph_cont, 'after');

		var indragger = false;

		var init_pos = 0;

		var _dragger = _hscroll.getElement('.dragger'),
		    disp_col = Math.ceil((_parent.getSize().x + _body.getStyle('margin-bottom').toInt()) / element_width),
		    size_coefficient = Math.ceil(this.series.length - disp_col);

		var dragger_left = 0;

		if (size_coefficient > 20) {
			size_coefficient = 20;
		} else if (size_coefficient < 2) {
			size_coefficient = 2;
		}

		var dr_size = _hscroll.getSize().x / size_coefficient;

		_dragger.setStyle('width', dr_size);

		var max_left = _hscroll.getSize().x - dr_size;

		_hscroll.addEvents({
			'click': function click(e) {
				if (!indragger) {
					var to = animate.to ? animate.to[0] : 0;

					if (e.page.x - _hscroll.getCoordinates().left > _dragger.getStyle('left').toInt()) {
						animate.start(to + element_width * (disp_col - 1), 0);
					} else {
						animate.start(to - element_width * (disp_col - 1), 0);
					}

					if (animate.to[0] >= child_width - _parent.getSize().x) {
						_dragger.setStyle('left', max_left);
						return;
					}

					var percent_left = animate.to[0] * 100 / child_width;
					var left = (_hscroll.getSize().x - dr_size) * percent_left / 100;

					if (left < 0) {
						left = 0;
					} else if (left > max_left) {
						left = max_left;
					}

					_dragger.setStyle('left', left);
				}
			},

			'mouseenter': function mouseenter() {
				if (self.dragging != true) _parent.addClass('dragging');
			},
			'mouseleave': function mouseleave() {
				if (self.dragging != true) _parent.removeClass('dragging');
			}
		});

		_dragger.addEvents({
			'mousedown': function mousedown(e) {
				self.dragging = true;
				dragger_left = _dragger.getStyle('left').toInt();
				init_pos = e.page.x;
				return false;
			},

			'mouseenter': function mouseenter() {
				indragger = true;
			},
			'mouseleave': function mouseleave() {
				indragger = false;
			}
		});

		document.addEvents({
			'mousemove': function mousemove(e) {
				if (self.dragging) {
					var hmove = e.page.x - init_pos,
					    left = dragger_left + hmove;

					if (left < 0) {
						left = 0;
					} else if (left > max_left) {
						left = max_left;
					}

					_dragger.setStyle('left', left);

					var hposition = left * ((child_width - 400) / max_left);
					animate.set(hposition, 0);

					if (!animate.to) animate.to = [0, 0];

					animate.to[0] = hposition;
				}
			},

			'mouseleave': function mouseleave() {
				self.dragging = false;
			},

			'mouseup': function mouseup() {
				self.dragging = false;
				// _parent.removeClass('dragging');
			}
		});

		if (opts.move_on_mousewheel) {
			this._graph_cont.addEvent('mousewheel', function (e) {
				if (e && e.stop) e.stop();

				if (e.wheel > 0) {
					var ev = { page: { x: 1, y: 0 } };
					_hscroll.fireEvent('click', [ev]);
				} else if (e.wheel < 0) {
					var ev = { page: { x: _hscroll.getSize().x - 1 + _hscroll.getPosition().x, y: 0 } };
					_hscroll.fireEvent('click', [ev]);
				}

				self.easytips._container.hide();
			});
		}
	},

	display_warning: function display_warning(show) {
		if (show) {
			var msg = 'No data available for ' + this._beds_select.getElement(':selected').get('text') + ' apartments in the selected ' + (this.area == 'region' ? 'regions' : 'neighborhoods');

			this._warning.set('text', msg);
			this._warning.show();
			this._graph_cont.hide();
			this._element.getElement('.w_graph_scale').hide();
			this._element.getElement('.x_axis_title').hide();
			this._element.getElement('.w_graph_disclaimer').hide();
		} else {
			this._warning.hide();
			this._graph_cont.show();
			this._element.getElement('.w_graph_scale').show();
			this._element.getElement('.x_axis_title').show();
			this._element.getElement('.w_graph_disclaimer').show();
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var MICC = new Class({
	Implements: [Options, Events],

	options: {
		colors: ['#a4b700', '#9ccdf3']
	},

	initialize: function initialize(_element, options) {
		if (_element) {
			this.setOptions(options);
			this._element = _element;
			this.build();
		}
	},

	build: function build() {
		var self = this;

		this.data = {};
		this.colors = [];

		this._graph_cont = this._element.getElement('.w_graph_stat');

		this._veil = this._element.getElement('.veil');

		this._beds_select = this._element.getElement('.w_styled_select._beds select');
		this._type_select = this._element.getElement('.w_styled_select._type select');
		this._pricetype_select = this._element.getElement('.w_styled_select._price_types select');
		this._region_select = this._element.getElement('.w_styled_select._regions select');

		this.rpc = this._element.getAttribute('data-rpc');
		this.running_rpcs = 0;
		this.type_id = this._type_select.getElement(':selected').get('value');
		this.pricetype_id = this._pricetype_select.getElement(':selected').get('value');
		this.region_id = this._region_select.getElement(':selected').get('value');
		this.beds_id = this._beds_select.getElement(':selected').get('value');

		this._cur1_select = this._element.getElement('.w_styled_select._currency1');
		this._cur2_select = this._element.getElement('.w_styled_select._currency2');

		this._yaxis_title1 = new Element('div', { 'class': 'yaxis_title _first', 'html': '<span>' + (this.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in US DOLLARS</span>' }).inject(this._graph_cont, 'after');
		this._yaxis_title2 = new Element('div', { 'class': 'yaxis_title _second', 'html': '<span>' + (this.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in EUROS</span>' }).inject(this._yaxis_title1, 'after');

		this._yaxis_title1.setStyle('background-color', this.options.colors[0]);
		this._yaxis_title2.setStyle('background-color', this.options.colors[1]);

		if (Core.is_ie8()) {
			this._yaxis_title1.addClass('ie');
			this._yaxis_title2.addClass('ie');
		}

		this.set_selects_functionality();

		this._beds_select.addEvent('change', function () {
			self.beds_id = self._beds_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this._type_select.addEvent('change', function () {
			self.type_id = self._type_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this._pricetype_select.addEvent('change', function () {
			self.pricetype_id = self._pricetype_select.getElement(':selected').get('value');
			self._yaxis_title1.set('html', '<span>' + (self.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in ' + (self.currency1 + (self.currency1.toLowerCase().contains('gold') ? '' : 's')).toUpperCase() + '</span>');
			self._yaxis_title2.set('html', '<span>' + (self.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in ' + (self.currency2 + (self.currency2.toLowerCase().contains('gold') ? '' : 's')).toUpperCase() + '</span>');
			self.fireEvent('filter');
		});

		this._region_select.addEvent('change', function () {
			self.region_id = self._region_select.getElement(':selected').get('value');
			self.fireEvent('filter');
		});

		this.addEvent('filter', this.get_data.bind(this));

		this._currencies = this._element.getElements('.currencies li');
		this.first_currency = 'USD';

		this._currencies.each(function (_el) {
			self.colors.push(_el.getElement('.symbol').getStyle('color'));
			_el.index = _el.get('class').toUpperCase();

			if (_el.index == self._cur1_select.getElement(':selected').get('value') || _el.index == self._cur2_select.getElement(':selected').get('value')) {
				_el.addClass('_selected');
			}
		});

		this.fireEvent('filter');
	},

	set_selects_functionality: function set_selects_functionality() {
		var self = this;

		this._cur1_select.getElements('li').each(function (_el, i) {
			_el.set('data-value', self._cur1_select.getElements('option')[i].get('value'));
		});

		this._cur2_select.getElements('li').each(function (_el, i) {
			_el.set('data-value', self._cur2_select.getElements('option')[i].get('value'));
		});

		var cur1 = this._cur1_select.getElement('.selected').getAttribute('data-value');
		this._cur2_select.getElements('li').each(function (_el) {
			if (cur1 == _el.getAttribute('data-value')) {
				_el.addClass('hidden');
			}
		});

		var cur2 = this._cur2_select.getElement('.selected').getAttribute('data-value');
		this._cur1_select.getElements('li').each(function (_el) {
			if (cur2 == _el.getAttribute('data-value')) {
				_el.addClass('hidden');
			}
		});

		var currency1 = this._cur1_select.getElement(':selected').get('text');
		var currency2 = this._cur2_select.getElement(':selected').get('text');

		this.currency1 = currency1.substring(0, currency1.lastIndexOf(' '));
		this.currency2 = currency2.substring(0, currency2.lastIndexOf(' '));
		this.currency_symbol1 = currency1.substring(currency1.lastIndexOf(' '), currency1.length);
		this.currency_symbol2 = currency2.substring(currency2.lastIndexOf(' '), currency2.length);

		this._cur1_select.getElement('select').addEvent('change', function (el) {
			self._cur2_select.getElement('li.hidden').removeClass('hidden');
			self._cur2_select.getElements('li').each(function (_el) {
				if (el.get('value') == _el.getAttribute('data-value')) {
					_el.addClass('hidden');
				}
			});

			cur2 = self._cur2_select.getElement('.selected').getAttribute('data-value');

			self._currencies.each(function (_el) {
				if (_el.index == el.get('value') || _el.index == cur2) {
					_el.addClass('_selected');
				} else {
					_el.removeClass('_selected');
				}
			});

			self.first_currency = el.get('value');

			currency1 = el.get('text');
			self.currency1 = currency1.substring(0, currency1.lastIndexOf(' '));
			self.currency_symbol1 = currency1.substring(currency1.lastIndexOf(' '), currency1.length);

			self._yaxis_title1.set('html', '<span>' + (self.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in ' + (self.currency1 + (self.currency1.toLowerCase().contains('gold') ? '' : 's')).toUpperCase() + '</span>');

			self.fireEvent('filter');
		});

		this._cur2_select.getElement('select').addEvent('change', function (el) {
			self._cur1_select.getElement('li.hidden').removeClass('hidden');
			self._cur1_select.getElements('li').each(function (_el) {
				if (el.get('value') == _el.getAttribute('data-value')) {
					_el.addClass('hidden');
				}
			});

			cur1 = self._cur1_select.getElement('.selected').getAttribute('data-value');

			self._currencies.each(function (_el) {
				if (_el.index == el.get('value') || _el.index == cur1) {
					_el.addClass('_selected');
				} else {
					_el.removeClass('_selected');
				}
			});

			currency2 = el.get('text');
			self.currency2 = currency2.substring(0, currency2.lastIndexOf(' '));
			self.currency_symbol2 = currency2.substring(currency2.lastIndexOf(' '), currency2.length);

			self._yaxis_title2.set('html', '<span>' + (self.pricetype_id == 'avg' ? 'Average' : 'Median') + ' Price / Ft<sup>2</sup> in ' + (self.currency2 + (self.currency2.toLowerCase().contains('gold') ? '' : 's')).toUpperCase() + '</span>');

			self.fireEvent('filter');
		});
	},

	get_data: function get_data() {
		var self = this;
		var currency = '';

		this._veil.show();

		if (!this.data || !this.data[this.type_id] || !this.data[this.type_id][this.pricetype_id] || !this.data[this.type_id][this.pricetype_id][this.region_id] || !this.data[this.type_id][this.pricetype_id][this.region_id][this.beds_id]) {

			this._currencies.each(function (_el) {
				if (_el.hasClass('_selected')) {
					var obj;
					try {
						obj = JSONMOO.decode('{"' + _el.index + '": "waiting"}', false);
					} catch (e) {}

					self.store_data(obj, self.type_id, self.pricetype_id, self.region_id, self.beds_id);
					currency += '&currency[]=' + _el.index.toUpperCase();
				}
			});
		} else {
			this._currencies.each(function (_el) {
				if (_el.hasClass('_selected') && !self.data[self.type_id][self.pricetype_id][self.region_id][self.beds_id][_el.index]) {
					self.store_data(JSONMOO.decode('{"' + _el.index + '": "waiting"}', false), self.type_id, self.pricetype_id, self.region_id, self.beds_id);
					currency += '&currency[]=' + _el.index.toUpperCase();
				}
			});
		}

		if (currency == '') {
			this.display_chart();
		} else {
			this.running_rpcs++;

			var rpc = this.rpc + '?type=' + this.type_id + '&show=' + this.pricetype_id + '&region=' + this.region_id + '&bedrooms=' + this.beds_id + currency;

			var aptype = this.type_id,
			    pricetype = this.pricetype_id,
			    region = this.region_id,
			    beds = this.beds_id;

			new Remote({
				rpc: rpc,
				onSuccess: function onSuccess() {
					self.running_rpcs--;
					self.store_data(this.get_data(), aptype, pricetype, region, beds);

					self.display_chart();
				}
			});
		}
	},

	store_data: function store_data(data, aptype, pricetype, region, beds) {
		var self = this;

		if (!this.data[aptype]) this.data[aptype] = {};
		if (!this.data[aptype][pricetype]) this.data[aptype][pricetype] = {};
		if (!this.data[aptype][pricetype][region]) this.data[aptype][pricetype][region] = {};
		if (!this.data[aptype][pricetype][region][beds]) this.data[aptype][pricetype][region][beds] = {};

		Object.each(data, function (el, i) {
			self.data[aptype][pricetype][region][beds][i] = el;
		});
	},

	display_chart: function display_chart() {
		if (this.running_rpcs > 0) return;

		var self = this;
		var series = [];

		if (this.chart) {
			this.chart.destroy();
		}

		this._currencies.each(function (_el) {
			if (_el.hasClass('_selected')) {
				if (_el.index == self.first_currency) {
					series[0] = {
						name: _el.index,
						data: self.data[self.type_id][self.pricetype_id][self.region_id][self.beds_id][_el.index],
						color: self.options.colors[0],
						yAxis: 0
					};
				} else {
					series[1] = {
						name: _el.index,
						data: self.data[self.type_id][self.pricetype_id][self.region_id][self.beds_id][_el.index],
						color: self.options.colors[1],
						yAxis: 1
					};
				}
			}
		});

		this.move_rangeselector();

		var min = null,
		    max = null;
		var second_grid_width = 1;

		if (self._cur1_select.getElement(':selected').get('value').toLowerCase() == 'usd' && self._cur2_select.getElement(':selected').get('value').toLowerCase() == 'u03' || self._cur1_select.getElement(':selected').get('value').toLowerCase() == 'u03' && self._cur2_select.getElement(':selected').get('value').toLowerCase() == 'usd') {

			series[0].data.each(function (el) {
				if (!min || min > el[1]) {
					min = el[1];
				}

				if (!max || max < el[1]) {
					max = el[1];
				}
			});

			series[1].data.each(function (el) {
				if (!min || min > el[1]) {
					min = el[1];
				}

				if (!max || max < el[1]) {
					max = el[1];
				}
			});

			second_grid_width = 0;
		}

		this.chart = new Highcharts.StockChart({
			chart: {
				renderTo: self._graph_cont,
				type: 'spline',
				backgroundColor: '#ebebeb',
				marginTop: 25
			},

			series: series,

			title: {
				text: null
			},

			subtitle: {
				text: null
			},

			rangeSelector: {
				selected: 5,
				inputEnabled: false,

				labelStyle: {
					color: '#666'
				},

				buttonTheme: {
					fill: 'none',
					stroke: 'none',
					style: {
						color: '#aaa'
					},
					states: {
						hover: {
							fill: 'white'
						},

						select: {
							fill: '#bbb',
							stroke: 'none',
							style: {
								color: '#fff'
							}
						}
					}
				},

				buttons: [{
					type: 'month',
					count: 6,
					text: '6m'
				}, {
					type: 'year',
					count: 1,
					text: '1yr'
				}, {
					type: 'year',
					count: 2,
					text: '2yr'
				}, {
					type: 'year',
					count: 4,
					text: '4yr'
				}, {
					type: 'year',
					count: 6,
					text: '6yr'
				}, {
					type: 'all',
					text: 'All'
				}]
			},

			credits: {
				enabled: false
			},

			xAxis: {
				type: 'datetime',
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14, //two weeks
				labels: {
					style: {
						color: '#666'
					}
				}
			},

			yAxis: [{
				min: min,
				max: max,
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					align: 'left',
					style: {
						color: '#666'
					},
					y: -5,
					x: 0,
					formatter: function formatter() {
						var currency_code = self._cur1_select.getElement(':selected').get('value');

						if (currency_code == 'RUB') {
							return Core.add_commas(this.value) + ' ' + self.currency_symbol1;
						} else if (currency_code == 'XAU') {
							return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol1;
						}

						return self.currency_symbol1 + Core.add_commas(this.value);
					}
				},

				gridLineWidth: 1,
				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				showLastLabel: true,
				opposite: false
			}, {
				min: min,
				max: max,
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					style: {
						color: '#666'
					},
					y: -5,
					formatter: function formatter() {
						var currency_code = self._cur2_select.getElement(':selected').get('value');

						if (currency_code == 'RUB') {
							return Core.add_commas(this.value) + ' ' + self.currency_symbol2;
						} else if (currency_code == 'XAU') {
							return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol2;
						}

						return self.currency_symbol2 + Core.add_commas(this.value);
					}
				},

				// gridLineDashStyle: 'dash',
				endOnTick: false,
				showLastLabel: true,
				opposite: true,
				gridLineWidth: second_grid_width,
				gridLineColor: '#ccc'
			}],

			navigator: {
				maskFill: 'rgba(150, 150, 150, 0.5)',
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 100,
					type: 'datetime',
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					},
					gridLineColor: '#888',
					gridZIndex: 4
				},

				series: {
					color: '#bbb',
					lineWidth: 0
				}
			},

			plotOptions: {
				series: {
					animation: true
				},

				// line: {
				//	 lineWidth: 3,

				//	 states: {
				//		 hover: {
				//			 lineWidth: 3
				//		 }
				//	 },

				//	 marker: {
				//		 enabled: false,
				//		 states: {
				//			 hover: {
				//				 enabled: false
				//			 }
				//		 }
				//	 },

				//	 dataGrouping: {
				//		 // groupPixelWidth: 5,
				//		 approximation: 'open',
				//		 // forced: true,
				//		 dateTimeLabelFormats: {
				//			 day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
				//			 week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
				//		 }
				//	 }
				// },

				spline: {
					lineWidth: 3,

					states: {
						hover: {
							lineWidth: 3
						}
					},

					marker: {
						enabled: false
					},

					dataGrouping: {
						groupPixelWidth: 10,
						approximation: 'open',
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					}
				}
			},

			tooltip: {
				useHTML: true,
				valueDecimals: 0,
				shared: true,
				crosshairs: false,
				borderWidth: 2,
				borderColor: '#999',

				formatter: function formatter() {
					return self.get_tooltip(this);
				}
			},

			scrollbar: {
				enabled: true,
				barBackgroundColor: '#bbb',
				barBorderColor: '#fff',
				rifleColor: '#fff',
				buttonBackgroundColor: '#bbb',
				buttonArrowColor: '#666',
				buttonBorderColor: '#fff',
				trackBackgroundColor: '#bbb'
			}
		});

		this._veil.hide();
	},

	get_tooltip: function get_tooltip(obj) {
		var self = this;

		var details, c_price1, h_price1, c_price2, h_price2;

		var current1 = obj.points[0].series.yData[obj.points[0].series.yData.length - 1];
		var current2 = obj.points[1].series.yData[obj.points[1].series.yData.length - 1];

		var result1 = ((current1 - obj.points[0].y) / obj.points[0].y * 100).round(1);
		var result2 = ((current2 - obj.points[1].y) / obj.points[1].y * 100).round(1);

		var current_date = new Date();
		var fromDate = new Date(Highcharts.dateFormat('%b %e, %Y', obj.points[0].x));
		var xy = self.date_difference(fromDate, current_date);

		if (self._cur1_select.getElement(':selected').get('value') == 'XAU') {
			c_price1 = Core.add_commas(current1.toFixed(1)) + ' ' + self.currency_symbol1;
			h_price1 = Core.add_commas(obj.points[0].y.toFixed(1)) + ' ' + self.currency_symbol1;
		} else if (self._cur1_select.getElement(':selected').get('value') == 'RUB') {
			c_price1 = Core.add_commas(current1) + ' ' + self.currency_symbol1;
			h_price1 = Core.add_commas(obj.points[0].y) + ' ' + self.currency_symbol1;
		} else {
			c_price1 = self.currency_symbol1 + Core.add_commas(current1);
			h_price1 = self.currency_symbol1 + Core.add_commas(obj.points[0].y.round());
		}

		if (self._cur2_select.getElement(':selected').get('value') == 'XAU') {
			c_price2 = Core.add_commas(current2.toFixed(1)) + ' ' + self.currency_symbol2;
			h_price2 = Core.add_commas(obj.points[1].y.toFixed(1)) + ' ' + self.currency_symbol2;
		} else if (self._cur2_select.getElement(':selected').get('value') == 'RUB') {
			c_price2 = Core.add_commas(current2) + ' ' + self.currency_symbol2;
			h_price2 = Core.add_commas(obj.points[1].y) + ' ' + self.currency_symbol2;
		} else {
			c_price2 = self.currency_symbol2 + Core.add_commas(current2);
			h_price2 = self.currency_symbol2 + Core.add_commas(obj.points[1].y.round());
		}

		var sign1 = current1.round(1) >= obj.points[0].y.round(1) ? '+' : '';
		result1 = sign1 + result1.toString();

		var sign2 = current2.round(1) >= obj.points[1].y.round(1) ? '+' : '';
		result2 = sign2 + result2.toString();

		details = '<div class="tooltip">' + '<div class="series_name" style="background-color:' + self.options.colors[0] + '">' + self.currency1 + '</div>' + '<div style="">Current Price: ' + '<b style="">' + c_price1 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">Price on ' + Highcharts.dateFormat('%b %e, %Y', obj.points[0].x) + ': ' + '<b style="">' + h_price1 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<span style="color:' + (sign1 == '+' ? 'green' : 'red') + '"/>' + result1.toString() + '%</span>' + '</div><br/>' + '<div class="series_name" style="background-color:' + self.options.colors[1] + '">' + self.currency2 + '</div>' + '<div style="">Current Price: ' + '<b style="">' + c_price2 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">Price on ' + Highcharts.dateFormat('%b %e, %Y', obj.points[1].x) + ': ' + '<b style="">' + h_price2 + ' / ft<sup>2</sup></b>' + '</div>' + '<div style="">&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<span style="color:' + (sign2 == '+' ? 'green' : 'red') + '"/>' + result2.toString() + '%</span>' + '</div>' + '</div>';

		return details;
	},

	date_difference: function date_difference(d1, d2) {
		var monthDay = [31, -1, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		var fromDate, toDate;
		var year, month, day;

		fromDate = d1;
		toDate = d2;

		var increment = 0;

		if (fromDate.format('%e') > toDate.format('%e')) {
			increment = monthDay[fromDate.format('%m') - 1];
		}

		if (increment == -1) {
			if (fromDate.isLeapYear()) {
				increment = 29;
			} else {
				increment = 28;
			}
		}

		if (increment != 0) {
			increment = 1;
		}

		if (fromDate.get('Month') + increment > toDate.get('Month')) {
			month = toDate.get('Month') + 12 - (fromDate.get('Month') + increment);
			increment = 1;
		} else {
			month = toDate.get('Month') - (fromDate.get('Month') + increment);
			increment = 0;
		}

		year = toDate.get('year') - (fromDate.get('year') + increment);

		return year + '.' + month;
	},

	move_rangeselector: function move_rangeselector() {
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft - 15,
				    topPosition = this.chart.plotTop,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 415,
					y: topPosition - 56

				});

				leftPosition += this.zoomText.getBBox().width + 420;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition,
						y: topPosition - 70
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	}
});
'use strict';

var Module = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_module'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);
		this._element = _element || document.getElement('.' + this.options.cls);

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var _photogalleries = this._element.getElements('.w_photogallery');

		if (_photogalleries.length > 0) {
			_photogalleries.each(function (_el) {
				new Photogallery(_el, {
					width_by_thumbs: 0, //has to be odd or 0 if thumbs are hidden	!!!!!!!!!!!!!!!!!!!!!!
					show_controllers: true, //always display controllers
					no_enlarge_opt: false,
					no_fullscreen_opt: true
					//onFsClose: function(){}
				});
			});
		}
	}
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var NhStats = new Class({
	Implements: [Options, Events],

	options: {
		type: 2,
		graph_colors: ['#b19f00', '#018f9b', '#b4224a', '#484a67', '#ff5a00'],
		map_zoom: 13,
		map_markers_path: null
	},

	initialize: function initialize(_element, options) {
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;
		this.build();
	},

	build: function build() {
		var self = this;

		this.beds_status = [true, true, true, true, true];

		this.cache = [];

		this.rangeslider = new Rangeslider(this._element.getElement('.w_rangeslider'), {
			title: 'Date Range:',
			onComplete: function onComplete(min, max, min_formatted, max_formatted) {
				self.date_min_formatted = min_formatted || min;
				self.date_max_formatted = max_formatted || max;

				if (this._min_label) {
					self.date_min_formatted = this._min_label.get('text');
				}

				if (this._max_label) {
					self.date_max_formatted = this._max_label.get('text');
				}

				self.date_min = min || this._min_input.get('value');
				self.date_max = max || this._max_input.get('value');

				self.date_max = moment(self.date_max).endOf('month').format('YYYY-MM-DD');

				self.display_period();

				self.filter_data();
				self.apply_data();

				/*---*/
				// to set the bed to be the same as the one in city stats if the user click the series line.
				if (self._element.get('data-bed-id') && self._message.getStyle('display') != 'block') {
					var bed_id = self._element.get('data-bed-id');
					var _bed = document.getElement('.nh_beds');

					if (!_bed) return;

					var _beds = _bed.getElements('li._selected');

					_beds.each(function (_b) {
						if (bed_id.toInt() != 0 && _b.hasClass('_active')) {
							if (!_b.hasClass('beds_' + bed_id)) {
								_b.fireEvent('click');
							}
						}
					});

					self._element.set('data-bed-id', '');
				}

				// var url = window.location.href;

				// if(url.contains('bedrooms=')){
				// 	var start = url.indexOf('bedrooms=');
				// 	var param = url.substring(start);
				// 	var bed_id = param.substr(param.indexOf('=')+1);
				// 	var _bed = document.getElement('.nh_beds');
				// 	var _beds = _bed.getElements('li._selected');

				// 	_beds.each(function(_b){
				// 		if(bed_id.toInt() != 0 && _b.hasClass('_active')){
				// 			if(!_b.hasClass('beds_'+ bed_id)){
				// 				_b.fireEvent('click');
				// 			}
				// 		}
				// 	})
				// }

				/*---*/
			}
		});

		this.mindate_to_compare = this.rangeslider._min_label ? this.rangeslider._min_label.get('text') : this.rangeslider._min_input.get('value');
		this.maxdate_to_compare = this.rangeslider._max_label ? this.rangeslider._max_label.get('text') : this.rangeslider._max_input.get('value');

		if (this._element.getElement('.w_rangeslider_labels')) {
			this.date_min_formatted = this._element.getElement('.w_rangeslider_labels .min').get('text');
			this.date_max_formatted = this._element.getElement('.w_rangeslider_labels .max').get('text');
		} else {
			this.date_min_formatted = this.rangeslider._min_input.get('text');
			this.date_max_formatted = this.rangeslider._max_input.get('text');
		}

		this.type = _typeof(this.options.type) == 'object' ? this.options.type.value : this.options.type;

		this._graph_cont = document.getElement('.w_neighborhoods .graph .graph_container');
		this._chart_cont = document.getElement('.w_neighborhoods .chart .graph_container');
		this._listview_cont = document.getElement('.w_neighborhoods .listview');
		this._areamap_cont = document.getElement('.w_neighborhoods .areamap');
		this._heatmap_cont = document.getElement('.w_neighborhoods .heatmap');

		var _conts = [this._areamap_cont, this._listview_cont, this._chart_cont.getParent('.chart'), this._graph_cont.getParent('.graph'), this._heatmap_cont];

		this._veil = document.getElement('.w_neighborhoods .data_display_veil');
		this._message = document.getElement('.w_neighborhoods .data_display .error');
		this._warning = document.getElement('.w_neighborhoods .data_display .warning').hide();

		this.init_message = this._message.get('text');

		this._header = document.getElement('.ns_header h2');
		this._cats = this._element.getElements('.nh_categories a');

		this._region_styled_select = self._element.getElement('.w_styled_select._regions');
		this._region_select = this._element.getElement('.w_styled_select._regions select');

		this._precise = this._element.getElement('.nh_precise');
		this._beds_cont = this._element.getElement('.nh_beds');
		this._beds_select = self._element.getElement('.w_multiselect._beds');
		this._beds = this._beds_cont.getElements('li');

		this._currency_styled_select = self._element.getElement('.w_styled_select.currency');
		this._currency_select = this._element.getElement('.w_styled_select.currency select');
		this.currency = this._currency_select.getElement(':selected').get('value');
		this._currency_select.addEvent('change', function () {
			self.currency = self._currency_select.getElement(':selected').get('value');
			self.get_data();
		});
		this.currency_symbol = '$';

		if (this._beds_select) {
			this.add_beds_select();
		} else {
			this.add_beds_functionality();
		}

		this._summary = document.getElement('.w_neighborhoods .summary');

		this.cats = this._cats;

		if (this._region_styled_select) {
			this._region_select_options = this._region_select.getElements('option');
			this._cats = this._region_styled_select.getElements('li');
		}

		this._cats.each(function (_el, i) {
			_el.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (self._clicked_cat === _el && e) return;

				if (self._clicked_cat) {
					self._clicked_cat.removeClass('_selected');
					self._clicked_cat.removeClass('_loading');
				}

				self._clicked_cat = _el;
				self.region_id = self._region_select_options ? self._region_select_options[i].get('value') : _el.get('data-region');

				if (!this._region_styled_select) {
					_el.addClass('_selected');

					var nh = self._clicked_cat.get('text').trim();

					self._precise.getElement('h3').set('text', nh + (nh.length > 15 ? ' nbrhds' : ' neighborhoods'));

					self.current_nh = _el._precise_select ? _el._precise_select.getElement('.monitor').get('text') : 'this neighborhood';
				}

				if (_el.ss) {
					_el.ss.fireEvent('change');
				}

				self.set_new_precise_select(_el);

				self.set_header(self.current_nh);
			}.bind(this));
		}.bind(this));

		//this.set_active_region();

		this._menu_togglers = document.getElements('.w_neighborhoods .nh_tools a');
		this._current_menu_toggler = this._menu_togglers[0];

		this._menu_togglers.each(function (_el, i) {
			_el.data_changed = i != 0;
			_el.beds_status = [true, true, true, true, true];
			_el._cont = _conts[i];

			_el.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (_el !== self._current_menu_toggler) {
					self.toggle_menu(_el);
				}
			});
		});
	},

	display_period: function display_period() {
		var date_min = this.date_min_formatted || this.date_min;
		var date_max = this.date_max_formatted || this.date_max;

		var period = '(' + date_min + ' - ' + date_max + ')';

		if (date_min == date_max) {
			period = '( ' + date_max + ' )';
		}

		if (date_max == this.maxdate_to_compare) {
			var diff = Date.parse(this.date_min).diff(Date.parse('28th'), 'month');

			if (diff <= 12) {
				period = '(past ' + diff + ' month' + (diff == 1 ? ')' : 's)');
			}

			if (diff == 0) {
				period = '( ' + date_max + ' )';
			}
		}

		this._summary.getElement('._period').set('text', period);
	},

	get_data: function get_data() {
		var self = this;

		if (this._current_nh.data && this._current_nh.data[this.type] && this._current_nh.data[this.type][this.currency] && this._current_nh.data[this.type][this.currency] != 'waiting' && this._current_nh.data[this.type][this.currency] != 'error') {
			this.rangeslider.fireEvent('complete');

			return;
		}

		// if User click a hood series from CityStats : Apartment prices by Region Chart,
		// Apply the same criteria to get the correct data of the selected hood from the previous page
		var crNhStatsCriteria = Cookie.read('crNhStatsCriteria');
		if (crNhStatsCriteria) {
			crNhStatsCriteria = JSONMOO.decode(crNhStatsCriteria);

			this.current_nh_id = crNhStatsCriteria.hood;
			this.region_id = crNhStatsCriteria.region;
			this.type = crNhStatsCriteria.type;
			this.currency = crNhStatsCriteria.currency;
		}

		var hood_string = '';

		if (this.current_nh_id == 0) {} else {
			hood_string = '&hood=' + this.current_nh_id;
		}

		var rpc = self._clicked_cat.getAttribute('data-rpc');

		if (this._region_styled_select) {
			rpc = this._region_styled_select.get('data-rpc') + '&region=' + this.region_id;
		}

		rpc += '&type=' + this.type + hood_string + '&currency=' + self.currency;

		this.latest_rpc = rpc;

		self._current_nh.data = self._current_nh.data || {};

		var type = self.type;

		self._current_nh.data[type] = self._current_nh.data[type] || {};

		if (self._current_nh.data[type][self.currency] == 'waiting') return;

		self._current_nh.data[type][self.currency] = 'waiting';

		this._veil.show();
		this.rangeslider.disable();

		var nh = self._current_nh;
		var cc = self._clicked_cat;

		if (this.remote) {
			this.remote.cancel();
			// delete the waiting status in case of cancel
			if (self.previous_current_nh && self.previous_current_nh.data) {
				delete self.previous_current_nh.data[type][self.currency];
			}
		}

		this.remote = new Remote({
			rpc: rpc,
			onSuccess: function onSuccess() {
				nh.data[type][self.currency] = this.get_data();
				cc.removeClass('_loading');

				if (self.latest_rpc == this.options.rpc) {
					self.rangeslider.fireEvent('complete');
				}
			}
		});

		this._summary.addClass('_loading');
		this.remote._clicked_cat = this._clicked_cat;
		this.remote._clicked_cat.addClass('_loading');
	},

	filter_data: function filter_data() {
		var self = this;
		this.sorted_data = this._current_nh.data[this.type][this.currency].sales;

		Object.each(this.sorted_data, function (el, i) {
			var display_by_beds = false;

			el.each(function (e) {
				var date = e.sale_date_unformatted;

				if (date > self.date_max || date < self.date_min) {
					e.display = false;
				} else {
					e.display = true;
					display_by_beds = true;
				}
			});

			if (display_by_beds) {
				self._beds[i - 10].addClass('_active');

				if (self.beds_status[i - 10]) {
					self._beds[i - 10].addClass('_selected');
				}
			} else {
				self._beds[i - 10].removeClass('_active').removeClass('_selected');
			}
		});
	},

	apply_data: function apply_data() {
		var current_display = this._current_menu_toggler.getAttribute('data-element');

		this.currency_symbol = Core.get_html_text(this._current_nh.data[this.type][this.currency].currency_symbol);

		if (current_display == 'graph') {
			this.display_graph();
		} else if (current_display == 'chart') {
			this.display_chart();
		} else if (current_display == 'listview') {
			this.display_listview();
		} else if (current_display == 'areamap') {
			this.display_areamap();
		} else if (current_display == 'heatmap') {
			this.display_heatmap();
		}

		this.rangeslider.enable();

		this.set_summary();
	},

	add_beds_select: function add_beds_select() {
		var self = this;

		this._element.getElement('.w_styled_select._beds').hide();

		this._beds_select.show();

		this.beds_multiselect = new Multiselect(this._beds_select, {
			text_input: false,
			close_button: false,
			equality: true,
			add_tiles: false,
			onClick: function onClick(e, _el) {
				var id = _el.get('data-id');
				var dbb = _el.hasClass('_selected');
				self.beds_status[id - 10] = dbb;

				self.sorted_data[id].each(function (el) {
					el.display_by_beds = dbb;
				});

				var current_display = self._current_menu_toggler.getAttribute('data-element');

				if (current_display == 'graph') {
					self.update_highchart_series(id, dbb, 'graph');
				} else if (current_display == 'chart') {
					self.update_highchart_series(id, dbb, 'chart');
				} else if (current_display == 'listview') {
					self.display_listview();
				} else if (current_display == 'areamap') {
					self.display_areamap();
				} else if (current_display == 'heatmap') {
					self.display_heatmap();
				}

				self.set_summary();
			}
		});

		this.beds_multiselect.update_monitor();
	},

	add_beds_functionality: function add_beds_functionality() {
		var self = this;

		this._beds.each(function (_el, i) {
			_el.addEvents({
				'click': function click() {
					if (_el.hasClass('_active')) {
						_el.toggleClass('_selected');
						var dbb = _el.hasClass('_selected');
						self.beds_status[i] = dbb;

						self.sorted_data[i + 10].each(function (el) {
							el.display_by_beds = dbb;
						});

						var current_display = self._current_menu_toggler.getAttribute('data-element');

						if (current_display == 'graph') {
							self.update_highchart_series(i + 10, dbb, 'graph');
						} else if (current_display == 'chart') {
							self.update_highchart_series(i + 10, dbb, 'chart');
						} else if (current_display == 'listview') {
							self.display_listview();
						} else if (current_display == 'areamap') {
							self.display_areamap();
						} else if (current_display == 'heatmap') {
							self.display_heatmap();
						}

						self.set_summary();

						_el.fireEvent('mouseleave');
					}
				},

				'mouseenter': function mouseenter() {
					_el.addClass('_hovered');
				},

				'mouseleave': function mouseleave() {
					_el.removeClass('_hovered');
				}
			});
		});
	},

	toggle_menu: function toggle_menu(_el) {
		var self = this;
		this._menu_togglers.each(function (_e) {
			if (_e !== _el) {
				_e.removeClass('_active');
				_e._cont.hide();
			}
		});

		this.beds_status.each(function (el, i) {
			self._current_menu_toggler.beds_status[i] = el;
		});

		_el.addClass('_active');
		_el._cont.show();

		_el.data_changed = false;
		this._current_menu_toggler = _el;

		this.apply_data();
	},

	mark_menu_togglers: function mark_menu_togglers() {
		this._menu_togglers.each(function (_el) {
			if (!_el.hasClass('_active')) {
				_el.data_changed = true;
			} else {
				_el.data_changed = false;
			}
		});
	},

	set_summary: function set_summary() {
		var self = this;
		var total_sales = 0;
		var avg_ppsqft = 0;
		var avg_price = 0;
		var median_price = 0;
		var median_prices_array = [];

		var most_expensive, least_expensive;

		var cs = this.currency_symbol;

		if (this.sorted_data) {
			this.beds_status.each(function (el, i) {
				if (el && self.sorted_data[i + 10] && self.sorted_data[i + 10]) {
					self.sorted_data[i + 10].each(function (e) {
						if (e.display) {
							var price = (e.sale_price || 0).toFloat();

							total_sales++;
							avg_ppsqft += (e.ppsqft || 0).toFloat();
							avg_price += price;
							median_prices_array.push(price);

							if (!most_expensive || price > most_expensive.sale_price.toFloat()) {
								most_expensive = e;
							}

							if (!least_expensive || price < least_expensive.sale_price.toFloat()) {
								least_expensive = e;
							}
						}
					});
				}
			});

			if (total_sales > 0) {
				avg_ppsqft /= total_sales;
				avg_price /= total_sales;

				if (this.currency.toLowerCase() == 'rub' || this.currency.toLowerCase() == 'xau') {
					if (avg_ppsqft > 0) avg_ppsqft = Core.add_commas(avg_ppsqft.round(avg_ppsqft < 100 ? 2 : 0)) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
					if (avg_price > 0) avg_price = Core.add_commas(avg_price.round(0)) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
				} else {
					if (avg_ppsqft > 0) avg_ppsqft = cs + Core.add_commas(avg_ppsqft.round(avg_ppsqft < 100 ? 2 : 0));
					if (avg_price > 0) avg_price = cs + Core.add_commas(avg_price.round(0));
				}

				if (median_prices_array.length > 0) {
					median_prices_array = median_prices_array.sort(function (a, b) {
						return a - b;
					});

					if (median_prices_array.length % 2 == 0) {
						median_price = ((median_prices_array[median_prices_array.length / 2] + median_prices_array[median_prices_array.length / 2 - 1]) / 2).round(0);
					} else {
						median_price = median_prices_array[(median_prices_array.length / 2).floor()].round(0);
					}

					if (this.currency.toLowerCase() == 'rub' || this.currency.toLowerCase() == 'xau') {
						median_price = Core.add_commas(median_price) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
					} else {
						median_price = cs + Core.add_commas(median_price);
					}
				}

				if (total_sales > 500) {
					self._warning.show();
				} else {
					self._warning.hide();
				}
			}
		}

		this._summary.getElement('#total_sales').set('html', total_sales);

		var _avg_price_ft = this._summary.getElement('#avg_price_ft');
		_avg_price_ft.set('html', avg_ppsqft);

		if (_avg_price_ft.get('text').length > 8) {
			_avg_price_ft.addClass('_small');
		} else {
			_avg_price_ft.removeClass('_small');
			_avg_price_ft.removeClass('_supersmall');
		}

		if (_avg_price_ft.get('text').length > 11) {
			_avg_price_ft.addClass('_supersmall');
		}

		var _avg_price = this._summary.getElement('#avg_price');
		_avg_price.set('html', avg_price);

		if (_avg_price.get('text').length > 8) {
			_avg_price.addClass('_small');
		} else {
			_avg_price.removeClass('_small');
			_avg_price.removeClass('_supersmall');
		}

		if (_avg_price.get('text').length > 11) {
			_avg_price.addClass('_supersmall');
		}

		var _med_price = this._summary.getElement('#med_price');
		_med_price.set('html', median_price);

		if (_med_price.get('text').length > 8) {
			_med_price.addClass('_small');
		} else {
			_med_price.removeClass('_small');
			_med_price.removeClass('_supersmall');
		}

		if (_avg_price.get('text').length > 11) {
			_med_price.addClass('_supersmall');
		}

		this._summary.removeClass('_loading');

		if (most_expensive) {
			var me = '<strong>Most Expensive</strong><br>' + '<a href="' + most_expensive.url_sold + '">' + (most_expensive.name || most_expensive.display_name || most_expensive.street_address) + ', #' + most_expensive.unit + '</a><br/>' + most_expensive.bedroom.split('room').join('') + ' | ' + most_expensive.sale_price_format + '<br>' + most_expensive.ppsqft_format + ' / ft<sup>2</sup>' + '<br/>' + '<span> Closed: ' + most_expensive.sale_date + '</span>';

			this._most_expensive = this._summary.getElement('#most_exp');
			this._most_expensive.set('html', me);

			this._summary.getElement('#most_exp').show();
		} else {
			this._summary.getElement('#most_exp').hide();
		}

		if (least_expensive) {
			var le = '<strong>Least Expensive</strong><br>' + '<a href="' + least_expensive.url_sold + '">' + (least_expensive.name || least_expensive.display_name || least_expensive.street_address) + ', #' + least_expensive.unit + '</a><br/>' + least_expensive.bedroom.split('room').join('') + ' | ' + least_expensive.sale_price_format + '<br>' + least_expensive.ppsqft_format + ' / ft<sup>2</sup>' + '<br/>' + '<span> Closed: ' + least_expensive.sale_date + '</span>';

			this._least_expensive = this._summary.getElement('#least_exp');
			this._least_expensive.set('html', le);

			this._summary.getElement('#least_exp').show();
		} else {
			this._summary.getElement('#least_exp').hide();
		}
	},

	set_new_precise_select: function set_new_precise_select(_el) {
		var self = this;
		var _ss = this._precise.getElement('.w_styled_select');

		if (_ss) _ss.dispose();

		if (!_el._precise_select) {
			var config;

			try {
				var data = (_el.getNext('.hoods') || _el.getElement('.hoods')).get('html');
				config = JSONMOO.decode(data, false);
			} catch (e) {}

			if (typeOf(config) == 'object') {
				_el.hoods = config;

				var _select = _el._hood_select = new Element('select');

				Object.each(_el.hoods, function (el, i) {
					new Element('option', { 'text': el, 'data-hood': i }).inject(_select);
				});

				_el._precise_select = new Element('div', { 'class': 'w_styled_select' }).adopt(_select);

				this._precise.adopt(_el._precise_select);

				_el.ss = this.styledselect = new StyledSelect(_el._precise_select);

				this.fireEvent('nhSet', [_el._precise_select]);

				if (this.current_nh_id) {
					var _ul = this._region_styled_select ? this._region_styled_select.getElement('ul') : this._element.getElement('.nh_categories ul');
					_ul.setAttribute('data-hood-selected', self.current_nh_id);
				}

				this.set_active_hood(_el._precise_select);

				_el.ss.addEvent('change', function () {
					self.current_nh = this.text;

					self.set_header(this.text);

					var _selected_option = this._select.getElement(':selected');

					if (!_selected_option) {
						_select.getElements('option').each(function (_option) {
							if (_option.get('text') == self.current_nh) {
								_selected_option = _option;
							}
						});
					}

					self.previous_current_nh = self._current_nh;
					self.current_nh_id = _selected_option.getAttribute('data-hood');
					self._current_nh = this._selected;

					self.get_data();

					if (self.graph && self._current_nh.data[self.type][self.currency] != 'waiting' && self._current_nh.data[self.type][self.currency] != 'error') {
						self.mark_menu_togglers();
					}
				});

				_el.ss.fireEvent('change');
			} else {
				this._precise.hide();
			}
		} else {
			this._precise.adopt(_el._precise_select);
		}
	},

	set_active_region: function set_active_region() {
		var self = this;

		this._cats_ul = self._element.getElement('.nh_categories ul') || this._region_styled_select.getElement('ul');
		var active_region = this._cats_ul.get('data-region-selected');
		if (active_region) {

			this._cats.each(function (_cat, i) {

				if (this._region_styled_select) {
					if (this._region_select_options[i].get('value') == active_region) {
						_cat.fireEvent('click');
					}
				} else {
					if (_cat.get('data-region') == active_region) {
						_cat.fireEvent('click');
					}
				}
			}.bind(this));
		} else {
			this._cats[0].fireEvent('click');
		}
	},

	set_active_hood: function set_active_hood(_precise_select) {
		var self = this;
		this._cats_ul = self._element.getElement('.nh_categories ul') || this._region_styled_select.getElement('ul');

		var active_hood = this._cats_ul.get('data-hood-selected');
		var _options = _precise_select.getElements('option');

		if (active_hood) {
			_options.each(function (_option, i) {
				if (_option.get('data-hood') == active_hood) {
					var _opts = _precise_select.getElements('.option');
					_opts[i].fireEvent('click');
				}
			}.bind(this));
		}
	},

	set_header: function set_header(text) {
		if (!this._header) return;
		this._header.set('html', text + ' Sales Summary');
	},

	display_chart: function display_chart() {
		var self = this;
		this.display_message(false);

		var series = [];
		var color = 0;

		var data = {
			10: this.sorted_data[10],
			11: this.sorted_data[11],
			12: this.sorted_data[12],
			13: this.sorted_data[13],
			14: this.sorted_data[14]
		};

		Object.each(data, function (el, i) {
			if (!el || el.length == 0) return;

			var data_series = [];

			Object.each(el, function (e) {
				if (!e.display) return;

				var date = new Date(e.sale_date_unformatted).getTime();

				data_series.push([date, e.ppsqft, e.tooltip, e.url_sold]);
			});

			self.sort(data_series);

			if (data_series.length > 0) {
				series.push({
					name: i,
					color: self.options.graph_colors[color],
					data: data_series
				});
			}

			color++;
		});

		this.cache = series;

		if (this.chart) {
			this.reset_highchart(series, 'chart');
		} else {
			this.move_rangeselector();
			this.get_rangedate();

			this.create_chart(series);

			this.set_rangeselector();

			this.filter_data(); //causes infinite recursion
		}

		this._veil.hide();
	},

	create_chart: function create_chart(series) {
		var self = this;

		if (series.length > 0) {
			this.chart = new Highcharts.StockChart({
				chart: {
					renderTo: self._chart_cont,
					type: 'spline',
					backgroundColor: '#ebebeb',
					marginTop: 25
				},

				series: series,

				title: {
					useHTML: true,
					text: null,
					x: 25,
					margin: 0,
					align: 'left',
					style: {
						color: '#ccc',
						font: '11px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif',
						fontWeight: 'bold'
					}
				},

				subtitle: {
					text: null
				},

				rangeSelector: {
					enabled: false
				},

				credits: {
					enabled: false
				},

				xAxis: {
					type: 'datetime',
					title: {
						text: null
					},
					minRange: 3600000 * 24 * 14, //two weeks
					labels: {
						style: {
							color: '#666'
						}
					}
				},

				yAxis: {
					plotLines: [{
						value: 0,
						width: 2,
						color: '#666'
					}],

					title: {
						text: null,
						x: -5,
						style: {
							color: '#666'
						}
					},

					labels: {
						align: 'left',
						style: {
							color: '#666'
						},
						x: 0,
						formatter: function formatter() {
							return self.currency_symbol + Core.add_commas(this.value);
						}
					},
					gridLineWidth: 1,
					gridLineDashStyle: 'dash',
					gridLineColor: '#666',
					endOnTick: false,
					showLastLabel: true,
					minPadding: 0,
					opposite: false
				},

				navigator: {
					enabled: false
				},

				plotOptions: {
					series: {
						animation: true,
						cursor: 'pointer',
						point: {
							events: {
								click: function click(e) {
									var index;

									if (this.dataGroup) {
										index = this.dataGroup.start;
									} else {
										index = this.index;
									}

									var url = this.series.options.data[index][3];

									if (url) {
										window.location = url;
									}

									self.fireEvent('seriesClick');
								}
							}
						},
						states: {
							hover: {
								lineWidthPlus: 0
							}
						}
					},

					line: {
						dataGrouping: {
							// smoothed: true,
							groupPixelWidth: 5,
							approximation: 'open',
							dateTimeLabelFormats: {
								day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
								week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
							}
						},
						lineWidth: 3,

						states: {
							hover: {
								lineWidthPlus: 0
							}
						},

						marker: {
							enabled: false,
							states: {
								hover: {
									enabled: true
								}
							}
						}
					}
				},

				tooltip: {
					useHTML: true,
					valueDecimals: 0,
					shared: false,
					crosshairs: false,
					borderWidth: 2,
					style: {
						width: '300px'
					},
					formatter: function formatter() {
						var index;
						if (this.point.dataGroup) {
							index = this.point.dataGroup.start;
						} else {
							index = this.point.index;
						}

						var content = this.point.series.options.data[index][2];

						if (this.point.dataGroup && this.point.dataGroup.length > 1) {
							content += '<br><br><i class="note">Note: This is an Average Closing Price.</i>';
						}

						return content;
					}
				},

				scrollbar: {
					enabled: false
					// barBackgroundColor: '#bbb',
					// barBorderColor: '#fff',
					// rifleColor: '#fff',
					// buttonBackgroundColor: '#bbb',
					// buttonArrowColor: '#666',
					// buttonBorderColor: '#fff',
					// trackBackgroundColor: '#bbb'
				}
			});
		} else {
			this.display_message(true);
		}

		this._veil.hide();
	},

	display_graph: function display_graph() {
		var self = this;
		this.display_message(false);

		var series = [];
		var color = 0;

		var data = {
			10: this.sorted_data[10],
			11: this.sorted_data[11],
			12: this.sorted_data[12],
			13: this.sorted_data[13],
			14: this.sorted_data[14]
		};

		Object.each(data, function (el, i) {
			if (el && el.length > 0) {
				var data_series = [];

				Object.each(el, function (e) {
					if (e.display) {
						data_series.push([e.x, e.y, e.tooltip, e.url_sold]);
					}
				});

				if (data_series.length > 0) {
					series.push({
						name: i,
						color: self.options.graph_colors[color],
						data: data_series,
						marker: {
							symbol: 'circle',
							radius: 8
						}
					});
				}
			}

			color++;
		});

		this.cache = series;

		if (this.graph) {
			this.reset_highchart(series, 'graph');
		} else {
			this.create_graph(series);
			this.filter_data(); //causes infinite recursion
		}

		this._veil.hide();
	},

	create_graph: function create_graph(series) {
		var self = this;

		if (series.length > 0) {
			this.graph = new Highcharts.Chart({
				chart: {
					animation: false,
					renderTo: self._graph_cont,
					type: 'scatter',
					zoomType: 'xy',
					plotBackgroundColor: '#ebebeb',
					backgroundColor: '#ebebeb',
					// marginTop: 20,
					marginBottom: 42,
					marginLeft: 14,
					ignoreHiddenSeries: true,

					resetZoomButton: {
						theme: {
							fill: '#585858',
							stroke: 'silver',
							style: {
								color: '#fff'
							},
							r: 0,
							states: {
								hover: {
									fill: '#41739D',
									style: {
										color: 'white'
									}
								}
							}
						}
					}
				},

				series: series,

				credits: {
					enabled: false
				},

				title: {
					text: null
				},

				xAxis: {
					type: self._current_nh.data[self.type][self.currency].x.type,
					minPadding: 0.1,
					gridLineWidth: 1,
					gridLineColor: '#aaa',
					gridLineDashStyle: 'dash',
					// min: 100,
					title: {
						text: '<span style="margin-bottom:3px;">' + self._current_nh.data[self.type][self.currency].x.label + '</span>',
						margin: 3,
						style: {
							color: '#666'
						}
					},
					labels: {
						useHTML: true,
						overflow: 'justify',
						formatter: function formatter() {
							return Core.add_commas(this.value) + ' ft<sup>2</sup>';;
						},
						style: {
							color: '#666',
							fontWeight: 'normal'
						}
					}
				},

				yAxis: {
					type: self._current_nh.data[self.type][self.currency].y.type,
					gridLineColor: '#aaa',
					gridLineDashStyle: 'dash',

					showFirstLabel: true,
					showLastLabel: false,

					minPadding: 0.05,
					maxPadding: 0,

					title: {
						text: self._current_nh.data[self.type][self.currency].y.label,
						margin: 3,
						style: {
							color: '#666'
						}
					},
					labels: {
						align: 'left',
						x: 3,
						y: -4,
						formatter: function formatter() {
							if (self.currency.toLowerCase() == 'xau' || self.currency.toLowerCase() == 'rub') {
								return Highcharts.numberFormat(this.value, 2) + ' ' + self.currency_symbol.toLowerCase();
							} else {
								return self.currency_symbol + Highcharts.numberFormat(this.value, 0);
							}
						},
						style: {
							color: '#666',
							fontWeight: 'normal',
							whiteSpace: 'nowrap'
						}
					}
				},

				tooltip: {
					formatter: function formatter() {
						if (!this.series.visible) {
							return false;
						} else {
							this.series.zIndex = 1;
						}

						var index;
						if (this.point.dataGroup) {
							index = this.point.dataGroup.start;
						} else {
							index = this.point.index;
						}

						var content = this.point.series.options.data[index][2];

						return content;
					},
					snap: 30,
					useHTML: true
				},

				legend: {
					enabled: false
				},

				plotOptions: {
					scatter: {
						marker: {
							radius: 6,
							states: {
								hover: {
									enabled: true,
									lineColor: 'rgb(100,100,100)'
								}
							}
						},
						states: {
							hover: {
								marker: {
									enabled: false
								}
							}
						}
					},

					series: {
						animation: false,
						cursor: 'pointer',
						point: {
							events: {
								click: function click(e) {
									self._veil.show();

									var index;

									if (this.dataGroup) {
										index = this.dataGroup.start;
									} else {
										index = this.index;
									}

									var url = this.series.options.data[index][3];

									if (url) {
										window.location = url;
									}

									self.fireEvent('seriesClick');
								},
								mouseOver: function mouseOver() {
									if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
										if (!this.button) {
											var index;

											if (this.dataGroup) {
												index = this.dataGroup.start;
											} else {
												index = this.index;
											}

											this.button = new Element('a', { 'class': 'button details', 'href': this.series.options.data[index][3], 'text': 'Listing Details' });
										}

										self._graph_cont.adopt(this.button);
									}
								},

								mouseOut: function mouseOut() {
									if (this.button) {
										this.button.dispose();
									}
								}
							}
						}
					}
				}
			});
		} else {
			this.display_message(true);
		}

		this._veil.hide();
	},

	reset_highchart: function reset_highchart(series, type) {
		var self = this;
		var active_chart = this.chart;

		if (type == 'graph') {
			active_chart = this.graph;
		}

		if (series.length > 0) {
			var length;
			if (Core.is_ie9()) {
				while (active_chart.series.length > 0) {
					active_chart.series[0].remove(true);
				}
			} else {
				length = active_chart.series.length;
				for (var i = 0; i < length; i++) {
					active_chart.series[0].remove(false);
				}

				series.each(function (el) {
					active_chart.addSeries(el);
				});
			}

			this.beds_status.each(function (el, i) {
				self.update_highchart_series(i + 10, el, type);
			});

			active_chart.yAxis[0].setTitle({
				text: self._current_nh.data[self.type][self.currency].y.label
			});
		} else {
			this.display_message(true);
		}
	},

	update_highchart_series: function update_highchart_series(id, turn_on, type) {
		var series;
		var active_chart = this.chart;
		this._hidden_series;

		if (type == 'graph') {
			active_chart = this.graph;
		}

		active_chart.series.each(function (el) {
			if (el.name == id) {
				series = el;
				return;
			}
		});

		if (!Core.is_ie9() && !series) {
			return;
		}

		if (turn_on && series && !series.visible) {
			series.show();
		} else if (turn_on && Core.is_ie9()) {
			var found = null;
			this.cache.each(function (s) {
				if (s.name == id) {
					found = s;
				}
			});
			active_chart.addSeries(found);
		} else if (!turn_on && series && series.visible) {
			//series.zIndex = 0;
			//console.log(series);
			//console.log(series.cursor);
			//series.cursor = null;
			//series.enableMouseTracking = false;
			if (Core.is_ie9()) {
				series.remove();
				active_chart.redraw();
			} else {
				series.hide();
			}
		}
	},

	display_areamap: function display_areamap() {
		var self = this;
		this.display_message(false);

		var data = [];

		Object.each(this.sorted_data, function (el, i) {
			if (el && el.length > 0 && self.beds_status[i - 10]) {
				Object.each(el, function (e) {
					if (e.display) data.push(e);
				});
			}
		});

		if (!this.areamap) {
			this._veil.show();

			this.create_areamap(data);
		} else {
			this.reset_areamap(data);
		}
	},

	create_areamap: function create_areamap(data) {
		var self = this;

		if (data.length > 0) {

			var areamap_data = {
				zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
				markers_path: this._current_nh ? this._current_nh.data[this.type][this.currency].map_markers_path : this.options.map_markers_path,
				data: data
			};

			this.areamap = new NhStatsAreaMap(this._areamap_cont, {
				min_zoom: 12,
				data: areamap_data,
				// onNoData: function(){ self.display_message(true); },
				open_blimp: function open_blimp(url) {
					self._veil.show();

					var blimp;

					Blimp.instances.each(function (el) {
						if (el.options.rpc_url == url) {
							blimp = el;

							return;
						}
					});

					if (!blimp) {
						blimp = new BlimpExt(null, {
							draggable: true,
							show_veil: true,
							onPostRpc: function onPostRpc() {
								new BldBlimp(this);
								self._veil.hide();

								self.fireEvent('seriesClick');
							},
							rpc_url: url
						});
					}

					blimp._link.fireEvent('click');
				}
			});

			this.areamap.addEvent('ready', function () {
				self._veil.hide();
			});
		} else {
			this.display_message(true);
		}
	},

	reset_areamap: function reset_areamap(sorted_data) {
		if (sorted_data.length > 0) {
			var sorted_data = sorted_data || Object.clone(this.sorted_data);

			this._beds.each(function (_el) {
				sorted_data.each(function (el) {
					el.display_on_map = _el.hasClass('_selected');
				});
			});

			if (!this.areamap) {
				this.create_areamap();
				return;
			}

			var areamap_data = {
				zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
				markers_path: this._current_nh ? this._current_nh.data[this.type][this.currency].map_markers_path : this.options.map_markers_path,
				data: sorted_data
			};

			this.areamap.data = areamap_data;
			this.areamap.reset_map();

			this._veil.hide();
		} else {
			this.display_message(true);
		}
	},

	display_heatmap: function display_heatmap() {
		var self = this;
		this.display_message(false);

		var data = [];

		Object.each(this.sorted_data, function (el, i) {
			if (el && el.length > 0 && self.beds_status[i - 10]) {
				Object.each(el, function (e) {
					if (e.display) data.push(e);
				});
			}
		});

		if (!this.heatmap) {
			this._veil.show();

			this.create_heatmap(data);
		} else {
			this.reset_heatmap(data);
		}
	},

	create_heatmap: function create_heatmap(data) {
		if (data.length > 0) {
			var self = this;

			var heatmap_data = {
				zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
				radius: 15,
				opacity: this._current_nh ? this._current_nh.data[this.type][this.currency].heatmap_opacity : this.options.map_markers_path,
				data: data
			};

			this.heatmap = new NhStatsHeatMap(self._heatmap_cont, {
				data: heatmap_data,
				// onNoData: function(){ self.show_error(_el); },
				onReady: function onReady() {
					self._veil.hide();
				}
			});
		} else {
			this.display_message(true);
		}
	},

	reset_heatmap: function reset_heatmap(sorted_data) {
		var sorted_data = sorted_data || Object.clone(this.current_sorted_data);

		this._beds.each(function (_el) {
			sorted_data.each(function (el) {
				el.display_on_map = _el.hasClass('_selected');
			});
		});

		if (!this.heatmap) {
			this.create_heatmap(sorted_data);
			return;
		}

		var heatmap_data = {
			zoom: this._current_nh ? this._current_nh.data[this.type][this.currency].map_zoom : this.options.map_zoom,
			radius: 15,
			opacity: this._current_nh ? this._current_nh.data[this.type][this.currency].heatmap_opacity : this.options.map_markers_path,
			data: sorted_data
		};

		this.heatmap.data = heatmap_data;
		this.heatmap.add_heatmap_layer();
	},

	display_listview: function display_listview() {
		var self = this;
		this.display_message(false);

		var data = [];

		Object.each(this.sorted_data, function (el, i) {
			if (el && el.length > 0 && self.beds_status[i - 10]) {
				Object.each(el, function (e) {
					if (e.display) data.push(e);
					e.bedroom_id = i;
				});
			}
		});

		this.create_listview(data);
	},

	create_listview: function create_listview(data) {
		var self = this;

		this._veil.show();

		self._listview_cont.empty();
		self._trs = [];

		var _divtable = new Element('div', { 'class': 'w_divtable clearfix' });
		var _thead = '<div class="thead">' + '<div class="tr">' + '<div class="th building_name">Building / Address</div>' +
		//'<div class="th size">size</div>' +
		'<div class="th closing_price">Closing Price</div>' + '<div class="th closing_date"> Closing Date</div>' + '</div>' + '</div>';

		_divtable.set('html', _thead);

		var _tbody = new Element('div', { 'class': 'tbody w_styled_scroll' }).inject(_divtable);
		var nothing_to_show = true;

		var sorted_by_date = self.sort_by_date(data);

		sorted_by_date.each(function (e, i) {
			if (!e.display) return;

			nothing_to_show = false;

			var color;

			switch (e.bedroom_id.toInt()) {
				case 10:
					color = 0;
					break;
				case 11:
					color = 1;
					break;
				case 12:
					color = 2;
					break;
				case 13:
					color = 3;
					break;
				default:
					color = 4;
			}

			var _tr = new Element('div', {
				'class': 'tr',
				'data-href': e.url_sold,
				styles: {
					'border-left': '6px solid ' + self.options.graph_colors[color]
				}
			}).inject(_tbody);

			_tr.addEvent('click', function () {
				self.fireEvent('seriesClick');
			});

			var _td_building = new Element('.td.building_name');
			var _td_closing_price = new Element('.td.closing_price');
			var _td_closing_date = new Element('.td.closing_date');

			var building_text = '<span>' + (e.name || e.street_address) + ', </span><span class="unit"> Apt ' + e.unit + '</span><br>' + (e.name != null ? e.street_address : '');

			var closing_price_text = '<span>' + e.sale_price_format + '</span><br> Approx. ' + e.ppsqft_format + ' / ft <sup>2</sup>';
			var closing_date_text = '<span>' + e.sale_date + '</span>';

			_td_building.set('html', building_text).inject(_tr);
			_td_closing_price.set('html', closing_price_text).inject(_tr);
			_td_closing_date.set('html', closing_date_text).inject(_tr);

			self._trs.push(_tr);
		});

		if (!nothing_to_show) {
			_divtable.inject(self._listview_cont);
			self._listview_cont.show();

			new Divtable(_divtable, { 'zebra_order': 'odd' });

			if (self._trs.length > 9) {
				_divtable.addClass('on_scroll');
				new StyledScroll(_tbody, { type: 'v', max_height: self.set_max_height() });
			}
		} else {
			self._listview_cont.hide();
			self.display_message(true);
		}

		self._veil.hide();
	},

	sort_by_date: function sort_by_date(data) {
		var sorted_by_date = data.sort(function (a, b) {
			return new Date(a.sale_date).set({ sec: 0, ms: 0 }).format("%s") > new Date(b.sale_date).set({ sec: 0, ms: 0 }).format("%s") ? -1 : 1;
		});

		return sorted_by_date;
	},

	set_max_height: function set_max_height() {
		var self = this;
		var max_height = 0;

		self._trs.each(function (_tr, i) {
			if (i < 10) {
				max_height += _tr.getComputedSize().height; //_tr.offsetHeight;//_tr.getSize().y
			}
		});

		return max_height + 20;
	},

	display_message: function display_message(show) {
		var _cont;

		this._menu_togglers.each(function (_el) {
			if (_el.hasClass('_active')) {
				_cont = _el._cont;
				return;
			}
		});

		if (show) {
			this._warning.hide();
			var message = 'No data available for ' + (this.current_nh && this.current_nh.toLowerCase() != 'all' ? this.current_nh : this._clicked_cat.get('text')) + '<br/>for the period of ' + this.date_min_formatted + ' - ' + this.date_max_formatted + '<br/>Try to increase the date range.';

			this._message.set('html', message);

			_cont.hide();
			this._veil.hide();
			this._message.show();
			this.message_displayed = true;
		} else {
			_cont.show();
			this._message.hide();
			this.message_displayed = false;
		}
	},

	move_rangeselector: function move_rangeselector() {
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft,
				    topPosition = this.chart.plotTop - 25,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 200,
					y: topPosition
				});

				leftPosition += this.zoomText.getBBox().width + 200;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition,
						y: topPosition - 14
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	},

	get_rangedate: function get_rangedate() {
		var url = new URI(window.location.href);
		if (url.getData('date_from') && url.getData('date_to')) {
			this.min_date = url.getData('date_from');
			this.max_date = url.getData('date_to');
		}
	},

	set_rangeselector: function set_rangeselector() {
		var url = new URI(window.location.href);
		if (url.getData('date_from') && url.getData('date_to')) {
			this.chart.xAxis[0].setExtremes(new Date(url.getData('date_from')), new Date(url.getData('date_to')));
		}
	},

	sort: function sort(series) {
		series.sort(function (a, b) {
			if (a[0] < b[0]) return -1;
			if (a[0] > b[0]) return 1;
			return 0;
		});

		// return series;
	}
});
'use strict';

var NhStatsExt = new Class({
	Extends: NhStats,

	options: {
		data: null,
		_veil: null,
		map_zoom: 13,
		map_markers_path: null,
		graph_colors: {
			10: '#b19f00',
			11: '#018f9b',
			12: '#b4224a',
			13: '#484a67',
			14: '#ff5a00'
		}
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.' + this.options.cls);

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		this._graph_cont = this._element.getElement('.graph');
		this._areamap_cont = this._element.getElement('.areamap');
		this._heatmap_cont = this._element.getElement('.heatmap');

		this._graph_stat = this._element.getElement('.w_graph_stat');
		this._summary = this._element.getElement('.w_graph_summary');
		this._period_select = this._element.getElement('.w_styled_select._period select');
		this._currency_select = this._element.getElement('.w_styled_select._currencies select');
		this.currency = this._currency_select.getElement(':selected').get('value');
		this._veil = this.options._veil;
		this.inactive_series_type = [];
	},

	display_graph: function display_graph() {
		var self = this;
		var series = [];

		this.display_message(false);

		Object.each(self.data.sales, function (el, i) {
			if (el && el.length > 0) {
				var data_series = [];

				Object.each(el, function (e) {
					data_series.push([e.x, e.y, e.name, e.tooltip, e.url_sold]);
				});

				if (data_series.length > 0) {
					series.push({
						name: el[0].bedroom.toInt() >= 4 ? '4+ Bedrooms' : el[0].bedroom,
						color: self.options.graph_colors[i],
						data: data_series,
						marker: {
							symbol: 'circle',
							radius: 8
						}
					});
				}
			}
		});

		if (!this.chart) {
			this.create_graph(series);
		} else {
			self.fireEvent('ready');
		}
	},

	create_graph: function create_graph(series) {
		var self = this;

		if (series.length > 0) {
			this.graph = new Highcharts.Chart({
				chart: {
					renderTo: self._graph_cont,
					type: 'scatter',
					zoomType: 'xy',
					plotBackgroundColor: '#666',
					backgroundColor: '#666',
					plotBorderWidth: 1,
					plotBorderColor: '#aaa',
					// marginTop: 20,
					marginBottom: 190,
					marginLeft: 35,
					resetZoomButton: {
						theme: {
							fill: '#585858',
							stroke: 'silver',
							style: {
								color: '#fff'
							},
							r: 0,
							states: {
								hover: {
									fill: '#41739D',
									style: {
										color: 'white'
									}
								}
							}
						}
					}
				},

				credits: {
					enabled: false
				},

				title: {
					text: null
				},

				xAxis: {
					// min: 0,

					minRange: 2,
					minTickInterval: 0.5,
					// minPadding: 0,
					maxPadding: 0,
					gridLineWidth: 1,
					gridLineColor: '#aaa',
					gridLineDashStyle: 'dash',
					tickWidth: 0,
					showEmpty: false,

					// showFirstLabel: false,
					// showLastLabel: true,

					// gridLineWidth: 1,
					// gridLineColor: '#e0e0e0',
					title: {
						useHTML: true,
						text: 'Apartment Size (In Square Feet)',
						margin: 20,
						style: {
							color: '#bbb'
						}
					},
					labels: {
						useHTML: true,
						overflow: 'justify',
						// formatter: function() {
						//	 return Highcharts.numberFormat(this.value, ((opts.xAxis_copy == 'Bathrooms')? 1 : 0));
						// },
						style: {
							color: '#ccc',
							fontWeight: 'normal'
						},
						formatter: function formatter() {
							return Core.add_commas(this.value) + ' ft<sup>2</sup>';
						}
					}
				},

				yAxis: {
					type: 'logarithmic',

					gridLineColor: '#aaa',
					gridLineDashStyle: 'dash',

					showFirstLabel: false,
					showLastLabel: false,

					minPadding: 0.05,
					maxPadding: 0,

					title: {
						useHTML: true,
						text: 'Closing Price / Ft<sup>2</sup>',
						margin: 25,
						x: 4,
						style: {
							color: '#bbb'
						}
					},
					labels: {
						//useHTML: true,
						align: 'left',
						x: 3,
						y: -4,
						formatter: function formatter() {
							var currency_code = self.currency;
							var currency_symbol = Core.get_html_text(self.data.currency_symbol);

							if (currency_code == 'RUB') {
								return Core.add_commas(this.value) + ' ' + currency_symbol;
							} else if (currency_code == 'XAU') {
								return Highcharts.numberFormat(this.value, 2) + ' ' + currency_symbol;
							}

							return currency_symbol + Core.add_commas(this.value);
						},
						style: {
							color: '#ccc',
							fontWeight: 'normal',
							whiteSpace: 'nowrap'
						}
					}
				},

				tooltip: {
					formatter: function formatter() {
						var index;
						if (this.point.dataGroup) {
							index = this.point.dataGroup.start;
						} else {
							index = this.point.index;
						}

						var content = this.point.series.options.data[index][3];

						if (this.point.dataGroup && this.point.dataGroup.length > 1) {
							content += '<br><br><i class="note">Note: This is Average Closing Price.</i>';
						}

						return content;
					},
					snap: 30,
					useHTML: true
				},

				legend: {
					enabled: false
				},

				plotOptions: {
					scatter: {
						marker: {
							symbol: 'circle',
							radius: 8,
							states: {
								hover: {
									enabled: true,
									lineColor: 'rgb(100,100,100)'
								}
							}
						},
						states: {
							hover: {
								marker: {
									enabled: false
								}
							}
						},
						events: {
							legendItemClick: function legendItemClick(e) {
								var data = {};
								var counter = 0;

								(function () {
									Object.each(self.data.sales, function (el, i) {
										if (!el && !el.length > 0) return;

										if (counter != e.target._i && !self.inactive_series_type.contains(i)) {
											data[i] = el;
										} else if (counter == e.target._i && self.inactive_series_type.contains(i) && e.target.visible == true) {
											data[i] = el;
											self.inactive_series_type.erase(i);
										} else {
											if (!self.inactive_series_type.contains(i)) {
												self.inactive_series_type.push(i);
											}
										}
										counter++;
									});

									self.set_summary(data);
								}).delay(200, self);
							}
						}
					},

					series: {
						cursor: 'pointer',
						point: {
							events: {
								click: function click() {
									var index;

									if (this.dataGroup) {
										index = this.dataGroup.start;
									} else {
										index = this.index;
									}

									var url = this.series.options.data[index][4];

									if (url) {
										window.location = url;
									}
								}
							}
						}
					}
				},

				series: series
			}, function (chart) {
				self.fireEvent('ready');
			});
		} else {
			this.display_message(true);
		}
	},

	display_areamap: function display_areamap() {
		var self = this;
		this.display_message(false);

		var data = [];

		Object.each(self.data.sales, function (el, i) {
			if (el && el.length > 0) {
				Object.each(el, function (e) {
					e.display = true;
					data.push(e);
				});
			}
		});

		if (!this.areamap) {
			this.create_areamap(data);
		} else {
			self.fireEvent('ready');
		}
	},

	display_heatmap: function display_heatmap() {
		var self = this;
		var data = [];

		this.display_message(false);

		Object.each(self.data.sales, function (el, i) {
			if (el && el.length > 0) {
				Object.each(el, function (e) {
					e.display = true;e.display = true;
					data.push(e);
				});
			}
		});

		if (!this.heatmap) {
			this.create_heatmap(data);
		} else {
			self.fireEvent('ready');
		}
	},

	set_summary: function set_summary(data_series) {
		var self = this;
		var total_sales = 0;
		var avg_ppsqft = 0;
		var avg_price = 0;
		var median_price = 0;
		var median_prices_array = [];
		var most_expensive, least_expensive;
		var sales_data = data_series || self.data.sales;

		// var cs = (this.currency_symbol.length > 1)? '' : this.currency_symbol;
		this.currency_symbol = Core.get_html_text(self.data.currency_symbol);
		var cs = this.currency_symbol;

		//if(this.sorted_data){
		Object.each(sales_data, function (el, i) {
			if (el && el.length > 0) {

				Object.each(el, function (e) {
					var price = (e.sale_price || 0).toFloat();

					total_sales++;
					avg_ppsqft += (e.ppsqft || 0).toFloat();
					avg_price += price;
					median_prices_array.push(price);

					if (!most_expensive || price > most_expensive.sale_price.toFloat()) {
						most_expensive = e;
					}

					if (!least_expensive || price < least_expensive.sale_price.toFloat()) {
						least_expensive = e;
					}
				});
			}
		});

		if (total_sales > 0) {
			avg_ppsqft /= total_sales;
			avg_price /= total_sales;

			if (this.currency.toLowerCase() == 'rub' || this.currency.toLowerCase() == 'xau') {
				if (avg_ppsqft > 0) avg_ppsqft = Core.add_commas(avg_ppsqft.round(avg_ppsqft < 100 ? 2 : 0)) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
				if (avg_price > 0) avg_price = Core.add_commas(avg_price.round(0)) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
			} else {
				if (avg_ppsqft > 0) avg_ppsqft = cs + Core.add_commas(avg_ppsqft.round(avg_ppsqft < 100 ? 2 : 0));
				if (avg_price > 0) avg_price = cs + Core.add_commas(avg_price.round(0));
			}

			if (median_prices_array.length > 0) {
				median_prices_array = median_prices_array.sort(function (a, b) {
					return a - b;
				});

				if (median_prices_array.length % 2 == 0) {
					median_price = ((median_prices_array[median_prices_array.length / 2] + median_prices_array[median_prices_array.length / 2 - 1]) / 2).round(0);
				} else {
					median_price = median_prices_array[(median_prices_array.length / 2).floor()].round(0);
				}

				if (this.currency.toLowerCase() == 'rub' || this.currency.toLowerCase() == 'xau') {
					median_price = Core.add_commas(median_price) + '<span style="display: inline; text-transform: lowercase; font-size: 75%"> ' + cs + '</span>';
				} else {
					median_price = cs + Core.add_commas(median_price);
				}
			}

			if (total_sales > 500) {
				//self._warning.show();
			} else {
					//self._warning.hide();
				}
		}
		//}
		var period = this._period_select.getElement(':selected').get('text');
		this._summary.getElement('.period').set('text', period + ':');

		this._summary.getElement('#total_sales').set('html', total_sales);

		var _avg_price_ft = this._summary.getElement('#avg_price_ft');
		_avg_price_ft.set('html', avg_ppsqft);

		if (_avg_price_ft.get('text').length > 8) {
			_avg_price_ft.addClass('_small');
		} else {
			_avg_price_ft.removeClass('_small');
			_avg_price_ft.removeClass('_supersmall');
		}

		if (_avg_price_ft.get('text').length > 11) {
			_avg_price_ft.addClass('_supersmall');
		}

		var _avg_price = this._summary.getElement('#avg_price');
		_avg_price.set('html', avg_price);

		if (_avg_price.get('text').length > 8) {
			_avg_price.addClass('_small');
		} else {
			_avg_price.removeClass('_small');
			_avg_price.removeClass('_supersmall');
		}

		if (_avg_price.get('text').length > 11) {
			_avg_price.addClass('_supersmall');
		}

		var _med_price = this._summary.getElement('#med_price');
		_med_price.set('html', median_price);

		if (_med_price.get('text').length > 8) {
			_med_price.addClass('_small');
		} else {
			_med_price.removeClass('_small');
			_med_price.removeClass('_supersmall');
		}

		if (_avg_price.get('text').length > 11) {
			_med_price.addClass('_supersmall');
		}

		this._summary.removeClass('_loading');

		if (most_expensive) {
			var me = '';

			if (most_expensive.image) {
				me += '<a href="' + most_expensive.url_sold + '"  class="image" style="background-image:url(' + (most_expensive.image.t || most_expensive.image.o) + ')"></a>';
			}

			me += '<strong>Most Expensive</strong><br>' + '<a href="' + most_expensive.url_sold + '">' + (most_expensive.name || most_expensive.display_name || most_expensive.street_address) + ', <span class="unit">#' + most_expensive.unit + '</span></a><br/>' + most_expensive.bedroom.split('room').join('') + ' | ' + most_expensive.sale_price_format + '<br>' + most_expensive.ppsqft_format + ' / ft<sup>2</sup>' + '<br/>' + '<span> Closed: ' + most_expensive.sale_date + '</span>';

			this._most_expensive = this._summary.getElement('#most_exp');
			this._most_expensive.set('html', me);

			this._summary.getElement('#most_exp').show();
		} else {
			this._summary.getElement('#most_exp').hide();
		}

		if (least_expensive) {
			var le = '';

			if (least_expensive.image) {
				le += '<a href="' + least_expensive.url_sold + '" class="image" style="background-image:url(' + (least_expensive.image.t || least_expensive.image.o) + ')"></a>';
			}

			le += '<strong>Least Expensive</strong><br>' + '<a href="' + least_expensive.url_sold + '">' + (least_expensive.name || least_expensive.display_name || least_expensive.street_address) + ', <span class="unit">#' + least_expensive.unit + '</span></a><br/>' + least_expensive.bedroom.split('room').join('') + ' | ' + least_expensive.sale_price_format + '<br>' + least_expensive.ppsqft_format + ' / ft<sup>2</sup>' + '<br/>' + '<span> Closed: ' + least_expensive.sale_date + '</span>';

			this._least_expensive = this._summary.getElement('#least_exp');
			this._least_expensive.set('html', le);

			// this._least_expensive.addEvent('click',function(){
			//	 window.location = least_expensive.url_building;
			// })

			// this._summary.getElement('#least_exp').set('html', le);
			this._summary.getElement('#least_exp').show();
		} else {
			this._summary.getElement('#least_exp').hide();
		}
	},

	display_message: function display_message(show) {
		var _cont;

		if (show) {
			var nh_name = this._element.get('data-neighborhood');

			new Element('div', {
				class: 'error',
				html: 'No data available for ' + nh_name + '. <span>Please try to modified the filter.</span>'
			}).inject(this._graph_stat);

			this._graph_stat.getElement('._active').hide();

			this._veil.hide();

			this.message_displayed = true;
		} else {

			var _message = this._graph_stat.getElement('.error');
			if (!_message) return;

			this._graph_stat.getElement('._active').show();

			_message.destroy();

			this.message_displayed = false;
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var NhStatsAreaMap = new Class({
	Extends: HoodsAreaMap,
	options: {
		use_marker_path: null
	},

	get_data: function get_data() {
		var self = this;
		if (self.options.data != '') {
			self.data = self.options.data;
			self.process_rpc();
		} else {
			return;
		}
	},

	process_rpc: function process_rpc() {
		var opts = this.options,
		    data = this.data,
		    self = this;

		var new_data = {};

		data.data.each(function (el) {
			if (!new_data[el.building_id]) {
				new_data[el.building_id] = [];
			}

			if (el.display) {
				new_data[el.building_id].push(el);
			}
		});

		var num_of_markers = 0;

		Object.each(new_data, function (place) {
			if (place.length > 0) {

				if (!self.in_new_york(place[0].lat, place[0].lng)) return;

				var icon;

				if (self.options.use_marker_path) {
					icon = data.markers_path + '/bed-markers/' + (place.length > 5 ? '5' : place.length) + '_beds_12.png';
				} else {
					icon = Res_i + '/w/hoods/hood-markers/' + (place.length > 100 ? '100+' : place.length) + '.png';
				}

				self.add_marker({
					lat: place[0].lat,
					lng: place[0].lng,
					icon: icon,
					bubble: {
						content: (place[0].name || place[0].display_name || place[0].street_address || 'Unknown building') + '<span class="legend">Click on marker for more info</span>'
					},
					label: {
						content: null
					},
					base_point: 'center',
					callbacks: {
						onClick: function onClick() {
							opts.open_blimp(place[0].url_popup);
						}
					}
				});

				num_of_markers++;
			}
		});

		if (num_of_markers > 0) {
			this.fit_markers();
		} else {
			this.center_map_in_ny();
		}

		(function () {
			this.fireEvent('ready');
		}).bind(this).delay(1000);
	},

	center_map_in_ny: function center_map_in_ny() {
		var lat = 40.7646;
		var lng = -73.9777;

		var center = new google.maps.LatLng(lat, lng);

		this.map.setCenter(center);
	},

	reset_map: function reset_map() {
		this.clear_markers();
		this.process_rpc();
	},

	in_new_york: function in_new_york(lat, lng) {
		//some properties have wrong coordinates, that's why it's needed to be verified
		// return true;
		if (!lat || !lng) return false;

		return lat < 41.2 && lat > 40.4 && lng < -73.1 && lng > -74.4;
	}
});
'use strict';

/*
--- 
description: FED Process
authors: 
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var NhStatsHeatMap = new Class({
	Extends: HoodsHeatMap,

	draw_map: function draw_map() {
		var zoom = this.data.zoom || 13;

		this.map = new google.maps.Map(this._element, {

			zoom: zoom,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});

		this.map.setOptions({ styles: this.options.map_styles });

		this.add_heatmap_layer();
	},

	add_heatmap_layer: function add_heatmap_layer() {
		var self = this;
		var data = this.data;
		var new_data = {};
		var data_empty = true;

		Object.each(data.data, function (el) {
			// el.each(function(e){
			if (!new_data[el.building_id]) {
				new_data[el.building_id] = [];
			}

			if (el.display) {
				new_data[el.building_id].push(el);
				data_empty = false;
			}
			// });
		});

		this.data.data = new_data;

		var heatmapData = [];

		Object.each(new_data, function (el) {

			if (el[0]) {

				if (!self.in_new_york(el[0].lat, el[0].lng)) return;

				var obj = { location: new google.maps.LatLng(el[0].lat, el[0].lng), weight: el.length };
				heatmapData.push(obj);
			}
		});

		if (this.heatmap) this.heatmap.setMap(null);

		var heatmap = this.heatmap = new google.maps.visualization.HeatmapLayer({
			data: heatmapData,
			radius: data.radius ? data.radius : 20
		});

		heatmap.setMap(this.map);

		var lat = 0,
		    lng = 0,
		    num_of_points = 0;

		Object.each(new_data, function (el) {
			if (el.length > 0) {
				if (!self.in_new_york(el[0].lat, el[0].lng)) return;

				lat += el[0].lat.toFloat();
				lng += el[0].lng.toFloat();
				num_of_points++;
			}
		});

		if (num_of_points > 0) {
			lat = lat / num_of_points;
			lng = lng / num_of_points;
		} else {
			lat = 40.7646;
			lng = -73.9777;
		}

		var center = new google.maps.LatLng(lat, lng);

		this.map.setCenter(center);
		// this.change_gradient();
		this.change_opacity();

		(function () {
			this.fireEvent('ready');
		}).bind(this).delay(1000);
	},

	change_opacity: function change_opacity() {
		this.heatmap.setOptions({ opacity: this.heatmap.get('opacity') ? null : 0.7 });
	},

	in_new_york: function in_new_york(lat, lng) {
		//some properties have wrong coordinates, that's why it's needed to be verified
		// return true;
		if (!lat || !lng) return false;

		return lat < 41.2 && lat > 40.4 && lng < -73.1 && lng > -74.4;
	}
});
'use strict';

/*
---
description: FED Process
authors:
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.5: '*'
...
*/

var Photogallery = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_photogallery',
		first_image: null,
		width_by_thumbs: 5, //has to be odd or 0 if thumbs are hidden
		animate: false, //use for slideshow
		scroll_speed: 200,
		in_popup: false,
		no_fullscreen_opt: false, //no fullscreen option if true
		no_enlarge_opt: true, //no fullscreen option if true
		thumbs: null, //used for full screen gallery
		show_controllers: false, //always display controllers
		single_img_cls: '',
		fs_class: 'fs', //class for fullscreen,
		en_class: 'en', //class for enlarge screen
		thumbnail_mode: false, //gallery needs class _thumbnails,
		missing_img: null,
		videos: false,
		dont_adjust_img_css: null,
		onFsClose: function onFsClose() {}
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;
		this.cls = this.options.cls;

		if (this._element) {
			this.build();
			this.adaFix();
		}
	},

	adaFix: function adaFix() {
		this._element.setAttribute('aria-label', 'carousel');
		this._element.setAttribute('role', 'region');
	},

	build: function build() {
		var fcls = '.' + this.cls;

		this.is_touched = false;
		this.normal_mode = true;
		this.fullscreen_mode = false;
		this.enlarge_mode = false;
		this._main = this._element.getElement(fcls + '_main');
		if (this.options.videos) {
			this._main.addClass('videos');
		}
		this._bottom = this._element.getElement(fcls + '_bottom');
		this._strip = this._element.getElement(fcls + '_strip');
		this._thumbs = this.options.thumbs || this._strip.getElements('.thumb');

		if (!this._thumbs || this._thumbs.length == 0) {
			this._element.dispose();
			return;
		}

		var error_img_url = this.options.missing_img ? this.options.missing_img : Res_i + '/l/missing_big.png';

		this._thumbs.each(function (_el) {
			if (_el.getAttribute('type') === 'video') {
				_el._full_img = new Element('iframe', {
					class: 'iframe-fullscreen',
					'src': Res_i + '/l/dummy.png',
					'allowfullscreen': 1,
					'onerror': 'this.src=\'' + error_img_url + '\''
				});
			} else {
				_el._full_img = new Element('img', {
					'src': Res_i + '/l/dummy.png',
					'onerror': 'this.src=\'' + error_img_url + '\''
				});
			}

			_el._full_cont = new Element('div', {
				'class': 'img_transition'
			}).adopt(_el._full_img);

			_el._full_cont.inject(this._main);

			var url = _el.getElement('img') ? _el.getElement('img').getAttribute('data-url') : null;

			if (url) {
				_el._full_cont.setStyle('cursor', 'pointer');

				_el._full_cont.addEvent('click', function () {
					window.location = url;
				});
			}
		}.bind(this));

		if (this._thumbs && this._thumbs.length < this.options.width_by_thumbs) {
			var dummies_amount = this.dummies_amount = this.options.width_by_thumbs - this._thumbs.length;

			for (var i = 0; i < dummies_amount; i++) {
				new Element('div', { 'class': 'thumb _dummy', 'html': '&nbsp;' }).inject(this._strip);
			}
		}

		var _controllers = this._main.getElement(fcls + '_controllers');

		if (_controllers && this.options.show_controllers) {
			_controllers.show();
		}

		this._arrow_previous = this._main.getElement(fcls + '_arrow_previous');
		this._arrow_next = this._main.getElement(fcls + '_arrow_next');
		this._fullscreen = this._main.getElement(fcls + '_fullscreen');
		this._enlarge = this._main.getElement(fcls + '_enlarge');
		this._thumbs_left = this._element.getElement(fcls + '_bottom .move_left');
		this._thumbs_right = this._element.getElement(fcls + '_bottom .move_right');
		this._image_counter = this._element.getElement(fcls + '_image_counter');

		this._progress = new Element('div', {
			'class': 'ajax_loader',
			'html': '&nbsp;'
		});

		this._progress.inject(this._main, 'top');

		this.current_cont = 0;
		this.to_center = true;

		this.set_appearance();
		this.set_functionality();

		if (this.options.thumbnail_mode) this.set_thumb_mode();

		if (this._element.hasClass('_slide')) {
			this.move_caption();
		}
	},
	set_thumb_mode: function set_thumb_mode() {
		var self = this;
		var fcls = '.' + this.cls;
		var _enlarges = this._element.getElements(fcls + '_thumb .thumb .w_photogallery_enlarge');

		if (_enlarges.length > 0) {
			_enlarges.each(function (el) {
				el.addEvent('click', function () {
					self.select_thumb(parseInt(el.getParent().getAttribute('data-key')));
					self.go_fullscreen_mode(self.options.en_class);
				});
			});
		}
	},
	set_appearance: function set_appearance() {
		var opts = this.options;

		if (opts.first_image && opts.first_image != '') {
			this._thumbs[0]._full_img.setProperty('src', opts.first_image);
			this._thumbs[0]._full_cont.fade('show');
		}

		if (opts.width_by_thumbs % 2 == 1) {
			this.margin = this._thumbs[0].getStyle('margin-left').toInt() + this._thumbs[0].getStyle('margin-right').toInt();
			this.thumb_width = this._thumbs[0].getSize().x;
			this.strip_width = (this.thumb_width + this.margin) * (this._thumbs.length + (this.dummies_amount || 0)) - this._thumbs[0].getStyle('margin-left').toInt();

			this.main_width = (this.thumb_width + this.margin) * opts.width_by_thumbs - this._thumbs[0].getStyle('margin-left').toInt();

			this._thumbs[0].setStyle('margin-left', 0);

			this._strip.setStyles({
				'width': this.strip_width,
				'left': 0
			});
		} else {
			this.main_width = this._main.getSize().x;

			var _bottom = this._element.getElement('.' + opts.cls + '_bottom');

			if (_bottom) {
				_bottom.hide();
				this._element.addClass('_no_thumbnails');
			}
		}

		if ((this.main_width == 0 || this.main_width == null) && opts.width) {
			this.main_width = opts.width;
		}

		// NCR-6855
		// if(this.main_width > 0 && opts.in_popup && !opts.fullscreen){
		// this._element.setStyle('width', this.main_width);
		// }

		if (opts.no_fullscreen_opt) {
			this._fullscreen.hide();
		}

		if (opts.no_enlarge_opt && this._enlarge) {
			this._enlarge.hide();
		}

		this.main_height = this._main.getSize().y;

		if (opts.fullscreen) {
			this.img_cont_width = '100%';
			this.img_cont_height = '100%';
			this.main_height = '100%';
		} else {
			var _cont = this._thumbs[0]._full_cont;

			this.img_cont_width = this.main_width - _cont.getParent().getStyle('padding-left').toInt() * 2 - _cont.getParent().getStyle('border-width').toInt() * 2;
			this.img_cont_height = this.main_height - _cont.getParent().getStyle('padding-top').toInt() * 2 - _cont.getParent().getStyle('border-width').toInt() * 2;
		}

		var zi_1 = this._thumbs[0]._full_cont.getStyle('z-index').toInt();

		this._progress.setStyle('z-index', zi_1 + 1);
		this._progress.fade('hide');

		this._thumbs.each(function (_el, i) {
			_el.addEvent('click', function () {
				this.to_center = false;
				this.select_thumb(i);
			}.bind(this));
		}.bind(this));

		this.thumbs_arrows_set_class();
	},

	set_functionality: function set_functionality() {
		var self = this;

		this._main.addEvents({
			'mouseenter': function mouseenter() {
				self._main.addClass('_active');
			},

			'mouseover': function mouseover() {
				self._main.addClass('_active');
			},

			'mouseout': function mouseout() {
				self._main.removeClass('_active');
			},

			'click': function click() {
				var url = self._element.get('data-url') || self._thumbs[self.current_img].get("data-url");

				if (!url) return;

				window.location = url;
			}
		});

		if (this._fullscreen && !this.options.no_fullscreen_opt) {
			this._fullscreen.addEvents({
				'click': function (e) {
					if (e && e.stop) e.stop();
					if (self.fullscreen_mode) {
						this.go_normal_mode();
					} else {
						this.go_fullscreen_mode(this.options.fs_class);
					}
				}.bind(this),

				'touchstart': function touchstart(e) {
					if (e && e.stop) e.stop();

					self._fullscreen.fireEvent('click');
					return false;
				}
			});
		}

		if (this._enlarge && !this.options.no_enlarge_opt) {
			this._enlarge.addEvents({
				'click': function (e) {
					if (e && e.stop) e.stop();

					if (self.fullscreen_mode) {
						this.go_normal_mode();
					} else {
						this.go_fullscreen_mode(this.options.en_class);
					}
				}.bind(this),

				'touchstart': function touchstart(e) {
					if (e && e.stop) e.stop();

					self._enlarge.fireEvent('click');
					return false;
				}
			});
		}

		if (this._thumbs.length == 1) {
			this.hide_controllers();
			this._element.addClass(this.options.single_img_cls);
			return;
		}

		this._thumbs.each(function (_el) {
			var _first_img = _el._full_img;

			_first_img.addEvent('load', function () {
				self.fireEvent('firstImageLoad');
			});
		});

		this.select_thumb(0);

		if (this._thumbs.length > 1) {
			this._arrow_previous.addEvents({
				'click': function (e) {
					if (e && e.stop) e.stop();

					this.to_center = true;
					this.select_thumb(this.previous_img);
				}.bind(this),

				'touchstart': function touchstart(e) {
					if (e && e.stop) e.stop();

					self._arrow_previous.fireEvent('click');
					return false;
				}
			});

			this._arrow_next.addEvents({
				'click': function (e) {
					if (e && e.stop) e.stop();

					this.to_center = true;
					this.select_thumb(this.next_img);
				}.bind(this),

				'touchstart': function touchstart(e) {
					if (e && e.stop) e.stop();

					self._arrow_next.fireEvent('click');
					return false;
				}
			});

			if (this._thumbs.length > this.options.width_by_thumbs) {
				this._thumbs_left.addEvent('click', function (e) {
					if (e && e.stop) e.stop();

					this.to_center = false;
					this.move_thumbs('left');
				}.bind(this));

				this._thumbs_right.addEvent('click', function (e) {
					if (e && e.stop) e.stop();

					this.to_center = false;
					this.move_thumbs('right');
				}.bind(this));

				this.move_strip = new Fx.Morph(this._strip, {
					link: 'ignore',
					duration: this.options.scroll_speed
				});
			} else {
				this._thumbs_left.hide();
				this._thumbs_right.hide();
			}
		}
	},

	thumb_is_preloaded: function thumb_is_preloaded(_thumb) {
		var is_preloaded = _thumb.getAttribute('data-preloaded');
		return is_preloaded == "1";
	},

	select_thumb: function select_thumb(indx) {
		if (typeof indx === 'string') {
			indx = indx.toInt();
		}

		var th = this._thumbs[indx];

		if (indx != 0 && !this.is_touched) {
			this.is_touched = true;
		}

		if (this._previous_thumb && this._previous_thumb !== th) {
			this._previous_thumb.removeClass('current');
		}

		if (this._previous_thumb !== this._thumbs[indx]) {
			th.addClass('current');

			this.load(th);
			this.setImageCounter(indx);

			this._previous_thumb = th;
		}

		if (this.to_center == true && this.options.width_by_thumbs % 2 == 1) {
			this.move_thumbs_auto(indx);
		}

		this.set_next_and_previous_img(indx);
	},

	preload_all: function preload_all(ignore_idx) {
		ignore_idx = ignore_idx || null;

		this._thumbs.each(function (itm, i) {
			if (i == ignore_idx) {
				return;
			}
			itm.setAttribute('data-preloaded', 1);
			new Asset.image(itm.getAttribute('data-full'));
		});
	},

	load: function load(th) {
		var self = this;
		var path = this.fullscreen_mode ? th.getAttribute('data-fullscreen') : th.getAttribute('data-full');

		this.show_image(th, path);
	},

	show_image: function show_image(th, path) {

		var img = th._full_img;
		img.set('src', path);

		var error_img_url = this.options.missing_img ? this.options.missing_img : Res_i + '/l/missing_big.png';
		img.set('onerror', 'this.src = "' + error_img_url + '"');

		if (th.getAttribute('type') !== 'video') {
			if (!this.options.dont_adjust_img_css) {
				this.adjust_img_css(img);
			}
		}

		this.img_transition(th);

		this._current_cont = th._full_cont;

		this.update_caption(th);

		this.fireEvent('showImage');
	},

	adjust_img_css: function adjust_img_css(img) {
		if (!img) return;

		var size = { x: img.width, y: img.height };
		var img_cont_width = this._main.getSize().x;
		var img_cont_height = this._main.getSize().y;

		// get ratio to see if the image is wider or higher
		// if it is wider, set width to 100%
		// if it is higher, set heigh to 100%
		var xRatio = size.x / img_cont_width;
		var yRatio = size.y / img_cont_height;
		if (xRatio >= yRatio) {
			img.setStyles({
				'width': '100%',
				'height': 'auto'
			});
		} else {
			img.setStyles({
				'width': 'auto',
				'height': '100%'
			});
		}
	},

	img_transition: function img_transition(th) {
		if (this._current_cont) {
			this._current_cont.setStyles({
				opacity: 0,
				visibility: 'hidden'
			});
		}

		th._full_cont.setStyles({
			opacity: 1,
			visibility: 'visible'
		});

		this._progress.setStyles({
			opacity: 0,
			visibility: 'hidden'
		});
	},

	go_fullscreen_mode: function go_fullscreen_mode(fullscreen_type) {
		this.save_position();
		this.normal_mode = false;
		if (fullscreen_type == this.options.fs_class) this.show_fs_mode();

		if (fullscreen_type == this.options.en_class) this.show_en_mode();
	},

	show_fs_mode: function show_fs_mode() {

		this.enlarge_mode = false;
		this.fullscreen_mode = true;

		var self = this;
		this._fs_gallery = new Element('div', { 'class': 'w_fs_gallery', 'aria-label': 'modal dialog', 'role': 'region' }).inject(document.body);

		var _gallery_cont = new Element('div', { 'class': 'w_fs_gallery_cont' }).inject(this._fs_gallery);
		var _close = new Element('button', { 'class': 'w_fs_close no-border', 'html': 'Close' }).inject(_gallery_cont);

		_close.addEvent('click', function () {
			self.go_normal_mode();
		});

		this._element.inject(_gallery_cont);
		var th = this._thumbs[this.current_img];
		this.load(th);
		this.removeTabbingRestriction = Core.disableTabbingOutside(this._fs_gallery);
		_close.focus();
	},

	show_en_mode: function show_en_mode() {
		this.enlarge_mode = true;
		this.fullscreen_mode = false;

		var self = this;

		this._veil = new Element('div.w_popup_veil').inject(document.body);

		this._en_gallery = new Element('div.w_en_gallery').inject(document.body);
		var _gallery_cont = new Element('div.w_en_gallery_cont').inject(this._en_gallery);
		var _close = new Element('button', { 'class': 'w_en_close no-style', 'html': '&nbsp;' }).inject(_gallery_cont);

		_close.addEvent('click', function () {
			self.go_normal_mode();
		});

		this._element.inject(_gallery_cont);
		var th = this._thumbs[this.current_img];
		this.load(th);
		this.center_element(this._en_gallery);

		this._enlarge_mode_title = new Element('h3', { 'html': th.getElement('img').get('title') }).inject(_gallery_cont, 'top');

		this.removeTabbingRestriction = Core.disableTabbingOutside(this._en_gallery);
		_close.focus();
	},

	center_element: function center_element(_element) {
		_element.setStyles({
			position: 'absolute'
		});

		var win_scroll = window.getScroll(),
		    win_size = window.getSize(),
		    el_size = _element.getSize();

		var pos_y = win_scroll.y + Math.floor(Math.max(0, (win_size.y - el_size.y) / 2));

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			win_size.x = Math.max(win_size.x, document.getElement('body').offsetWidth);
		}

		var pos_x = win_scroll.x + Math.floor(Math.max(0, (win_size.x - el_size.x) / 2));

		_element.setStyles({
			top: pos_y,
			left: pos_x
		});
	},

	save_position: function save_position() {
		if (this._element.getPrevious()) {
			this._prev_el = this._element.getPrevious();
		} else if (this._element.getNext()) {
			this._next_el = this._element.getNext();
		} else {
			this._parent = this._element.getParent();
		}
	},
	restore_position: function restore_position() {
		if (this._prev_el) {
			this._element.inject(this._prev_el, 'after');
		} else if (this._next_el) {
			this._element.inject(this._next_el, 'before');
		} else {
			this._element.inject(this._parent);
		}
	},

	go_normal_mode: function go_normal_mode() {

		this.restore_position();
		var trigger;
		if (this._fs_gallery) {
			this._fs_gallery.destroy();
			this.fullscreen_mode = false;
			trigger = this._fullscreen;
		}
		if (this._veil) this._veil.destroy();

		if (this._en_gallery) {
			this._en_gallery.destroy();
			this.enlarge_mode = false;
			trigger = this._enlarge;
		}
		this.normal_mode = true;
		var th = this._thumbs[this.current_img];
		this.load(th);
		this.fireEvent('fsClose');

		trigger && trigger.focus();
		this.removeTabbingRestriction();
	},

	animate: function animate() {
		this.select_thumb(this.next_img);
	},

	set_next_and_previous_img: function set_next_and_previous_img(indx) {
		if (typeof indx === 'string') {
			indx = indx.toInt();
		}

		this.current_img = indx;
		if (indx == 0) {
			this.next_img = 1;
			this.previous_img = this._thumbs.length - 1;
		} else if (indx == this._thumbs.length - 1) {
			this.next_img = 0;
			this.previous_img = indx - 1;
		} else {
			this.next_img = indx + 1;
			this.previous_img = indx - 1;
		}
	},

	move_thumbs: function move_thumbs(side) {
		if (side == 'left' && !this._thumbs_left.hasClass('inactive')) {
			var move = this._strip.getStyle('left').toInt() + (this.thumb_width + this.margin);
			if (move > 0) {
				move = 0;
			}
		} else if (side == 'right' && !this._thumbs_right.hasClass('inactive')) {
			var move = this._strip.getStyle('left').toInt() - (this.thumb_width + this.margin);
		}

		if (!this.move_strip) return;

		if (move || move == 0) {
			this.move_strip.start({
				'left': move
			}).chain(function () {
				this.thumbs_arrows_set_class();
			}.bind(this));
		}
	},

	move_thumbs_auto: function move_thumbs_auto(indx) {
		var half = Math.floor(this.options.width_by_thumbs / 2);
		var thumb_to_center;

		if (this.options.width_by_thumbs < this._thumbs.length) {
			if (indx <= half) {
				thumb_to_center = 0;
			} else if (indx >= this._thumbs.length - half - 1) {
				thumb_to_center = this.main_width - this.strip_width;
			} else {
				thumb_to_center = -(this._strip.getSize().x - (this._thumbs.length - indx + half) * (this.thumb_width + this.margin) + this.margin);
			}

			if (this._strip.getSize().x - this.thumb_width * indx < this._bottom.getSize().x) {
				thumb_to_center = -(this._strip.getSize().x - this._bottom.getSize().x);
			}

			if (!this.move_strip || this.strip_width <= this._bottom.getSize().x) {
				return;
			}

			this.move_strip.start({ 'left': thumb_to_center }).chain(function () {
				this.thumbs_arrows_set_class();
			}.bind(this));
		}
	},

	thumbs_arrows_set_class: function thumbs_arrows_set_class() {
		if (!this._strip) return;

		if (this._strip.getStyle('left').toInt() >= 0) {
			this._thumbs_left.addClass('inactive');
		} else {
			this._thumbs_left.removeClass('inactive');
		}

		if (this.strip_width <= this.main_width || this._bottom.getSize().x > this._strip.getSize().x + this._strip.getStyle('left').toInt()) {
			this._thumbs_right.addClass('inactive');
		} else {
			this._thumbs_right.removeClass('inactive');
		}
	},

	hide_controllers: function hide_controllers() {
		this.select_thumb(0);

		if (this._strip) {
			this._strip.getParent().hide();
			this._element.addClass('_no_thumbnails');
		}

		if (this._fullscreen) {
			var _divider = this._arrow_previous.getParent().getElement('.divider');

			if (_divider) {
				_divider.dispose();
			}

			this._arrow_previous.hide();
			this._arrow_next.hide();
		} else if (this._arrow_previous) {
			this._arrow_previous.getParent().hide();
		}
	},

	update_caption: function update_caption(_th) {
		var _caption = this._element.getElement('.' + this.options.cls + '_caption span');

		if (!_caption) return;

		_caption.set('html', _th.getElement('img').get('title'));

		if (this._enlarge_mode_title) this._enlarge_mode_title.set('html', _caption.get('html'));
	},

	move_caption: function move_caption() {
		var _caption = this._element.getElement('.' + this.options.cls + '_caption');

		if (!_caption) return;

		_caption.inject(this._element);
	},

	setImageCounter: function setImageCounter(indx) {
		if (this._image_counter) {
			var current_idx = indx + 1;
			this._image_counter.set('text', current_idx + ' / ' + this._thumbs.length + ' Photos');
		}
	}
});
'use strict';

var RegionSelector = new Class({
	Implements: [Options, Events],

	options: {
		style: 'light',
		dispose_on_click: false,
		follow_url: true
	},

	initialize: function initialize(_element, options) {
		if (!_element) return;

		this._element = _element;
		this.setOptions(options);
		this.build();
	},

	build: function build() {
		var self = this;
		var opts = this.options;
		var _map = this._element.getElement('.map') || new Element('.map').inject(this._element);

		this.map = new RegionsMap(_map, opts);

		this.map.addEvent('mapReady', function () {
			self.draw();
		});
	},

	draw: function draw() {
		var self = this;
		var map = this.map;
		var map_message = this._element.getElement('.map_message');

		this.fx_msg = new Fx.Morph(map_message);

		google.maps.event.addListener(map.map, 'center_changed', function () {
			if (map_message) self.hide_message(map_message);
		});

		google.maps.event.addListener(map.map, 'zoom_changed', this.hide_message);

		this.set_hoods();
	},

	hide_message: function hide_message(msg) {
		if (!this.fx_msg) return;

		this.fx_msg.start({
			opacity: 0
		}).chain(function () {
			msg.dispose();
		});

		this.fx_msg = null;
	},

	select_hood: function select_hood(selected, data) {
		if (this.options.dispose_on_click) {
			this._element.dispose();
		}

		this.fireEvent('hoodSelect', [selected, data]);

		var url = data.url;

		if (this.options.follow_url && url) {
			window.location = url;
		}
	},

	set_hoods: function set_hoods() {
		var _bounds = this._element.getElement('.hoods_bounds');
		if (!_bounds) return;

		var bounds;

		try {
			bounds = JSONMOO.decode(_bounds.get('html'), false);
		} catch (e) {
			return;
		}

		if (typeOf(bounds) == 'object') {
			Object.each(bounds, function (el) {
				if (el.active != false) {
					this.map.set_region(el.name, el.bounds, this.select_hood.bind(this, null, el), false, el);
				}
			}.bind(this));
		} else if (typeOf(bounds) == 'array') {
			bounds.each(function (el) {
				if (el.active != false) {
					this.map.set_region(el.name, el.bounds, this.select_hood.bind(this, null, el), false, el);
				}
			}.bind(this));
		}
	}
});
'use strict';

var SalesData = new Class({
	Implements: [Options, Events],

	options: {
		data: null,
		cls: 'w_sales_data',
		use_cookies: true,
		colors: {
			10: '#b19f00',
			11: '#018f9b',
			12: '#b4224a',
			13: '#484a67',
			14: '#ff5a00'
		},
		shorten_pricerange: false
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);
		this._element = _element || document.getElement('.' + this.options.cls);

		if (!this._element) return;

		this.build();
	},

	build: function build() {
		var self = this;

		this.beds_filter_applied = false;
		this.first_load = true;
		this.is_loaded = false;

		if (this.options.use_cookies) {
			window.addEvent('beforeunload', function (e) {
				// set the cookie only if the chart is initialized.
				if (self.is_loaded) {
					self.write_cookies();
				}
			});

			this.read_cookies();
		} else {
			this.cookies = {};
		}

		this._beds_filter = this._element.getElement('.beds_filter');

		this._veil = this._element.getElement('.veil');
		this._data_display = this._element.getElement('.data_display');
		this._chart = this._element.getElement('.chart');
		this._list = this._element.getElement('.list');

		this._chart.show = function () {
			if (self._element.hasClass('_list_view')) return;

			self._chart.removeClass('_hidden');
		};

		this._chart.hide = function () {
			self._chart.addClass('_hidden');
		};

		this._controllers = this._element.getElement('.data_controllers');

		this.new_currency = true;

		this.rpc = this.add_type_select();

		this.add_currency_select();
		this.add_period_select();
		this.add_beds_select();
		// this.add_listings_select();

		this.get_data();
	},

	add_type_select: function add_type_select() {
		var self = this;

		this._type_select = this._element.getElement('.type_select');

		if (!this._type_select) return;

		var _selected;

		if (this.cookies.type) {
			this._type_select.getElements('option').some(function (_el) {
				if (_el.getAttribute('data-type') == self.cookies.type) {
					_selected = _el;
					_el.fireEvent('select');
					return true;
				}
			});
		}

		this._type_select.addEvents({
			'change': function change(_el) {
				var data_rpc = _el.getAttribute('data-rpc');

				if (data_rpc) {
					self.rpc = data_rpc;
				}

				var _selected = self._type_select.getElement('._selected') || self._type_select.getElement('option:selected');

				if (_selected) {
					self._element.type = _selected.getAttribute('data-type');
				}

				self.get_data();
			}
		});

		_selected = _selected || this._type_select.getElement('._selected') || this._type_select.getElement('option:selected') || this._type_select.getElements('option')[0];

		this._element.type = _selected.getAttribute('data-type');

		return _selected.getAttribute('data-rpc');
	},

	add_currency_select: function add_currency_select() {
		var self = this;

		this._currency_select = this._element.getElement('.w_styled_select._currencies select');

		if (this.cookies.currency) {
			this._currency_select.getElements('option').some(function (_el) {
				if (_el.get('value') == self.cookies.currency) {
					_el.fireEvent('select');
					self.currency = _el.get('value');
					return true;
				}
			});
		}

		if (!this.currency) {
			var _selected = this._currency_select.getElement('option[selected]') || this._currency_select.getElement('option');
			this.currency = _selected.get('value');
		}

		this._currency_select.addEvent('change', function () {
			self.currency = self._currency_select.getElement(':selected').get('value');

			self._element.currency = {
				'id': self.currency,
				'symbol': self.data.currency_symbol
			};

			self.new_currency = true;
			self.get_data();
		});
	},

	add_period_select: function add_period_select() {
		var self = this;

		this._period_select = this._element.getElement('.w_styled_select.period select');

		if (this.cookies.period) {
			this._period_select.getElements('option').some(function (_el) {
				if (_el.get('value') == self.cookies.period) {
					_el.fireEvent('select');
					self.start_date = _el.get('value');
					return true;
				}
			});
		}

		if (!this.start_date) {
			var _selected = this._period_select.getElement('option[selected]') || this._period_select.getElement('option');
			this.start_date = _selected.get('value');
		}

		this._period_select.addEvent('change', function () {
			self.update_section_title();

			self.start_date = self._period_select.getElement(':selected').get('value');
			self.get_data();
		});

		self.update_section_title();
	},

	add_listings_select: function add_listings_select() {
		var self = this;

		this._listings_select = this._element.getElement('.w_styled_select._listings select');

		if (this.cookies.listings) {
			this._listings_select.getElements('option').some(function (_el) {
				if (_el.get('value') == self.cookies.listings) {
					_el.fireEvent('select');
					self.listings_type = _el.get('value');
					return true;
				}
			});
		}

		if (!this.listings_type) {
			var _selected = this._listings_select.getElement('option[selected]') || this._listings_select.getElement('option');
			this.listings_type = _selected.get('value');
		}

		this._listings_select.addEvent('change', function () {
			self.update_section_title();

			self.listings_type = self._listings_select.getElement(':selected').get('value');
			self.get_data();
		});

		self.update_section_title();
	},

	add_beds_select: function add_beds_select() {
		var self = this;

		//this._bed_select = this._element.getElement('.w_multiselect._beds select');

		this.beds_multiselect = new Multiselect(this._element.getElement('.w_multiselect._beds'), {
			text_input: false,
			close_button: false,
			equality: true,
			add_tiles: false,
			onClick: function onClick(e, _el) {

				Cookie.write('salesDataBedsClicked', true);

				if (!_el.hasClass('_active')) return;

				_el.toggleClass('_hover');
				self.filter_bedrooms(_el.getAttribute('data-id'));

				if (self._list.instance) {
					self._list.instance.update();
				}

				self.first_load = false;
			}
		});

		this.beds_multiselect.update_monitor();
	},

	update_section_title: function update_section_title() {
		var _section_title = this._element.getElement('.header h2 span');

		if (_section_title) {
			var _selected_period = this._period_select.getElement('option:selected') || this._period_select.getParent().getElement('.selected');
			_section_title.set('text', _selected_period.get('text').capitalize());
		}
	},

	get_data: function get_data() {
		var self = this;
		this._veil.show();

		if (this.remote) {
			this.remote.cancel();
		}

		if (this.options.data) {
			this.data = this.get_data();
			this.proceed_rpc();

			return;
		}

		var rpc = this.rpc + '&start_date=' + this.start_date + '&currency=' + this.currency + (this.options.shorten_pricerange ? '&price_format=short' : '');

		this.remote = new Remote({
			rpc: rpc,
			onSuccess: function onSuccess() {
				self.data = this.get_data();

				self.proceed_rpc();
			},
			onError: this.display_error_message.bind(this)
		});
	},

	proceed_rpc: function proceed_rpc() {
		var id = this._currency_select.getElement(':selected').get('value').toLowerCase();

		this._element.currency = {
			'id': id,
			'symbol': this.data.currency_symbol
		};

		if (this.data.list.length < 1) {
			this.display_error_message();
			return;
		}

		//to count all sales in data
		// var count = 0;

		// Object.each(this.data.list, function(el){
		// 	Object.each(el, function(e){
		// 			count += e.length;
		// 	});
		// });

		// console.log(count);

		this.set_beds();
		this.set_price_range();
		//this.set_year_range();

		if (this._controllers) this._controllers.addClass('_ready');

		this.create_chart();

		if (this._list.instance) {
			var data = this.data.list[this._element.selected_graph_id] || [];

			this._list.instance.update(data);
		}
	},

	// set_year_range: function(){
	// 	this._year_range = this._year_range || this._element.getElement('#year_slider');

	// 	if(!this._year_range) return;

	// 	this.data.year_select = {
	// 		'keys': [2000,2001,2002,2003,2004,2005,2006,2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015],
	// 		'values': ['2000','2001','2002','2003','2004','2005','2006','2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015']
	// 	}

	// 	var self = this;
	// 	var values = this.data.year_select.values;

	// 	Object.each(values, function(el, i){
	// 		values[i] = Core.get_html_text(el);
	// 	});

	// 	// values[values.length - 1] += '+';

	// 	// var title = (this._element.type == 'onmarket'? 'Listing Prices: ' : 'Closing Prices: ');
	// 	var title = 'Year: ';

	// 	this._year_range.empty();
	// 	this._year_range.getParent().getElements('input').dispose();

	// 	this.year_range = new Rangeslider(this._year_range, {
	// 		title: title,
	// 		config: this.data.year_select,
	// 		min: this.cookies.year_range? this.cookies.year_range[0] : null,
	// 		max: this.cookies.year_range? this.cookies.year_range[1] : null,
	// 		onComplete: function(min, max){
	// 			console.log('test');
	// 			self.get_min_and_max_year();


	// 			//self.create_chart();

	// 			// if(self._list.update){
	// 			// 	self._list.update();
	// 			// }
	// 			// if(self._list.instance){
	// 			// 	self._list.instance.update();
	// 			// }
	// 		}
	// 	});

	// 	this.get_min_and_max_year();
	// 	this.cookies.year_range = [];
	// },

	set_price_range: function set_price_range() {
		this._price_range = this._price_range || this._element.getElement('.w_rangeslider');

		if (!this._price_range) return;

		var self = this;
		var values = this.data.price_select.values;

		Object.each(values, function (el, i) {
			values[i] = Core.get_html_text(el);
		});

		values[values.length - 1] += '+';

		// var title = (this._element.type == 'onmarket'? 'Listing Prices: ' : 'Closing Prices: ');
		var title = 'Price: ';

		if (this.new_currency) {
			this._price_range.empty();
			this._price_range.getParent().getElements('input').dispose();

			this.price_range = new Rangeslider(this._price_range, {
				title: title,
				config: this.data.price_select,
				min: this.cookies.price_range ? this.cookies.price_range[0] : null,
				max: this.cookies.price_range ? this.cookies.price_range[1] : null,
				onComplete: function onComplete(min, max) {
					self.get_min_and_max_price();
					self.create_chart();

					// if(self._list.update){
					// 	self._list.update();
					// }
					if (self._list.instance) {
						self._list.instance.update();
					}
				}
			});

			this.new_currency = false;
		} else {
			var _rs_title = this.price_range._element.getElement('.w_rangeslider_title');

			if (_rs_title) {
				_rs_title.set('html', title);
			}
		}

		this.get_min_and_max_price();
		this.cookies.price_range = [];
	},

	display_error_message: function display_error_message() {
		this._chart.hide();
		this._veil.hide();

		this._msg = this._msg || this._element.getElement('.error');

		this._msg.show();
	},

	set_beds: function set_beds() {
		var self = this;

		this.active_beds = {
			10: false,
			11: false,
			12: false,
			13: false,
			14: false
		};

		if (this.cookies.beds) {
			Object.each(this.cookies.beds, function (el, i) {
				if (el) {
					self._beds_filter.getElement('li.beds_' + i).addClass('_selected');
				} else {
					self._beds_filter.getElement('li.beds_' + i).removeClass('_selected');
				}
			});

			this.cookies.beds = null;
			this.first_load = false;
			this.beds_multiselect.update_monitor();
		} else if (!this.beds_filter_applied && !this.first_load) {
			this._beds_filter.getElements('li').addClass('_selected');
		}

		this.beds_filter_applied = true;

		Object.each(this.data.list, function (el) {
			Object.each(el, function (e, i) {
				self.active_beds[i] = self.active_beds[i] || e && e.length > 0;
			});
		});

		Object.each(this.active_beds, function (el, i) {
			var _bed = self._beds_filter.getElement('li.beds_' + i);
			if (!_bed) return;

			if (el) {
				_bed.addClass('_active');
			} else {
				_bed.removeClass('_active');
			}
		});
	},

	create_chart: function create_chart() {
		var self = this;

		var options = {
			data: this.data,
			currency_id: this._currency_select.getElement(':selected').get('value'),
			style: this._element.hasClass('_light') ? 'light' : 'dark',
			colors: this.options.colors,
			min: this.min_price,
			max: this.max_price,

			onReady: function onReady() {
				self.cookies.region = JSONMOO.decode(Cookie.read('salesDataRegion'), false);
				if (self.cookies.region) {
					this.charts.some(function (el) {
						if (el.chart.id == self.cookies.region) {
							el._lvt.fireEvent('click');
							return true;
						}
					});
				}

				self._veil.hide();
				self.is_loaded = true;
			},

			onSelectRegion: function onSelectRegion(id) {
				self.create_list(id);
			}
		};

		this.display = new SalesData.Display(this._data_display, options);

		if (!this.first_load) {
			this._beds_filter.getElements('li').each(function (_el) {
				if (!_el.hasClass('_selected')) {
					self.filter_bedrooms(_el.getAttribute('data-id'));
				}
			});
		}
	},

	filter_bedrooms: function filter_bedrooms(id) {
		var self = this;

		if (this.display) {
			this.display.charts.each(function (el) {
				el.chart.series.each(function (e) {
					if (self.first_load) {
						if (e.name == id) {
							e.show();
							self.active_beds[id] = true;
						} else {
							e.hide();
							self.active_beds[e.name] = false;
						}
					} else {
						if (e.name != id) return;

						if (e.visible) {
							e.hide();
							self.active_beds[id] = false;
						} else {
							e.show();
							self.active_beds[id] = true;
						}
					}
				});
			});
		}

		this.get_min_and_max_price();

		if (this.display) {
			this.display.charts.each(function (el) {
				el.chart.yAxis[0].setExtremes(self.min_price, self.max_price);
			});

			this.display.set_info();
		}
	},

	get_min_and_max_price: function get_min_and_max_price() {
		var self = this;
		var min = 1; //since we use logarithmic chart, we can't use 0
		var max = 1;

		Object.each(this.data.list, function (el) {
			Object.each(el, function (e) {
				e.each(function (listing) {
					var id = listing.bedroom_id > 14 ? 14 : listing.bedroom_id;

					if (self.active_beds[id] && listing.y <= self.price_range.get_max() && listing.y >= self.price_range.get_min()) {
						min = min == 1 || listing.y < min ? listing.y : min;
						max = max == 1 || listing.y > max ? listing.y : max;
					}
				});
			});
		});

		this.min_price = Math.max(min, this.price_range.get_min());
		this.max_price = Math.min(max, this.price_range.get_max());
	},

	// get_min_and_max_year: function(){
	// 	var self = this;
	// 	var min = 1; //since we use logarithmic chart, we can't use 0
	// 	var max = 1;

	// 	Object.each(this.data.list, function(el){
	// 		Object.each(el, function(e){
	// 			e.each(function(listing){
	// 				var id = (listing.bedroom_id > 14? 14 : listing.bedroom_id);
	// 				var date = new Date(listing.sale_date);
	// 				var year = date.getFullYear();

	// 				if(self.active_beds[id] && year <= self.year_range.get_max() && year >= self.year_range.get_min()){
	// 					min = ((min == 1 || year < min)? year : min);
	// 					max = ((max == 1 || year > max)? year : max);
	// 				}
	// 			});
	// 		});
	// 	});

	// 	this.min_year = Math.max(min, this.year_range.get_min());
	// 	this.max_year = Math.min(max, this.year_range.get_max());
	// },

	read_cookies: function read_cookies() {
		this.cookies = {
			type: Cookie.read('salesDataType'),
			currency: Cookie.read('salesDataCurrency'),
			period: Cookie.read('salesDataPeriod'),
			beds: JSONMOO.decode(Cookie.read('salesDataBeds'), false),
			price_range: JSONMOO.decode(Cookie.read('salesDataPriceRange'), false),
			region: JSONMOO.decode(Cookie.read('salesDataRegion'), false)
		};
	},

	write_cookies: function write_cookies() {
		var self = this;
		var sales_data_type = this._element.type;
		var sales_data_currency = this.currency;
		var sales_data_period = this.start_date;
		var sales_data_beds = {};

		this._element.getElements('.beds_filter li').each(function (_el) {
			sales_data_beds[_el.getAttribute('data-id')] = self.active_beds[_el.getAttribute('data-id')];
		});

		var sales_data_price_range = [];

		this._element.getElements('.price_filter input').each(function (_el) {
			sales_data_price_range.push(_el.get('value'));
		});

		var sales_data_region = this._element.selected_graph_id;

		Cookie.write('salesDataType', sales_data_type);
		Cookie.write('salesDataCurrency', sales_data_currency);
		Cookie.write('salesDataPeriod', sales_data_period);
		Cookie.write('salesDataBeds', JSONMOO.encode(sales_data_beds));
		Cookie.write('salesDataPriceRange', JSONMOO.encode(sales_data_price_range));
		Cookie.write('salesDataRegion', sales_data_region);
		Cookie.write('salesDataBedsClicked', '');
	}
});

SalesData.Display = new Class({
	Implements: [Options, Events],

	options: {
		data: null
	},

	initialize: function initialize(element, options) {
		if (!element) return;

		this._element = element;
		this.setOptions(options);

		if (!this.options.data) return;

		this.data = this.options.data;

		this.build();
	},

	build: function build() {
		this.stats = new SalesData.Stats(this._element.getElement('.stats'));
		this._chart = this._element.getElement('.chart');
		this._list = this._element.getElement('.list');

		this._widget = this._element.getParent('.w_sales_data');
		this._widget.set_info = this.set_info.bind(this);

		this._chart.empty();
		this._chart.show();

		this.currency_id = this.options.currency_id;

		this.regions = this.data.regions;

		this.create_multigraph();

		this.set_info();

		this.adjust_titles();

		this.fireEvent('ready');
	},

	get_number_of_regions: function get_number_of_regions() {
		var number_of_graphs = 0;

		Object.each(this.data.list, function (el) {
			var data_length = 0;

			Object.each(el, function (e) {
				data_length += e.length;
			});

			if (data_length > 0) {
				number_of_graphs++;
			}
		});

		return number_of_graphs;
	},

	create_multigraph: function create_multigraph() {
		var self = this;
		var pl = this._chart.getStyle('padding-left').toInt() || 0;
		var pr = this._chart.getStyle('padding-right').toInt() || 0;
		var cont_width = this._chart.getSize().x - pl - pr;

		var add_width = 75;
		var deducted_value = 5; // to reduce the width of the subgraph to have spaces.
		var number_of_graphs = this.get_number_of_regions();

		var width = Math.round((cont_width - add_width) / number_of_graphs, 0);

		add_width = cont_width - width * number_of_graphs;

		var ordered_regions = [{
			id: 2,
			name: this.regions[2]
		}, {
			id: 1,
			name: this.regions[1]
		}, {
			id: 11,
			name: this.regions[11]
		}, {
			id: 3,
			name: this.regions[3]
		}, {
			id: 13,
			name: this.regions[13]
		}, {
			id: 4,
			name: this.regions[4]
		}];

		var wide_graph = true;
		this.charts = [];

		ordered_regions.each(function (el) {
			if (!self.data.list[el.id] || Object.keys(self.data.list[el.id]).length < 1) return;

			var cls = '.subgraph' + (wide_graph ? '._first' : '');

			var _subgraph = new Element(cls);
			_subgraph.inject(self._chart);
			_subgraph.setStyle('width', (wide_graph ? width + add_width : width) - deducted_value);

			_subgraph.is_wide = wide_graph;
			_subgraph.region_id = el.id;

			el._graph = _subgraph;

			var margin_left = wide_graph ? add_width : 0;

			new Element('.subgraph_tick').inject(_subgraph).setStyles({ 'margin-left': margin_left });

			var _title = new Element('.subgraph_title', { 'html': el.name + '<span class="tail">&nbsp;</span>' });

			_title.inject(_subgraph).setStyles({ 'margin-left': margin_left });

			self.stats._element.setStyle('margin-left', add_width);

			wide_graph = false;
		});

		var i = 0;

		//yes, yes, looping 2 times .... because of ie8
		ordered_regions.each(function (el) {
			if (!self.data.list[el.id] || Object.keys(self.data.list[el.id]).length < 1) return;

			var chart_options = {
				data: self.data.list[el.id],
				y_axis_labels_width: i == 0 ? add_width : 0,
				backgroundColor: self._element.getStyle('backgroundColor'),
				colors: self.options.colors,
				currency_symbol: self.data.currency_symbol,
				currency_id: self.options.currency_id,
				x: self.data.x,
				y: self.data.y,
				max: self.options.max,
				min: self.options.min,
				stats: self.stats,
				style: self.options.style,
				name: el.name,
				id: el.id
			};

			var chart = new SalesData.Chart(el._graph, chart_options);
			self.charts.push(chart);

			i++;
		});
	},

	adjust_titles: function adjust_titles() {
		var _titles = this._chart.getElements('.subgraph_title');
		var min_height = 0;

		_titles.each(function (_el) {
			var height = _el.getSize().y;

			if (min_height == 0 || height < min_height) {
				min_height = height;
			}
		});

		_titles.each(function (_el) {
			var padding = _el.getStyle('padding-top').toInt() - (_el.getSize().y - min_height) / 2;

			_el.setStyles({
				'padding-bottom': padding,
				'padding-top': padding
			});
		});
	},

	set_info: function set_info(chart) {
		var chart;

		if (!chart && this._widget.selected_graph_id) {
			this.charts.some(function (el) {
				if (el.chart.id == this._widget.selected_graph_id) {
					chart = el;
					return true;
				}
			}.bind(this));
		}

		this.stats.set_info(chart ? [chart] : this.charts);
	}
});

SalesData.Stats = new Class({
	initialize: function initialize(element) {
		if (!element) return;

		this._element = element;
		this._widget = this._element.getParent('.w_sales_data');
	},

	set_info: function set_info(charts) {
		var sales = 0;
		var median_sales_count = 0;
		var ppsqft = 0;
		var med_price;

		var med_prices_array = [];

		var currency_symbol = this._widget.currency.symbol;
		var currency_id = this._widget.currency.id;

		charts.each(function (el) {
			el.chart.series.each(function (e) {
				if (!e.visible) return;

				e.data.each(function (ee, i) {
					// if(ee.config[4]){
					// 	median_sales_count++;
					// 	ppsqft += (ee.config[4] || 0).toFloat();
					// }

					var config4 = ee.series.options.data[ee.index][4];

					if (config4) {
						median_sales_count++;
						ppsqft += (config4 || 0).toFloat();
					}

					sales++;
					med_prices_array.push(ee.y);
				});
			});
		});

		var info;

		if (sales == 0) {
			info = '<div class="err">There are no recent sales that match the criteria</div>';
		} else {
			med_prices_array = med_prices_array.sort(function (a, b) {
				return a - b;
			});

			if (med_prices_array.length % 2 == 0) {
				med_price = ((med_prices_array[med_prices_array.length / 2] + med_prices_array[med_prices_array.length / 2 - 1]) / 2).round(0);
			} else {
				med_price = med_prices_array[(med_prices_array.length / 2).floor()].round(0);
			}

			if (currency_id == 'xau' || currency_id == 'rub') {
				ppsqft = ppsqft == 0 ? 'N/A' : Core.add_commas((ppsqft / median_sales_count).round(currency_id == 'xau' ? 2 : 0)) + ' <span class="cs">' + currency_symbol + '</span>';
				med_price = Core.add_commas(med_price) + ' <span class="cs">' + currency_symbol + '</span>';
			} else {
				ppsqft = ppsqft == 0 ? 'N/A' : '<span class="cs">' + currency_symbol + '</span>' + Core.add_commas((ppsqft / median_sales_count).round(ppsqft / median_sales_count > 100 ? 0 : 2));
				med_price = '<span class="cs">' + currency_symbol + '</span>' + Core.add_commas(med_price);
			}

			info = '<ul class="clearfix ' + (Core.get_html_text(currency_symbol).length > 1 ? '_letters' : '') + '">' + '<li class="_first"><span class="big">' + sales + '</span>' + (this._widget.type == 'onmarket' ? '<span>Total Listings</span>' : '<span>Total Sales</span>') + '</li>' + '<li><span class="big">' + ppsqft + '</span><span>Median Price / Ft<sup>2</sup></span></li>' + '<li><span class="big">' + med_price + '</span><span>Median Price</span></li>' + '</ul>';
		}

		this._element.set('html', info);
		this.adjust_text_size();
	},

	adjust_text_size: function adjust_text_size() {
		//prices in some currencies are too long, so we have to change size of the text to fit it

		var _big_texts = this._element.getElements('.big');

		if (_big_texts.length == 0) return;

		if (_big_texts[2].get('text').length >= 14) {
			_big_texts.each(function (_el) {
				_el.addClass('_smaller');
			});
		} else {
			_big_texts.each(function (_el) {
				_el.removeClass('_smaller');
			});
		}
	}
});

SalesData.Chart = new Class({
	Implements: [Options, Events],

	options: {
		data: null
	},

	initialize: function initialize(element, options) {
		if (!element) return;

		this._element = element;
		this.setOptions(options);

		if (!this.options.data) return;

		this.data = this.options.data;

		this.build();
	},

	build: function build() {
		this._widget = this._element.getParent('.w_sales_data');

		this.create_chart();
		this.add_mouse_events();
		this.create_list_view_toggle();
	},

	create_chart: function create_chart() {
		var self = this;
		var series = this.create_series();

		var _chart_cont = this._chart_cont = new Element('.chart_cont').inject(this._element, 'top');

		var max = this.options.max;
		var min = this.options.min > 0 ? this.options.min : 1;

		this.chart = new Highcharts.Chart({
			chart: {
				renderTo: _chart_cont,
				type: 'scatter',
				plotBackgroundColor: this.options.backgroundColor,
				backgroundColor: this.options.backgroundColor,
				marginBottom: 0,
				marginLeft: this.options.y_axis_labels_width,
				marginRight: 0,
				animation: false,
				spacingTop: 20,
				events: {
					tooltipHide: function tooltipHide() {
						if (self._tooltip) {
							self._tooltip.hide();
						}
					},
					tooltipMove: function tooltipMove(e) {
						self.position_tooltip(self._element, e[0], e[1]);
					},
					click: function click() {
						if (!Core.is_touch_supported()) {
							self._lvt.fireEvent('click');
						}
					}
				}
			},

			xAxis: {
				categories: self.regions_by_name,

				labels: {
					enabled: false
				},

				min: 0.5,
				max: 5.5,

				minPadding: 0.2,
				maxPadding: 0.2,

				title: {
					text: null
				},

				tickLength: 0
			},

			yAxis: {
				type: 'logarithmic',
				min: min,
				max: max,
				gridLineColor: '#aaa',
				gridLineDashStyle: 'dash',
				showFirstLabel: false,
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: this._element.is_wide ? this.options.y.label : null,
					style: {
						color: '#999'
					},
					margin: 10
				},

				labels: {
					enabled: this._element.is_wide,
					style: {
						color: '#999'
					},
					formatter: function formatter() {
						var cs = Core.get_html_text(self.options.currency_symbol || '&#36;');
						if (cs.length > 1) cs = '';

						if (this.value < 100) {
							return cs + Highcharts.numberFormat(this.value, 2);
						} else {
							var s;

							if (this.value % 1000000000 == 0) {
								s = this.value / 1000000000 + 'G';
							} else if (this.value % 1000000 == 0) {
								s = this.value / 1000000 + 'M';
							} else if (this.value % 1000 == 0) {
								s = this.value / 1000 + 'k';
							} else {
								s = this.value;
							}

							return cs + s;
						}
					}
				}
			},

			series: series,

			tooltip: {
				useHTML: true,
				formatter: function formatter() {
					if (!this.point.series.visible) return;

					var index;
					if (this.point.dataGroup) {
						index = this.point.dataGroup.start;
					} else {
						index = this.point.index;
					}

					var content = this.point.series.options.data[index][2];

					self.display_tooltip(content, this.point.series.color);
					self.position_tooltip(self._element, this.point.plotX, this.point.plotY);

					return false;
				}
			},

			plotOptions: {
				column: {
					stacking: 'normal'
				},

				scatter: {
					marker: {
						radius: 7
					},
					events: {
						click: function click(e) {
							var stop = false;
							var index;

							// to display the tooltip on the first click
							if (Core.is_touch_supported()) {
								if (self.active_series != e.point) {
									stop = true;
								}

								self.active_series = e.point;

								if (stop) return;
							}

							if (e.point.dataGroup) {
								index = e.point.dataGroup.start;
							} else {
								index = e.point.index;
							}

							var url = e.point.series.options.data[index][3];

							if (url) {
								Cookie.write('salesDataSeriesClicked', true);

								window.location = url;
							}

							//NCR-5306 if user click the dot while on the market insight landing page.
							if ($(document.body).get('id') === 'min') {
								document.fireEvent('miSaveActiveGraph', ['salesData']);
							}

							self.seriesClicked = true;
						},
						mouseOut: function mouseOut() {
							if (self._tooltip) {
								self._tooltip.hide();
							}
						}
					}
				},

				series: {
					cursor: 'pointer'
				}
			},

			credits: {
				enabled: false
			},

			title: {
				text: null
			},

			legend: {
				enabled: false
			}
		});

		this.chart.id = this.options.id;
	},

	// get_prices_intervals: function(){ //for better distribution of dots
	// 	var prices = {};

	// 	var max = this.options.max;
	// 	var min = (this.options.min > 0? this.options.min : 1);

	// 	var range = max - min;
	// 	var step = range / 20;

	// 	while(range > 0){
	// 		prices[range] = [];
	// 		range -= step;
	// 	}

	// 	return prices;
	// },

	get_x: function get_x(number) {
		var x = number % 5 + 1;

		//todo: we need better distribution of dots on x axis

		return x;
	},

	create_series: function create_series() {
		var self = this;
		var series = [];
		// var prices = this.get_prices_intervals(); //for better distribution of dots

		Object.each(this.data, function (el, beds_id) {
			var graph_data = [];
			var url = [];

			el.each(function (e, i) {
				if (e.y > self.options.max || e.y < self.options.min) return;

				var x = self.get_x(beds_id.toInt() + i + (e.sqft || 0));

				graph_data.push([x, e.y, e.tooltip, e.url_sold || e.url, e.ppsqft]);

				url.push(e.url_sold);
			});

			series.push({
				data: graph_data,
				color: self.options.colors[beds_id],
				marker: { symbol: 'circle' },
				name: beds_id
			});
		});

		return series;
	},

	add_mouse_events: function add_mouse_events() {
		//if(Core.is_touch_supported()) return;

		var self = this;
		var _rect = this._element.getElements('svg>rect');
		var color = this.options.style == 'light' ? '#ccc' : '#777';
		var stats = self.options.stats;

		if (_rect) {
			_rect = _rect[1] || _rect[0];
		}

		this._element.addEvents({
			'touchstart': function touchstart() {
				var _tooltips = document.getElements('.chart_tooltip._sales_data');
				if (_tooltips) {
					_tooltips.each(function (_el) {
						_el.hide();
					});
				}
			},

			'mouseenter': function mouseenter() {
				if (Core.is_touch_supported()) {
					var _current_active_subgraph = document.getElement('.subgraph._hover');
					if (_current_active_subgraph) {
						_current_active_subgraph.fireEvent('mouseleave');
					}
				}

				self._element.addClass('_hover');

				if (_rect) {
					_rect.setProperty('fill', color);
					_rect.setProperty('height', _rect.getProperty('height').toInt() + 20);
					_rect.setProperty('y', 0);
				}

				stats.gen_info = stats._element.get('html');
				stats.set_info([self]);
			},

			'mouseleave': function mouseleave() {
				self._element.removeClass('_hover');

				if (_rect) {
					_rect.setProperty('fill', self.options.backgroundColor);
					_rect.setProperty('height', _rect.getProperty('height').toInt() - 20);
				}

				if (self.hidden) {
					self.hidden = false;
					return;
				}

				stats._element.set('html', stats.gen_info);
			},

			'click': function click(e) {
				self.hidden = true;

				if (e.target != self._lvt) {
					self._lvt.fireEvent('click');
				}
			}
		});
	},

	display_tooltip: function display_tooltip(tooltip, color) {
		this._tooltip = this._tooltip || new Element('.chart_tooltip._sales_data', {
			'html': '<div class="info"></div><div class="pointer">&nbsp;</div>'
		}).inject(document.body);

		tooltip += '<br/><br/>Click dot for full ' + (this._widget.type == 'onmarket' ? 'listing details' : 'sales summary');

		this._tooltip.getElement('.info').set('html', tooltip);
		this._tooltip.setStyle('borderColor', color);
		this._tooltip.getElement('.pointer').setStyle('borderTopColor', color);
		this._tooltip.show();
	},

	position_tooltip: function position_tooltip(_cont, x, y) {
		// To center the tooltip, we need to use the position of the subgraph_title because this has the same width of the graph.
		var pos_x = _cont.getElement('.subgraph_title').getPosition().x + x - this._tooltip.getSize().x / 2;
		var pos_y = _cont.getPosition().y + y - this._tooltip.getSize().y / 2 - 35; // - this._tooltip.getElement('.pointer').getSize().y - 10;

		this._tooltip.setStyles({
			'top': pos_y,
			'left': pos_x
		});
	},

	create_list_view_toggle: function create_list_view_toggle() {
		var self = this;
		var _list_view_toggle = this._lvt = new Element('.list_view_toggle', { 'html': 'Go to List View' });

		_list_view_toggle.inject(this._element, 'top');
		_list_view_toggle.setStyles({
			'margin-left': this.options.y_axis_labels_width
		});

		_list_view_toggle.addEvents({
			'click': function click() {
				if (self.seriesClicked) {
					return;
				}

				self._widget.selected_graph_id = self.chart.id;

				self.options.stats.gen_info = self.options.stats._element.get('html');
				self.options.stats.set_info([self]);
				self.show_list();
			}
		});
	},

	show_list: function show_list() {
		if (this.list) {
			this.list.show();
		} else {
			this.list = this.list || new SalesData.List(this._element.getParent().getNext('.list'), this.options);
		}
	}
});

SalesData.List = new Class({
	Implements: [Options, Events],

	options: {
		data: null
	},

	initialize: function initialize(element, options) {
		if (!element) return;

		this._element = element;
		this.setOptions(options);

		if (!this.options.data) return;

		this.data = this.options.data;

		this.build();
	},

	build: function build() {
		this._widget = this._element.getParent('.w_sales_data');
		this._chart = this._element.getPrevious('.chart');
		this.show();
	},

	set_content: function set_content() {
		var content = '<span class="region_name">' + this.options.name + '</span>';

		this._element.set('html', content);
		this.create_table();
		this.add_back_link();
	},

	create_table: function create_table() {
		var _table = this._element.getElement('.w_divtable');

		if (_table) {
			_table.dispose();
		}

		this._table = new Element('.w_divtable' + (this._widget.type == 'onmarket' ? '._onmarket' : ''));

		this._thead = new Element('.thead', {
			'html': '<div class="tr">' + '<div class="th building_name"><div class="th_content">Building / Address</div></div>' + '<div class="th size"><div class="th_content">Size</div></div>' + '<div class="th closing_price"><div class="th_content">' + (this._widget.type == 'onmarket' ? 'Price' : 'Closing Price') + '</div></div>' + '<div class="th closing_date"><div class="th_content">' + (this._widget.type == 'onmarket' ? '' : 'Closing Date') + '</div></div>' + '</div>'
		});

		this._tbody = new Element('.tbody');

		this._table.adopt([this._thead, this._tbody]);

		this._element.adopt(this._table);

		this.add_rows();
	},

	add_rows: function add_rows() {
		var self = this;
		var opts = this.options;

		this.sorted_data = this.sorted_data || (this._widget.type == 'sold' ? this.sort_by_date() : this.sort_by_price());

		var selected_bedrooms = [];

		var cookie_beds = Cookie.read('salesDataBeds');

		if (Cookie.read('salesDataBedsClicked')) {
			this._widget.getElements('.beds_filter ._active._selected').each(function (_el) {
				selected_bedrooms.push(_el.getAttribute('data-id').toInt());
			});
		} else if (cookie_beds) {
			cookie_beds = JSONMOO.decode(cookie_beds, false);

			Object.each(cookie_beds, function (el, i) {
				if (el == true) {
					selected_bedrooms.push(i.toInt());
				}
			});
		} else {
			this._widget.getElements('.beds_filter li').each(function (_el) {
				selected_bedrooms.push(_el.getAttribute('data-id').toInt());
			});
		}

		var extremes = this._widget.getElements('.price_filter input[type="hidden"]');

		var min = extremes[0] ? extremes[0].get('value') : opts.min;
		var max = extremes[1] ? extremes[1].get('value') : opts.max;

		this.sorted_data.each(function (el) {
			var id = el.bedroom_id.toInt() > 14 ? 14 : el.bedroom_id.toInt();

			if (el.y < min || el.y > max || !selected_bedrooms.contains(id)) return;

			var _tr = new Element('.tr');

			_tr.addEvents({
				'click': function click() {
					window.location = el.url_sold || el.url;

					//NCR-5306 if user click the dot while on the market insight landing page.
					if ($(document.body).get('id') === 'min') {
						document.fireEvent('miSaveActiveGraph', ['salesData']);
					}
				}
			});

			_tr.setStyle('border-left', '6px solid ' + opts.colors[id]);

			var name = (el.name || el.street_address).trim();

			var building = (name && name != '' ? '<span>' + (el.name || el.street_address) + ', </span>' : '') + '<span class="unit"> Apt ' + el.unit + '</span>' + (el.name ? '<br/>' + el.street_address : '');

			var size = '<span>' + (Number.from(el.bedroom) ? Number.from(el.bedroom) : el.bedroom) + (Number.from(el.bedroom) ? Number.from(el.bedroom) > 1 ? ' beds' : ' bed' : '') + '</span><br/>' + Number.from(el.bathroom) + (Number.from(el.bathroom) > 1 ? ' baths' : ' bath') + (el.sqft == 0 ? '' : ' | ' + el.sqft_format + ' / ft <sup>2</sup>');

			var closing_price = '<span>' + el.sale_price_format + '</span>' + (el.ppsqft == 0 ? '' : '<br/> Approx. ' + el.ppsqft_format + ' / ft <sup>2</sup>');
			var closing_date = '<span>' + (el.sale_date ? el.sale_date : '') + '</span>';

			new Element('.td.building_name', { 'html': '<div class="td_content">' + building + '</div>' }).inject(_tr);
			new Element('.td.size', { 'html': '<div class="td_content">' + size + '</div>' }).inject(_tr);
			new Element('.td.closing_price', { 'html': '<div class="td_content">' + closing_price + '</div>' }).inject(_tr);
			new Element('.td.closing_date', { 'html': '<div class="td_content">' + closing_date + '</div>' }).inject(_tr);

			_tr.inject(self._tbody);
		});

		new Divtable(this._table, {
			'zebra_order': 'odd'
		});

		// console.log(this._element.getSize().y, this._chart.getSize().y);

		if (this._element.getSize().y > this._chart.getSize().y) {
			this._thead.addClass('_table_scroll');

			new StyledScroll(this._tbody, {
				type: 'v',
				max_height: 315
			});
		}
	},

	update: function update(data) {
		if (data) {
			this.data = data;
			this.sorted_data = null;
		}

		this.create_table();
	},

	sort_by_price: function sort_by_price() {
		var sorted_list = [];

		Object.each(this.data, function (el) {
			el.each(function (e) {
				sorted_list.push(e);
			});
		});

		if (sorted_list.length > 1) {
			sorted_list = sorted_list.sort(function (a, b) {
				var price_a = a.sale_price.toInt();
				var price_b = b.sale_price.toInt();

				return price_a > price_b ? -1 : 1;
			});
		}

		return sorted_list;
	},

	sort_by_date: function sort_by_date() {
		var sorted_list = [];

		Object.each(this.data, function (el) {
			el.each(function (e) {
				sorted_list.push(e);
			});
		});

		if (sorted_list.length > 1) {
			sorted_list = sorted_list.sort(function (a, b) {
				var date_a = new Date(a.sale_date).set({ sec: 0, ms: 0 }).format("%s");
				var date_b = new Date(b.sale_date).set({ sec: 0, ms: 0 }).format("%s");

				return date_a > date_b ? -1 : 1;
			});
		}

		return sorted_list;
	},

	add_back_link: function add_back_link() {
		if (this._back_link) {
			this._back_link.inject(this._element, 'top');
			return;
		}

		var self = this;
		this._back_link = new Element('.back', { 'text': 'Back to Graph' });

		this._back_link.inject(this._element, 'top');

		this._back_link.addEvents({
			'click': function click() {
				self._widget.selected_graph_id = null;
				self.hide();
			}
		});
	},

	show: function show() {
		this.set_content();
		this._chart.hide();
		this._widget.addClass('_list_view');

		this._widget.set_info();
		this._element.instance = this;
	},

	hide: function hide() {
		this._widget.removeClass('_list_view');
		this._element.empty();
		this._chart.show();

		this._widget.set_info();
		this._element.instance = null;
		Cookie.write('salesDataRegion', null);
	}
});
"use strict";

var Table = new Class({
	Implements: Options,
	options: {},
	initialize: function initialize(_element, options) {
		this._element = document.id(_element);
		if (this._element) {
			this.setOptions(options);
			this.build();
		}
	},
	build: function build() {}
});

Table.RecentClosings = new Class({ //used as data-class in some widgets (i.e. widgets on building overview page)
	Extends: Table,
	build: function build() {
		this.parent();
		// console.log('Table.RecentClosings build');
		if (Page.Bir) {
			Page.Bir.make_table(this._element);
		}
	}
});

Table.Available = new Class({ //used as data-class in some widgets (i.e. widgets on building overview page)
	Extends: Table.RecentClosings,
	build: function build() {
		this.parent();
		// console.log('Table.Available build');
	}
});

Table.Available.ForSale = new Class({
	Extends: Table.Available,
	build: function build() {
		this.parent();

		// console.log('Table.Available.ForSale build');
	}
});
'use strict';

var Videos = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_videos'
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element || document.getElement('.' + this.options.cls);

		if (!this._element) return;

		this.build();
	},

	build: function build() {
		this._vimeo = this._element.getElement('.vimeo');

		Core.add_froogaloop();

		this.button_clicked = false;

		this._imagestrip = this._element.getElement('.w_imagestrip');

		if (!this._imagestrip) return;

		this._controllers = this._imagestrip.getParent();
		this._istrip_container = this._imagestrip.getElement('.w_imagestrip_scroller');

		this.add_categories();
	},

	add_categories: function add_categories() {
		var self = this;
		var _categories = this._controllers.getElements('.video_categories li a'),
		    _selected_category;

		_categories.each(function (_el) {
			_el.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (_el === _selected_category) return;

				self._controllers.addClass('_loading');
				self.inject_imagestrip(_el);

				if (_selected_category) {
					_selected_category.removeClass('_selected');
				}

				_el.addClass('_selected');
				_selected_category = _el;
			});
		});

		_categories[0].fireEvent('click');
	},

	inject_imagestrip: function inject_imagestrip(_el) {
		if (!this._istrip_container) return;

		var self = this;

		if (!_el.istr) {
			var rpc = _el.getAttribute('data-rpc') || _el.get('href');

			if (rpc && rpc != '') {
				new Remote({
					rpc: rpc,
					onSuccess: function onSuccess() {
						var content = this.get_data().content;

						_el.istr = self._imagestrip.clone();
						_el.istr.inject(self._imagestrip, 'after');

						self._imagestrip.dispose();

						_el.istr.getElement('.w_imagestrip_scroller').set('html', content);
						_el.istr_instace = new Imagestrip(_el.istr, {
							auto_move: false,
							amount: self._controllers.hasClass('_categorized') ? 2 : 3
						});

						self.process_photos(_el.istr);
						self._controllers.removeClass('_loading');
						self._imagestrip = _el.istr;
					}
				});
			}
		} else {
			_el.istr.inject(this._imagestrip, 'after');
			this._imagestrip.dispose();

			this._controllers.removeClass('_loading');
			this._imagestrip = _el.istr;
		}
	},

	add_report: function add_report(_active_video) {
		if (!_active_video) return;

		var _info_box = this._element.getElement('.info_box');

		if (_info_box) {
			var _title = _info_box.getElement('.title');
			var _date = _info_box.getElement('.date');
			var _description = _info_box.getElement('.description');
			var _links_cont = _info_box.getElement('.links');
			var title = _active_video.getElement('.name').get('text');
			var date = _active_video.getElement('.date').get('text');
			var description = _active_video.getElement('.description').get('text');
			var _buttons = _active_video.getElements('.market_insight_report_buttons a');

			_title.set('text', title);
			_date.set('text', date);
			_description.set('text', description);
			_links_cont.empty();

			if (_buttons.length > 0) {
				_buttons.each(function (_btn) {
					var _btn_cloned = _btn.clone();
					_btn_cloned.inject(_links_cont);
				});
			}

			_info_box.show();
		}
	},

	process_photos: function process_photos(_istr) {
		var self = this;
		var _photos = _istr.getElements('.w_imagestrip_photo');

		_photos.each(function (_el) {
			var _parent = _el.getElement('img').getParent();

			_parent.adopt(new Element('div', { 'class': 'veil' }));

			if (_el.getProperty('data-rpc')) {
				_parent.adopt(new Element('div', { 'class': 'now_playing', 'html': 'Now Playing' }));
				_parent.adopt(new Element('div', { 'class': 'play' }));
			}

			_el.addEvents({
				'click': function click(e) {
					self.user_click = !!e;

					self.handle_video_select(_el);
					self.add_report(_el);

					if (self.user_click) {
						self.handle_play();
					}
				},

				'touchstart': function touchstart() {
					this.fireEvent('click');
				},

				'mouseenter': function mouseenter() {
					this.addClass('_hover');
				},

				'mouseleave': function mouseleave() {
					this.removeClass('_hover');
				}
			});
		});

		if (!_istr.init_click) {
			_photos[0].fireEvent('click');
			_istr.init_click = true;
		}

		$(document.body).setStyle('cursor', 'default');
	},

	handle_video_select: function handle_video_select(_el) {
		if (this._current_thumbnail === _el) {
			if (_el.hasClass('_playing')) return;

			if (this.player) {
				this.player.api('play');
			}

			return;
		}

		this.is_playing = false;

		if (this._current_thumbnail) {
			this._current_thumbnail.removeClass('_current').removeClass('_playing').removeClass('_hover');
		}

		_el.addClass('_current');

		this._current_thumbnail = _el;

		var rpc = _el.getProperty('data-rpc');
		this._vimeo.set('html', '<div class="veil">&nbsp;</div>');
		this._vimeo.addClass('_loading');

		var self = this;
		if (rpc) {
			new Remote({
				rpc: rpc,

				onSuccess: function onSuccess() {
					var content = this.get_data().content + '<div class="veil">&nbsp;</div>';
					self._vimeo.set('html', content);
					self._vimeo.removeClass('_with_image');
					self._vimeo.removeClass('_loading');

					self.get_player();

					self.fireEvent('postRpc');
				}
			});
		} else {
			var _image = _el.getElement('.w_imagestrip_image img');

			if (_image) {
				var content = '<img class="article_image" src="' + _image.get('src') + '" />';

				self._vimeo.set('html', content);
				self._vimeo.addClass('_with_image');
				self._vimeo.removeClass('_loading');
			}
		}
	},

	get_player: function get_player() {
		var _iframe = this._vimeo.getElement('iframe');

		if (!_iframe) return;

		this.player = Froogaloop(_iframe);
		this.player.addEvent('ready', this.handle_ready.bind(this));
	},

	handle_ready: function handle_ready() {
		this.player.addEvent('pause', this.handle_pause.bind(this));
		this.player.addEvent('finish', this.handle_finish.bind(this));
		this.player.addEvent('playProgress', this.handle_play.bind(this));

		this._vimeo.removeClass('_loading');

		if (this.user_click) {
			this.player.api('play');
		}
	},

	handle_pause: function handle_pause() {
		this._current_thumbnail.removeClass('_playing');
		this.is_playing = false;
	},

	handle_finish: function handle_finish() {
		this.handle_pause();
	},

	handle_play: function handle_play() {
		if (this.is_playing) return;

		this._current_thumbnail.addClass('_playing');
		this.is_playing = true;
	}
});
'use strict';

var ScrollToElement = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'scroll_to',
		offset_y: 0
	},

	initialize: function initialize(_elements, options) {
		this.setOptions(options);
		this._elements = _elements || document.getElements('.' + this.options.cls);

		if (this._elements) {
			this.build();
		}
	},

	build: function build() {
		this.setScrollTo();
	},

	setScrollTo: function setScrollTo() {
		var self = this;

		var myFx = new Fx.Scroll(window, {
			offset: {
				x: 0,
				y: self.options.offset_y,
				duration: 1000
			},
			onStart: function onStart() {
				$(window).fireEvent('jumpStart');
			},
			onComplete: function onComplete() {
				$(window).fireEvent('jumpStop');
			}

		});

		this._elements.each(function (link) {
			link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.hasClass('_top')) {
					myFx.toTop();
					return;
				}

				var name = (this.get('data-href') || this.get('href') || this.href).split('#')[1];
				var elem = $$('a[name=' + name + ']');
				myFx.toElement(elem[0], 'y');
			});
		});
	}
});
'use strict';

Page.Min = new Class({
	Extends: Page,

	build: function build() {
		this.parent();

		var _bc_graph = document.getElement('#building_comparison');
		if (_bc_graph) {
			this.add_building_comparison(_bc_graph);
		}

		var _cc_graph = document.getElement('.condo_vs_coop_comparison');
		if (_cc_graph) {
			this.add_condo_vs_coop_comparison(_cc_graph);
		}

		var _nh_graph = document.getElement('.neighborhood_stats');
		if (_nh_graph) {
			this.add_neighborhood_stats(_nh_graph);
		}

		var _in_graph = document.getElement('.cityrealty_indices');
		if (_in_graph) {
			this.add_cityrealty_indices(_in_graph);
		}

		var _rs_graph = document.getElement('.recent_sales');

		if (_rs_graph) {
			this.add_recent_sales(_rs_graph);
		}

		new Module();

		// NCR-5386 To keep the current active graph if user clicks through the chart and comes back
		document.addEvent('miSaveActiveGraph', function (graph) {
			if (graph) {
				Cookie.write('crMILandingActiveGraph', graph);
			}
		});

		// To delete the cookie when the user close the building popup
		document.addEvent('miPopupClose', function () {
			Cookie.dispose('crMILandingActiveGraph');
		});
	},

	add_recent_sales: function add_recent_sales(_cont) {
		var _recent_sales = _cont;
		if (!_recent_sales) return;

		var _sale_data = _recent_sales.getElement('.w_sale_data');

		new SalesData(_sale_data, {
			shorten_pricerange: true
		});

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			var _price_filter = _recent_sales.getElement('.price_filter');

			if (_price_filter) {
				_price_filter.addClass('_no_slider');
			}
		}
	},

	add_cityrealty_indices: function add_cityrealty_indices(_cont) {
		var _cityrealty_indices = _cont;

		if (!_cityrealty_indices) return;

		var _details = _cityrealty_indices.getElement('.indices_details');
		var _periods = _details.getElements('li');

		var __randomise_graphs = function __randomise_graphs(prices) {
			var files = 16; //amount of pngs with different graphs
			var _poss = _details.getElements('._positive');
			var _negs = _details.getElements('._negative');

			if (!_poss && !_negs) return;

			var prices_abs = [];

			prices.each(function (p) {
				prices_abs.push(Math.abs(p));
			});

			var max = Math.max.apply(null, prices_abs);

			var range = Math.floor(files / (_poss.length + _negs.length));

			var taken = [];

			prices.each(function (p, i) {
				var percent = Math.abs(p) * 100 / max;

				if (p != 0) {
					var _change = _periods[i].getElement('.graph').setProperty('class', 'graph');
					var num = Math.round(files * percent / 100);

					while (taken.contains(num)) {
						var random = Math.floor(Math.random() * range);

						if (num + random < 16) {
							num += random;
						} else {
							num -= random;
						}

						num = Math.min(16, num);
						num = Math.max(1, num);
					}

					_change.addClass((p < 0 ? 'neg_' : '_') + num);

					taken.push(num);
				}
			});
		};
		var __update_details = function __update_details(_el, price_change) {
			var prices = [price_change[3] || 0, price_change[6] || 0, price_change[12] || 0, price_change[24] || 0];
			_periods.each(function (_el, i) {
				var _change = _el.getElement('.change');
				var value = prices[i] > 0 ? '+' : prices[i] < 0 ? '-' : '';

				_change.set('text', (value == '+' ? value : '') + prices[i].toFixed(1) + '%');

				var cls = value == '+' ? '_positive' : value == '-' ? '_negative' : '';

				_el.setProperty('class', '');
				_el.addClass(cls);

				var _graph = _el.getElement('.graph').setProperty('class', 'graph');

				if (prices[i] == 0) {
					var random = Math.floor(Math.random() * 4);
					var cls = '_0';

					for (var i = 0; i <= random; i++) {
						cls += 0;
					}

					_graph.addClass(cls);
				}
			});
			__randomise_graphs(prices);
		};

		var _highstock = _cityrealty_indices.getElement('#chart_container');
		_highstock.setAttribute('data-rpc', _cityrealty_indices.getAttribute('data-rpc'));

		new HighstockExt(_highstock, {
			series_name: _cityrealty_indices.getAttribute('data-text'),
			onPostRpc: function onPostRpc(data) {
				__update_details(_cityrealty_indices, data.change);
			},

			onSeriesClick: function onSeriesClick(graph) {
				document.fireEvent('miSaveActiveGraph', ['crIndices']);
			}
		});
	},

	add_neighborhood_stats: function add_neighborhood_stats(_cont) {
		var self = this;
		var _nh_stats = _cont;

		if (!_nh_stats) return;

		var _type_select = _nh_stats.getElement('.w_styled_select._type select');

		this.region_selector = new RegionSelector(_nh_stats.getElement('#region_selector'), {
			style: 'light',
			dispose_on_click: true,
			follow_url: false,
			onHoodSelect: function onHoodSelect(selected, data) {
				self.make_stat(data, _type_select);
			}
		});
	},

	make_stat: function make_stat(data, _type_select) {
		var _regions = document.getElements('.w_styled_select._regions li');
		var _region_options = document.getElements('.w_styled_select._regions option');
		var nh_id, region_Id;

		if (data) {
			nh_id = data.id;
			region_Id = data.regionId;
		}

		var nh_stats = new NhStats(document.getElement('.neighborhood_stats'), {
			type: _type_select.getElement(':selected') || _type_select.getElement(':selected').getAttribute('value'),

			onNhSet: function onNhSet(_styled_select) {
				this.current_nh_id = nh_id;
			},

			onSeriesClick: function onSeriesClick() {
				document.fireEvent('miSaveActiveGraph', ['hoodStats']);
			}
		});

		_region_options.each(function (_option, i) {
			if (_option.get('value') == region_Id) {
				_regions[i].fireEvent('click');
			}
		});

		var _summary_title = document.getElement('.w_neighborhoods ._type');

		_type_select.addEvent('change', function (_el) {
			nh_stats.type = _el.getAttribute('value');

			if (_summary_title) {
				var str = nh_stats.type == 3 ? 'Co-op Sales Summary' : 'Condo Sales Summary';
				_summary_title.set('html', str);
			}

			if (nh_stats._clicked_cat) {
				nh_stats._clicked_cat.fireEvent('click');
			}
		});
	},

	add_condo_vs_coop_comparison: function add_condo_vs_coop_comparison(_cont) {
		new MICP(_cont, {
			'onShow_in_apartment_prices': function onShow_in_apartment_prices(region_id, type_id, beds_id, pricetype_id, currency_id) {
				var _apartment_prices_option = document.getElement('.city_stats .w_graph_categories .apartment_prices');

				if (!_apartment_prices_option) return;

				var _self_MIAP = _apartment_prices_option.graph;
				var filter_changed = false;

				var _beds_options = _self_MIAP._beds_select_options;
				var _type_options = _self_MIAP._type_select_options;
				var _pricetype_options = _self_MIAP._pricetype_select_options;
				var _currency_options = _self_MIAP._currency_select_options;

				if (_self_MIAP.beds_id != beds_id) {
					_beds_options.each(function (_option, i) {
						if (_option.get('value') == beds_id) {
							_self_MIAP._beds_li_options[i].fireEvent('click');
							filter_changed = true;
						}
					});
				}

				if (_self_MIAP.type_id != type_id) {
					_type_options.each(function (_option, i) {
						if (_option.get('value') == type_id) {
							_self_MIAP._type_li_options[i].fireEvent('click');
							filter_changed = true;
						}
					});
				}

				if (_self_MIAP.pricetype_id != pricetype_id) {
					_pricetype_options.each(function (_option, i) {
						if (_option.get('value') == pricetype_id) {
							_self_MIAP._pricetype_li_options[i].fireEvent('click');
							filter_changed = true;
						}
					});
				}

				if (_self_MIAP.curr_id != currency_id) {
					_currency_options.each(function (_option, i) {
						if (_option.get('value') == currency_id) {
							_self_MIAP._currency_li_options[i].fireEvent('click');
							filter_changed = true;
						}
					});
				}

				if (!_self_MIAP.selected_region && region_id != 0 || _self_MIAP.selected_region && _self_MIAP.selected_region.toInt() != region_id) {
					filter_changed = true;
				}

				if (!filter_changed) return;

				if ((!_self_MIAP.selected_region || _self_MIAP.selected_region != '0') && region_id != 0) {
					_self_MIAP.show_by_region(region_id);
				} else {
					if (region_id == 0 && _self_MIAP._back_button) {
						_self_MIAP._back_button.fireEvent('click');
					}
				}
			},

			onSeriesClick: function onSeriesClick() {
				document.fireEvent('miSaveActiveGraph', ['crIndices']);
			}
		});
	},

	add_building_comparison: function add_building_comparison(_cont) {
		var _cont = _cont.getElement('.w_graph');

		new MIBC(_cont, {
			'onSet_cookie': function onSet_cookie() {
				var self = this;
				var my_cookie = [];
				var unselected_regions = [];

				self._beds_options.each(function (_li, i) {
					if (_li.hasClass('selected')) {
						my_cookie.push(i);
					}
				});

				self._pricetype_options.each(function (_li, i) {
					if (_li.hasClass('selected')) {
						my_cookie.push(i);
					}
				});

				self._currency_options.each(function (_li, i) {
					if (_li.hasClass('selected')) {
						my_cookie.push(i);
					}
				});

				my_cookie.push(this.type_id);

				self._regions.each(function (_li, i) {
					if (!_li.hasClass('_selected')) {
						unselected_regions.push(i);
					}
				});

				my_cookie.push(unselected_regions);

				Cookie.write('mbc_previous_filter', JSONMOO.encode(my_cookie));
			},

			'onApply_previous_filter': function onApply_previous_filter() {
				var self = this;
				var previous_filter = JSONMOO.decode(Cookie.read('mbc_previous_filter'), false);

				if (!previous_filter) return;

				self.previous_active_region = previous_filter[4];

				if (!previous_filter[0] == 0) {
					self._beds_options[previous_filter[0]].fireEvent('click');
				}

				if (!previous_filter[1] == 0) {
					self._pricetype_options[previous_filter[1]].fireEvent('click');
				}

				if (!previous_filter[2] == 0) {
					self._currency_options[previous_filter[2]].fireEvent('click');
				}

				if (previous_filter[3] != '2') {
					toggle._toggles[1].fireEvent('click');
				}
			},

			'onSet_active_regions': function onSet_active_regions() {
				var self = this;

				if (self.previous_active_region && self.previous_active_region.length != 0) {
					self.previous_active_region.each(function (el) {
						self._regions[el].fireEvent('click');
					});

					self.previous_active_region.empty();
				}
			},

			onColumnClick: function onColumnClick() {
				document.fireEvent('miSaveActiveGraph', ['pricesPerBuilding']);
			}
		});
	}
});
//# sourceMappingURL=min.js.map
